(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var Backbone;

Backbone = require('backbone');

Backbone.$ = window.$;

window.Backbone = require("backbone");



},{"backbone":55}],2:[function(require,module,exports){
require('$.slider');



},{"$.slider":5}],3:[function(require,module,exports){
(function (global){
(typeof _ !== "undefined" && _ !== null ? _ : (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null)).mixin({
  omitUndefined: function(obj) {
    var filteredObj, key, value;
    filteredObj = {};
    for (key in obj) {
      value = obj[key];
      if (value != null) {
        filteredObj[key] = value;
      }
    }
    return filteredObj;
  },
  indexBy: function(list, iterator) {
    var i, len, listItem, ref, returnedHash;
    returnedHash = {};
    ref = list || [];
    for (i = 0, len = ref.length; i < len; i++) {
      listItem = ref[i];
      returnedHash[listItem[iterator]] = listItem;
    }
    return returnedHash;
  },
  hasSubstring: function(str, subString) {
    return typeof str === "string" && str.indexOf(subString) >= 0;
  }
});


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],4:[function(require,module,exports){
var BrowseApplication, BrowsePageEvents, TrackingHelper;

require('../common/underscore_mixins');

require('../common/backbone_init');

require('../common/jquery_plugin_init');

BrowseApplication = require('../../modules/browse/frontend/application');

TrackingHelper = require('../../modules/browse/frontend/helpers/tracking');

BrowsePageEvents = require('../../modules/browse/frontend/page_events');

Groupon.BrowseTracking = new TrackingHelper();

$(document).ready(function() {
  var ref, ref1, ref2, ref3, ref4;
  $('body').removeClass('no-js');
  Groupon.browseApp = new BrowseApplication({
    isLeftBarVisible: !!((ref = Groupon.RefinementBar) != null ? ref.isLeftBarVisible : void 0),
    isOnNoDealsPage: !!Groupon.onNoDealsPage,
    goodsBrowsePageLayoutValue: Groupon.goodsBrowsePageLayoutValue,
    inNewHomepage: !!((ref1 = Groupon.enabledFeatures) != null ? ref1.inNewHomepage : void 0),
    carouselConfig: !!((ref2 = Groupon.enabledFeatures) != null ? ref2.inNewHomepage : void 0) ? Groupon.carouselConfig : void 0,
    homeWidgetPreview: !!((ref3 = Groupon.enabledFeatures) != null ? ref3.inNewHomepage : void 0) ? Groupon.homeWidgetPreview : void 0,
    showFreeShippingModal: !!Groupon.showFreeShippingModal,
    selectedCategory: (ref4 = Groupon.Categories) != null ? ref4.selectedCategory : void 0,
    isSeoEnabled: !!Groupon.isSeoEnabled,
    isVanityUrl: !!Groupon.isVanityUrl,
    inRAPI: !!Groupon.inRAPI,
    collection: Groupon.collection,
    useNewGAPIConnector: Groupon.useNewGAPIConnector
  });
  return Groupon.browseApp.startApp();
});

$(window).load(function() {
  Groupon.BrowseTracking.pageReady();
  return BrowsePageEvents.trigger('pageReady');
});



},{"../../modules/browse/frontend/application":14,"../../modules/browse/frontend/helpers/tracking":19,"../../modules/browse/frontend/page_events":22,"../common/backbone_init":1,"../common/jquery_plugin_init":2,"../common/underscore_mixins":3}],5:[function(require,module,exports){
(function (global){

; require("/var/groupon/home/adcaballero/napistrano/build/1492467975379-37952/staging-2017.04.17_22.15/goods/core/frontend/vendor_modules/jquery.widget.js");
; var __browserify_shim_require__=require;(function browserifyShim(module, define, require) {
/*! jQuery UI - v1.11.0 - 2014-06-26
* http://jqueryui.com
* Includes: core.js, widget.js, mouse.js, position.js, accordion.js, autocomplete.js, button.js, datepicker.js, dialog.js, draggable.js, droppable.js, effect.js, effect-blind.js, effect-bounce.js, effect-clip.js, effect-drop.js, effect-explode.js, effect-fade.js, effect-fold.js, effect-highlight.js, effect-puff.js, effect-pulsate.js, effect-scale.js, effect-shake.js, effect-size.js, effect-slide.js, effect-transfer.js, menu.js, progressbar.js, resizable.js, selectable.js, selectmenu.js, slider.js, sortable.js, spinner.js, tabs.js, tooltip.js
* Copyright 2014 jQuery Foundation and other contributors; Licensed MIT */

(function( factory ) {
  if ( typeof define === "function" && define.amd ) {

    // AMD. Register as an anonymous module.
    define([ "jquery" ], factory );
  } else {

    // Browser globals
    factory( jQuery );
  }
}(function( $ ) {

/*!
 * jQuery UI Widget 1.11.0
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/jQuery.widget/
 */


var widget_uuid = 0,
  widget_slice = Array.prototype.slice;

$.cleanData = (function( orig ) {
  return function( elems ) {
    for ( var i = 0, elem; (elem = elems[i]) != null; i++ ) {
      try {
        $( elem ).triggerHandler( "remove" );
      // http://bugs.jquery.com/ticket/8235
      } catch( e ) {}
    }
    orig( elems );
  };
})( $.cleanData );

$.widget2 = function( name, base, prototype ) {
  var fullName, existingConstructor, constructor, basePrototype,
    // proxiedPrototype allows the provided prototype to remain unmodified
    // so that it can be used as a mixin for multiple widgets (#8876)
    proxiedPrototype = {},
    namespace = name.split( "." )[ 0 ];

  name = name.split( "." )[ 1 ];
  fullName = namespace + "-" + name;

  if ( !prototype ) {
    prototype = base;
    base = $.Widget2;
  }

  // create selector for plugin
  $.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
    return !!$.data( elem, fullName );
  };

  $[ namespace ] = $[ namespace ] || {};
  existingConstructor = $[ namespace ][ name ];
  constructor = $[ namespace ][ name ] = function( options, element ) {
    // allow instantiation without "new" keyword
    if ( !this._createWidget ) {
      return new constructor( options, element );
    }

    // allow instantiation without initializing for simple inheritance
    // must use "new" keyword (the code above always passes args)
    if ( arguments.length ) {
      this._createWidget( options, element );
    }
  };
  // extend with the existing constructor to carry over any static properties
  $.extend( constructor, existingConstructor, {
    version: prototype.version,
    // copy the object used to create the prototype in case we need to
    // redefine the widget later
    _proto: $.extend( {}, prototype ),
    // track widgets that inherit from this widget in case this widget is
    // redefined after a widget inherits from it
    _childConstructors: []
  });

  basePrototype = new base();
  // we need to make the options hash a property directly on the new instance
  // otherwise we'll modify the options hash on the prototype that we're
  // inheriting from
  basePrototype.options = $.widget2.extend( {}, basePrototype.options );
  $.each( prototype, function( prop, value ) {
    if ( !$.isFunction( value ) ) {
      proxiedPrototype[ prop ] = value;
      return;
    }
    proxiedPrototype[ prop ] = (function() {
      var _super = function() {
          return base.prototype[ prop ].apply( this, arguments );
        },
        _superApply = function( args ) {
          return base.prototype[ prop ].apply( this, args );
        };
      return function() {
        var __super = this._super,
          __superApply = this._superApply,
          returnValue;

        this._super = _super;
        this._superApply = _superApply;

        returnValue = value.apply( this, arguments );

        this._super = __super;
        this._superApply = __superApply;

        return returnValue;
      };
    })();
  });
  constructor.prototype = $.widget2.extend( basePrototype, {
    // TODO: remove support for widgetEventPrefix
    // always use the name + a colon as the prefix, e.g., draggable:start
    // don't prefix for widgets that aren't DOM-based
    widgetEventPrefix: existingConstructor ? (basePrototype.widgetEventPrefix || name) : name
  }, proxiedPrototype, {
    constructor: constructor,
    namespace: namespace,
    widgetName: name,
    widgetFullName: fullName
  });

  // If this widget is being redefined then we need to find all widgets that
  // are inheriting from it and redefine all of them so that they inherit from
  // the new version of this widget. We're essentially trying to replace one
  // level in the prototype chain.
  if ( existingConstructor ) {
    $.each( existingConstructor._childConstructors, function( i, child ) {
      var childPrototype = child.prototype;

      // redefine the child widget using the same prototype that was
      // originally used, but inherit from the new version of the base
      $.widget2( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
    });
    // remove the list of existing child constructors from the old constructor
    // so the old child constructors can be garbage collected
    delete existingConstructor._childConstructors;
  } else {
    base._childConstructors.push( constructor );
  }

  $.widget2.bridge( name, constructor );

  return constructor;
};

$.widget2.extend = function( target ) {
  var input = widget_slice.call( arguments, 1 ),
    inputIndex = 0,
    inputLength = input.length,
    key,
    value;
  for ( ; inputIndex < inputLength; inputIndex++ ) {
    for ( key in input[ inputIndex ] ) {
      value = input[ inputIndex ][ key ];
      if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
        // Clone objects
        if ( $.isPlainObject( value ) ) {
          target[ key ] = $.isPlainObject( target[ key ] ) ?
            $.widget2.extend( {}, target[ key ], value ) :
            // Don't extend strings, arrays, etc. with objects
            $.widget2.extend( {}, value );
        // Copy everything else by reference
        } else {
          target[ key ] = value;
        }
      }
    }
  }
  return target;
};

$.widget2.bridge = function( name, object ) {
  var fullName = object.prototype.widgetFullName || name;
  $.fn[ name ] = function( options ) {
    var isMethodCall = typeof options === "string",
      args = widget_slice.call( arguments, 1 ),
      returnValue = this;

    // allow multiple hashes to be passed on init
    options = !isMethodCall && args.length ?
      $.widget2.extend.apply( null, [ options ].concat(args) ) :
      options;

    if ( isMethodCall ) {
      this.each(function() {
        var methodValue,
          instance = $.data( this, fullName );
        if ( options === "instance" ) {
          returnValue = instance;
          return false;
        }
        if ( !instance ) {
          return $.error( "cannot call methods on " + name + " prior to initialization; " +
            "attempted to call method '" + options + "'" );
        }
        if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
          return $.error( "no such method '" + options + "' for " + name + " widget instance" );
        }
        methodValue = instance[ options ].apply( instance, args );
        if ( methodValue !== instance && methodValue !== undefined ) {
          returnValue = methodValue && methodValue.jquery ?
            returnValue.pushStack( methodValue.get() ) :
            methodValue;
          return false;
        }
      });
    } else {
      this.each(function() {
        var instance = $.data( this, fullName );
        if ( instance ) {
          instance.option( options || {} );
          if ( instance._init ) {
            instance._init();
          }
        } else {
          $.data( this, fullName, new object( options, this ) );
        }
      });
    }

    return returnValue;
  };
};

$.Widget2 = function( /* options, element */ ) {};
$.Widget2._childConstructors = [];

$.Widget2.prototype = {
  widgetName: "widget",
  widgetEventPrefix: "",
  defaultElement: "<div>",
  options: {
    disabled: false,

    // callbacks
    create: null
  },
  _createWidget: function( options, element ) {
    element = $( element || this.defaultElement || this )[ 0 ];
    this.element = $( element );
    this.uuid = widget_uuid++;
    this.eventNamespace = "." + this.widgetName + this.uuid;
    this.options = $.widget2.extend( {},
      this.options,
      this._getCreateOptions(),
      options );

    this.bindings = $();
    this.hoverable = $();
    this.focusable = $();

    if ( element !== this ) {
      $.data( element, this.widgetFullName, this );
      this._on( true, this.element, {
        remove: function( event ) {
          if ( event.target === element ) {
            this.destroy();
          }
        }
      });
      this.document = $( element.style ?
        // element within the document
        element.ownerDocument :
        // element is window or document
        element.document || element );
      this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
    }

    this._create();
    this._trigger( "create", null, this._getCreateEventData() );
    this._init();
  },
  _getCreateOptions: $.noop,
  _getCreateEventData: $.noop,
  _create: $.noop,
  _init: $.noop,

  destroy: function() {
    this._destroy();
    // we can probably remove the unbind calls in 2.0
    // all event bindings should go through this._on()
    this.element
      .unbind( this.eventNamespace )
      .removeData( this.widgetFullName )
      // support: jquery <1.6.3
      // http://bugs.jquery.com/ticket/9413
      .removeData( $.camelCase( this.widgetFullName ) );
    this.widget()
      .unbind( this.eventNamespace )
      .removeAttr( "aria-disabled" )
      .removeClass(
        this.widgetFullName + "-disabled " +
        "ui-state-disabled" );

    // clean up events and states
    this.bindings.unbind( this.eventNamespace );
    this.hoverable.removeClass( "ui-state-hover" );
    this.focusable.removeClass( "ui-state-focus" );
  },
  _destroy: $.noop,

  widget: function() {
    return this.element;
  },

  option: function( key, value ) {
    var options = key,
      parts,
      curOption,
      i;

    if ( arguments.length === 0 ) {
      // don't return a reference to the internal hash
      return $.widget2.extend( {}, this.options );
    }

    if ( typeof key === "string" ) {
      // handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
      options = {};
      parts = key.split( "." );
      key = parts.shift();
      if ( parts.length ) {
        curOption = options[ key ] = $.widget2.extend( {}, this.options[ key ] );
        for ( i = 0; i < parts.length - 1; i++ ) {
          curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
          curOption = curOption[ parts[ i ] ];
        }
        key = parts.pop();
        if ( arguments.length === 1 ) {
          return curOption[ key ] === undefined ? null : curOption[ key ];
        }
        curOption[ key ] = value;
      } else {
        if ( arguments.length === 1 ) {
          return this.options[ key ] === undefined ? null : this.options[ key ];
        }
        options[ key ] = value;
      }
    }

    this._setOptions( options );

    return this;
  },
  _setOptions: function( options ) {
    var key;

    for ( key in options ) {
      this._setOption( key, options[ key ] );
    }

    return this;
  },
  _setOption: function( key, value ) {
    this.options[ key ] = value;

    if ( key === "disabled" ) {
      this.widget()
        .toggleClass( this.widgetFullName + "-disabled", !!value );

      // If the widget is becoming disabled, then nothing is interactive
      if ( value ) {
        this.hoverable.removeClass( "ui-state-hover" );
        this.focusable.removeClass( "ui-state-focus" );
      }
    }

    return this;
  },

  enable: function() {
    return this._setOptions({ disabled: false });
  },
  disable: function() {
    return this._setOptions({ disabled: true });
  },

  _on: function( suppressDisabledCheck, element, handlers ) {
    var delegateElement,
      instance = this;

    // no suppressDisabledCheck flag, shuffle arguments
    if ( typeof suppressDisabledCheck !== "boolean" ) {
      handlers = element;
      element = suppressDisabledCheck;
      suppressDisabledCheck = false;
    }

    // no element argument, shuffle and use this.element
    if ( !handlers ) {
      handlers = element;
      element = this.element;
      delegateElement = this.widget();
    } else {
      element = delegateElement = $( element );
      this.bindings = this.bindings.add( element );
    }

    $.each( handlers, function( event, handler ) {
      function handlerProxy() {
        // allow widgets to customize the disabled handling
        // - disabled as an array instead of boolean
        // - disabled class as method for disabling individual parts
        if ( !suppressDisabledCheck &&
            ( instance.options.disabled === true ||
              $( this ).hasClass( "ui-state-disabled" ) ) ) {
          return;
        }
        return ( typeof handler === "string" ? instance[ handler ] : handler )
          .apply( instance, arguments );
      }

      // copy the guid so direct unbinding works
      if ( typeof handler !== "string" ) {
        handlerProxy.guid = handler.guid =
          handler.guid || handlerProxy.guid || $.guid++;
      }

      var match = event.match( /^([\w:-]*)\s*(.*)$/ ),
        eventName = match[1] + instance.eventNamespace,
        selector = match[2];
      if ( selector ) {
        delegateElement.delegate( selector, eventName, handlerProxy );
      } else {
        element.bind( eventName, handlerProxy );
      }
    });
  },

  _off: function( element, eventName ) {
    eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) + this.eventNamespace;
    element.unbind( eventName ).undelegate( eventName );
  },

  _delay: function( handler, delay ) {
    function handlerProxy() {
      return ( typeof handler === "string" ? instance[ handler ] : handler )
        .apply( instance, arguments );
    }
    var instance = this;
    return setTimeout( handlerProxy, delay || 0 );
  },

  _hoverable: function( element ) {
    this.hoverable = this.hoverable.add( element );
    this._on( element, {
      mouseenter: function( event ) {
        $( event.currentTarget ).addClass( "ui-state-hover" );
      },
      mouseleave: function( event ) {
        $( event.currentTarget ).removeClass( "ui-state-hover" );
      }
    });
  },

  _focusable: function( element ) {
    this.focusable = this.focusable.add( element );
    this._on( element, {
      focusin: function( event ) {
        $( event.currentTarget ).addClass( "ui-state-focus" );
      },
      focusout: function( event ) {
        $( event.currentTarget ).removeClass( "ui-state-focus" );
      }
    });
  },

  _trigger: function( type, event, data ) {
    var prop, orig,
      callback = this.options[ type ];

    data = data || {};
    event = $.Event( event );
    event.type = ( type === this.widgetEventPrefix ?
      type :
      this.widgetEventPrefix + type ).toLowerCase();
    // the original event may come from any element
    // so we need to reset the target on the new event
    event.target = this.element[ 0 ];

    // copy original event properties over to the new event
    orig = event.originalEvent;
    if ( orig ) {
      for ( prop in orig ) {
        if ( !( prop in event ) ) {
          event[ prop ] = orig[ prop ];
        }
      }
    }

    this.element.trigger( event, data );
    return !( $.isFunction( callback ) &&
      callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
      event.isDefaultPrevented() );
  }
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
  $.Widget2.prototype[ "_" + method ] = function( element, options, callback ) {
    if ( typeof options === "string" ) {
      options = { effect: options };
    }
    var hasOptions,
      effectName = !options ?
        method :
        options === true || typeof options === "number" ?
          defaultEffect :
          options.effect || defaultEffect;
    options = options || {};
    if ( typeof options === "number" ) {
      options = { duration: options };
    }
    hasOptions = !$.isEmptyObject( options );
    options.complete = callback;
    if ( options.delay ) {
      element.delay( options.delay );
    }
    if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
      element[ method ]( options );
    } else if ( effectName !== method && element[ effectName ] ) {
      element[ effectName ]( options.duration, options.easing, callback );
    } else {
      element.queue(function( next ) {
        $( this )[ method ]();
        if ( callback ) {
          callback.call( element[ 0 ] );
        }
        next();
      });
    }
  };
});

var widget = $.widget2;


/*!
 * jQuery UI Mouse 1.11.0
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/mouse/
 */


var mouseHandled = false;
$( document ).mouseup( function() {
  mouseHandled = false;
});

var mouse = $.widget2("ui.mouse", {
  version: "1.11.0",
  options: {
    cancel: "input,textarea,button,select,option",
    distance: 1,
    delay: 0
  },
  _mouseInit: function() {
    var that = this;

    this.element
      .bind("mousedown." + this.widgetName, function(event) {
        return that._mouseDown(event);
      })
      .bind("click." + this.widgetName, function(event) {
        if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
          $.removeData(event.target, that.widgetName + ".preventClickEvent");
          event.stopImmediatePropagation();
          return false;
        }
      });

    this.started = false;
  },

  // TODO: make sure destroying one instance of mouse doesn't mess with
  // other instances of mouse
  _mouseDestroy: function() {
    this.element.unbind("." + this.widgetName);
    if ( this._mouseMoveDelegate ) {
      this.document
        .unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
        .unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
    }
  },

  _mouseDown: function(event) {
    // don't let more than one widget handle mouseStart
    if ( mouseHandled ) {
      return;
    }

    // we may have missed mouseup (out of window)
    (this._mouseStarted && this._mouseUp(event));

    this._mouseDownEvent = event;

    var that = this,
      btnIsLeft = (event.which === 1),
      // event.target.nodeName works around a bug in IE 8 with
      // disabled inputs (#7620)
      elIsCancel = (typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
    if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
      return true;
    }

    this.mouseDelayMet = !this.options.delay;
    if (!this.mouseDelayMet) {
      this._mouseDelayTimer = setTimeout(function() {
        that.mouseDelayMet = true;
      }, this.options.delay);
    }

    if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
      this._mouseStarted = (this._mouseStart(event) !== false);
      if (!this._mouseStarted) {
        event.preventDefault();
        return true;
      }
    }

    // Click event may never have fired (Gecko & Opera)
    if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) {
      $.removeData(event.target, this.widgetName + ".preventClickEvent");
    }

    // these delegates are required to keep context
    this._mouseMoveDelegate = function(event) {
      return that._mouseMove(event);
    };
    this._mouseUpDelegate = function(event) {
      return that._mouseUp(event);
    };

    this.document
      .bind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
      .bind( "mouseup." + this.widgetName, this._mouseUpDelegate );

    event.preventDefault();

    mouseHandled = true;
    return true;
  },

  _mouseMove: function(event) {
    // IE mouseup check - mouseup happened when mouse was out of window
    if ($.ui.ie && ( !document.documentMode || document.documentMode < 9 ) && !event.button) {
      return this._mouseUp(event);

    // Iframe mouseup check - mouseup occurred in another document
    } else if ( !event.which ) {
      return this._mouseUp( event );
    }

    if (this._mouseStarted) {
      this._mouseDrag(event);
      return event.preventDefault();
    }

    if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
      this._mouseStarted =
        (this._mouseStart(this._mouseDownEvent, event) !== false);
      (this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
    }

    return !this._mouseStarted;
  },

  _mouseUp: function(event) {
    this.document
      .unbind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
      .unbind( "mouseup." + this.widgetName, this._mouseUpDelegate );

    if (this._mouseStarted) {
      this._mouseStarted = false;

      if (event.target === this._mouseDownEvent.target) {
        $.data(event.target, this.widgetName + ".preventClickEvent", true);
      }

      this._mouseStop(event);
    }

    mouseHandled = false;
    return false;
  },

  _mouseDistanceMet: function(event) {
    return (Math.max(
        Math.abs(this._mouseDownEvent.pageX - event.pageX),
        Math.abs(this._mouseDownEvent.pageY - event.pageY)
      ) >= this.options.distance
    );
  },

  _mouseDelayMet: function(/* event */) {
    return this.mouseDelayMet;
  },

  // These are placeholder methods, to be overriden by extending plugin
  _mouseStart: function(/* event */) {},
  _mouseDrag: function(/* event */) {},
  _mouseStop: function(/* event */) {},
  _mouseCapture: function(/* event */) { return true; }
});

/*!
 * jQuery UI Slider 1.11.0
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/slider/
 */


var slider = $.widget2( "ui.slider", $.ui.mouse, {
  version: "1.11.0",
  widgetEventPrefix: "slide",

  options: {
    animate: false,
    distance: 0,
    max: 100,
    min: 0,
    orientation: "horizontal",
    range: false,
    step: 1,
    value: 0,
    values: null,

    // callbacks
    change: null,
    slide: null,
    start: null,
    stop: null
  },

  // number of pages in a slider
  // (how many times can you page up/down to go through the whole range)
  numPages: 5,

  _create: function() {
    this._keySliding = false;
    this._mouseSliding = false;
    this._animateOff = true;
    this._handleIndex = null;
    this._detectOrientation();
    this._mouseInit();

    this.element
      .addClass( "ui-slider" +
        " ui-slider-" + this.orientation +
        " ui-widget" +
        " ui-widget-content" +
        " ui-corner-all");

    this._refresh();
    this._setOption( "disabled", this.options.disabled );

    this._animateOff = false;
  },

  _refresh: function() {
    this._createRange();
    this._createHandles();
    this._setupEvents();
    this._refreshValue();
  },

  _createHandles: function() {
    var i, handleCount,
      options = this.options,
      existingHandles = this.element.find( ".ui-slider-handle" ).addClass( "ui-state-default ui-corner-all-handle" ),
      handle = "<span class='ui-slider-handle ui-state-default ui-corner-all-handle' tabindex='0'></span>",
      handles = [];

    handleCount = ( options.values && options.values.length ) || 1;

    if ( existingHandles.length > handleCount ) {
      existingHandles.slice( handleCount ).remove();
      existingHandles = existingHandles.slice( 0, handleCount );
    }

    for ( i = existingHandles.length; i < handleCount; i++ ) {
      handles.push( handle );
    }

    this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );

    this.handle = this.handles.eq( 0 );

    this.handles.each(function( i ) {
      $( this ).data( "ui-slider-handle-index", i );
    });
  },

  _createRange: function() {
    var options = this.options,
      classes = "";

    if ( options.range ) {
      if ( options.range === true ) {
        if ( !options.values ) {
          options.values = [ this._valueMin(), this._valueMin() ];
        } else if ( options.values.length && options.values.length !== 2 ) {
          options.values = [ options.values[0], options.values[0] ];
        } else if ( $.isArray( options.values ) ) {
          options.values = options.values.slice(0);
        }
      }

      if ( !this.range || !this.range.length ) {
        this.range = $( "<div></div>" )
          .appendTo( this.element );

        classes = "ui-slider-range" +
        // note: this isn't the most fittingly semantic framework class for this element,
        // but worked best visually with a variety of themes
        " ui-widget-header ui-corner-all";
      } else {
        this.range.removeClass( "ui-slider-range-min ui-slider-range-max" )
          // Handle range switching from true to min/max
          .css({
            "left": "",
            "bottom": ""
          });
      }

      this.range.addClass( classes +
        ( ( options.range === "min" || options.range === "max" ) ? " ui-slider-range-" + options.range : "" ) );
    } else {
      if ( this.range ) {
        this.range.remove();
      }
      this.range = null;
    }
  },

  _setupEvents: function() {
    this._off( this.handles );
    this._on( this.handles, this._handleEvents );
    this._hoverable( this.handles );
    this._focusable( this.handles );
  },

  _destroy: function() {
    this.handles.remove();
    if ( this.range ) {
      this.range.remove();
    }

    this.element
      .removeClass( "ui-slider" +
        " ui-slider-horizontal" +
        " ui-slider-vertical" +
        " ui-widget" +
        " ui-widget-content" +
        " ui-corner-all" );

    this._mouseDestroy();
  },

  _mouseCapture: function( event ) {
    var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
      that = this,
      o = this.options;

    if ( o.disabled ) {
      return false;
    }

    this.elementSize = {
      width: this.element.outerWidth(),
      height: this.element.outerHeight()
    };
    this.elementOffset = this.element.offset();

    position = { x: event.pageX, y: event.pageY };
    normValue = this._normValueFromMouse( position );
    distance = this._valueMax() - this._valueMin() + 1;
    this.handles.each(function( i ) {
      var realDistance, absDistance;
      realDistance = normValue - that.values(i);
      absDistance = Math.abs(realDistance);
      if (!$(event.target).is(closestHandle) &&
        ( distance > absDistance ||
          ( distance === absDistance &&
            ( i === that._lastChangedValue || this === event.target || that.values(i) === o.min || realDistance >= 0 )))) {
        distance = absDistance;
        closestHandle = $( this );
        index = i;
      }
    });

    allowed = this._start( event, index );
    if ( allowed === false ) {
      return false;
    }
    this._mouseSliding = true;

    this._handleIndex = index;

    closestHandle
      .addClass( "ui-state-active" )
      .focus();

    offset = closestHandle.offset();
    mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
    this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
      left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
      top: event.pageY - offset.top -
        ( closestHandle.height() / 2 ) -
        ( parseInt( closestHandle.css("borderTopWidth"), 10 ) || 0 ) -
        ( parseInt( closestHandle.css("borderBottomWidth"), 10 ) || 0) +
        ( parseInt( closestHandle.css("marginTop"), 10 ) || 0)
    };

    if ( !this.handles.hasClass( "ui-state-hover" ) ) {
      this._slide( event, index, normValue );
    }
    this._animateOff = true;
    return true;
  },

  _mouseStart: function() {
    return true;
  },

  _mouseDrag: function( event ) {
    var position = { x: event.pageX, y: event.pageY },
      normValue = this._normValueFromMouse( position );

    this._slide( event, this._handleIndex, normValue );

    return false;
  },

  _mouseStop: function( event ) {
    this.handles.removeClass( "ui-state-active" );
    this._mouseSliding = false;

    this._stop( event, this._handleIndex );
    this._change( event, this._handleIndex );

    this._handleIndex = null;
    this._clickOffset = null;
    this._animateOff = false;

    return false;
  },

  _detectOrientation: function() {
    this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
  },

  _normValueFromMouse: function( position ) {
    var pixelTotal,
      pixelMouse,
      percentMouse,
      valueTotal,
      valueMouse;

    if ( this.orientation === "horizontal" ) {
      pixelTotal = this.elementSize.width;
      pixelMouse = position.x - this.elementOffset.left - ( this._clickOffset ? this._clickOffset.left : 0 );
    } else {
      pixelTotal = this.elementSize.height;
      pixelMouse = position.y - this.elementOffset.top - ( this._clickOffset ? this._clickOffset.top : 0 );
    }

    percentMouse = ( pixelMouse / pixelTotal );
    if ( percentMouse > 1 ) {
      percentMouse = 1;
    }
    if ( percentMouse < 0 ) {
      percentMouse = 0;
    }
    if ( this.orientation === "vertical" ) {
      percentMouse = 1 - percentMouse;
    }

    valueTotal = this._valueMax() - this._valueMin();
    valueMouse = this._valueMin() + percentMouse * valueTotal;

    return this._trimAlignValue( valueMouse );
  },

  _start: function( event, index ) {
    var uiHash = {
      handle: this.handles[ index ],
      value: this.value()
    };
    if ( this.options.values && this.options.values.length ) {
      uiHash.value = this.values( index );
      uiHash.values = this.values();
    }
    return this._trigger( "start", event, uiHash );
  },

  _slide: function( event, index, newVal ) {
    var otherVal,
      newValues,
      allowed;

    if ( this.options.values && this.options.values.length ) {
      otherVal = this.values( index ? 0 : 1 );

      if ( ( this.options.values.length === 2 && this.options.range === true ) &&
          ( ( index === 0 && newVal > otherVal) || ( index === 1 && newVal < otherVal ) )
        ) {
        newVal = otherVal;
      }

      if ( newVal !== this.values( index ) ) {
        newValues = this.values();
        newValues[ index ] = newVal;

          if (event.type == "mousedown") {
                this.values( index, newVal );
            }

        // A slide can be canceled by returning false from the slide callback
        allowed = this._trigger( "slide", event, {
          handle: this.handles[ index ],
          value: newVal,
          values: newValues
        } );
        otherVal = this.values( index ? 0 : 1 );
        if ( allowed !== false ) {
          this.values( index, newVal );
        }
      }
    } else {
      if ( newVal !== this.value() ) {
        // A slide can be canceled by returning false from the slide callback
        allowed = this._trigger( "slide", event, {
          handle: this.handles[ index ],
          value: newVal
        } );
        if ( allowed !== false ) {
              this.value( newVal );
        }
      }
    }
  },

  _stop: function( event, index ) {
    var uiHash = {
      handle: this.handles[ index ],
      value: this.value()
    };
    if ( this.options.values && this.options.values.length ) {
      uiHash.value = this.values( index );
      uiHash.values = this.values();
    }

    this._trigger( "stop", event, uiHash );
  },

  _change: function( event, index ) {
    if ( !this._keySliding && !this._mouseSliding ) {
      var uiHash = {
        handle: this.handles[ index ],
        value: this.value()
      };
      if ( this.options.values && this.options.values.length ) {
        uiHash.value = this.values( index );
        uiHash.values = this.values();
      }

      //store the last changed value index for reference when handles overlap
      this._lastChangedValue = index;

      this._trigger( "change", event, uiHash );
    }
  },

  value: function( newValue ) {
    if ( arguments.length ) {
      this.options.value = this._trimAlignValue( newValue );
      this._refreshValue();
      this._change( null, 0 );
      return;
    }

    return this._value();
  },

  values: function( index, newValue ) {
    var vals,
      newValues,
      i;

    if ( arguments.length > 1 ) {
      this.options.values[ index ] = this._trimAlignValue( newValue );
      this._refreshValue();
      this._change( null, index );
      return;
    }

    if ( arguments.length ) {
      if ( $.isArray( arguments[ 0 ] ) ) {
        vals = this.options.values;
        newValues = arguments[ 0 ];
        for ( i = 0; i < vals.length; i += 1 ) {
          vals[ i ] = this._trimAlignValue( newValues[ i ] );
          this._change( null, i );
        }
        this._refreshValue();
      } else {
        if ( this.options.values && this.options.values.length ) {
          return this._values( index );
        } else {
          return this.value();
        }
      }
    } else {
      return this._values();
    }
  },

  _setOption: function( key, value ) {
    var i,
      valsLength = 0;

    if ( key === "range" && this.options.range === true ) {
      if ( value === "min" ) {
        this.options.value = this._values( 0 );
        this.options.values = null;
      } else if ( value === "max" ) {
        this.options.value = this._values( this.options.values.length - 1 );
        this.options.values = null;
      }
    }

    if ( $.isArray( this.options.values ) ) {
      valsLength = this.options.values.length;
    }

    if ( key === "disabled" ) {
      this.element.toggleClass( "ui-state-disabled", !!value );
    }

    this._super( key, value );

    switch ( key ) {
      case "orientation":
        this._detectOrientation();
        this.element
          .removeClass( "ui-slider-horizontal ui-slider-vertical" )
          .addClass( "ui-slider-" + this.orientation );
        this._refreshValue();
        break;
      case "value":
        this._animateOff = true;
        this._refreshValue();
        this._change( null, 0 );
        this._animateOff = false;
        break;
      case "values":
        this._animateOff = true;
        this._refreshValue();
        for ( i = 0; i < valsLength; i += 1 ) {
          this._change( null, i );
        }
        this._animateOff = false;
        break;
      case "min":
      case "max":
        this._animateOff = true;
        this._refreshValue();
        this._animateOff = false;
        break;
      case "range":
        this._animateOff = true;
        this._refresh();
        this._animateOff = false;
        break;
    }
  },

  //internal value getter
  // _value() returns value trimmed by min and max, aligned by step
  _value: function() {
    var val = this.options.value;
    val = this._trimAlignValue( val );

    return val;
  },

  //internal values getter
  // _values() returns array of values trimmed by min and max, aligned by step
  // _values( index ) returns single value trimmed by min and max, aligned by step
  _values: function( index ) {
    var val,
      vals,
      i;

    if ( arguments.length ) {
      val = this.options.values[ index ];
      val = this._trimAlignValue( val );

      return val;
    } else if ( this.options.values && this.options.values.length ) {
      // .slice() creates a copy of the array
      // this copy gets trimmed by min and max and then returned
      vals = this.options.values.slice();
      for ( i = 0; i < vals.length; i+= 1) {
        vals[ i ] = this._trimAlignValue( vals[ i ] );
      }

      return vals;
    } else {
      return [];
    }
  },

  // returns the step-aligned value that val is closest to, between (inclusive) min and max
  _trimAlignValue: function( val ) {
    if ( val <= this._valueMin() ) {
      return this._valueMin();
    }
    if ( val >= this._valueMax() ) {
      return this._valueMax();
    }
    var step = ( this.options.step > 0 ) ? this.options.step : 1,
      valModStep = (val - this._valueMin()) % step,
      alignValue = val - valModStep;

    if ( Math.abs(valModStep) * 2 >= step ) {
      alignValue += ( valModStep > 0 ) ? step : ( -step );
    }

    // Since JavaScript has problems with large floats, round
    // the final value to 5 digits after the decimal point (see #4124)
    return parseFloat( alignValue.toFixed(5) );
  },

  _valueMin: function() {
    return this.options.min;
  },

  _valueMax: function() {
    return this.options.max;
  },

  _refreshValue: function() {
    var lastValPercent, valPercent, value, valueMin, valueMax,
      oRange = this.options.range,
      o = this.options,
      that = this,
      animate = ( !this._animateOff ) ? o.animate : false,
      _set = {};

    if ( this.options.values && this.options.values.length ) {
      this.handles.each(function( i ) {
        valPercent = ( that.values(i) - that._valueMin() ) / ( that._valueMax() - that._valueMin() ) * 100;
        _set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
        $( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
        if ( that.options.range === true ) {
          if ( that.orientation === "horizontal" ) {
            if ( i === 0 ) {
              that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { left: valPercent + "%" }, o.animate );
            }
            if ( i === 1 ) {
              that.range[ animate ? "animate" : "css" ]( { width: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
            }
          } else {
            if ( i === 0 ) {
              that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { bottom: ( valPercent ) + "%" }, o.animate );
            }
            if ( i === 1 ) {
              that.range[ animate ? "animate" : "css" ]( { height: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
            }
          }
        }
        lastValPercent = valPercent;
      });
    } else {
      value = this.value();
      valueMin = this._valueMin();
      valueMax = this._valueMax();
      valPercent = ( valueMax !== valueMin ) ?
          ( value - valueMin ) / ( valueMax - valueMin ) * 100 :
          0;
      _set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
      this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

      if ( oRange === "min" && this.orientation === "horizontal" ) {
        this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { width: valPercent + "%" }, o.animate );
      }
      if ( oRange === "max" && this.orientation === "horizontal" ) {
        this.range[ animate ? "animate" : "css" ]( { width: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
      }
      if ( oRange === "min" && this.orientation === "vertical" ) {
        this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { height: valPercent + "%" }, o.animate );
      }
      if ( oRange === "max" && this.orientation === "vertical" ) {
        this.range[ animate ? "animate" : "css" ]( { height: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
      }
    }
  },

  _handleEvents: {
    keydown: function( event ) {
      var allowed, curVal, newVal, step,
        index = $( event.target ).data( "ui-slider-handle-index" );

      switch ( event.keyCode ) {
        case $.ui.keyCode.HOME:
        case $.ui.keyCode.END:
        case $.ui.keyCode.PAGE_UP:
        case $.ui.keyCode.PAGE_DOWN:
        case $.ui.keyCode.UP:
        case $.ui.keyCode.RIGHT:
        case $.ui.keyCode.DOWN:
        case $.ui.keyCode.LEFT:
          event.preventDefault();
          if ( !this._keySliding ) {
            this._keySliding = true;
            $( event.target ).addClass( "ui-state-active" );
            allowed = this._start( event, index );
            if ( allowed === false ) {
              return;
            }
          }
          break;
      }

      step = this.options.step;
      if ( this.options.values && this.options.values.length ) {
        curVal = newVal = this.values( index );
      } else {
        curVal = newVal = this.value();
      }

      switch ( event.keyCode ) {
        case $.ui.keyCode.HOME:
          newVal = this._valueMin();
          break;
        case $.ui.keyCode.END:
          newVal = this._valueMax();
          break;
        case $.ui.keyCode.PAGE_UP:
          newVal = this._trimAlignValue(
            curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
          );
          break;
        case $.ui.keyCode.PAGE_DOWN:
          newVal = this._trimAlignValue(
            curVal - ( (this._valueMax() - this._valueMin()) / this.numPages ) );
          break;
        case $.ui.keyCode.UP:
        case $.ui.keyCode.RIGHT:
          if ( curVal === this._valueMax() ) {
            return;
          }
          newVal = this._trimAlignValue( curVal + step );
          break;
        case $.ui.keyCode.DOWN:
        case $.ui.keyCode.LEFT:
          if ( curVal === this._valueMin() ) {
            return;
          }
          newVal = this._trimAlignValue( curVal - step );
          break;
      }

      this._slide( event, index, newVal );
    },
    keyup: function( event ) {
      var index = $( event.target ).data( "ui-slider-handle-index" );

      if ( this._keySliding ) {
        this._keySliding = false;
        this._stop( event, index );
        this._change( event, index );
        $( event.target ).removeClass( "ui-state-active" );
      }
    }
  }
});

}));

}).call(global, module, undefined, undefined);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"/var/groupon/home/adcaballero/napistrano/build/1492467975379-37952/staging-2017.04.17_22.15/goods/core/frontend/vendor_modules/jquery.widget.js":6}],6:[function(require,module,exports){
/*!
 * jQuery UI Widget 1.8.13
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Widget
 */
(function( $, undefined ) {

// jQuery 1.4+
if ( $.cleanData ) {
	var _cleanData = $.cleanData;
	$.cleanData = function( elems ) {
                var tmp;
		for ( var i = 0, elem; (elem = elems[i]) != null; i++ ) {
			try {
				$( elem ).triggerHandler( "remove" );
			} catch (err) {
			}
		}
		_cleanData( elems );
	};
} else {
	var _remove = $.fn.remove;
	$.fn.remove = function( selector, keepData ) {
		return this.each(function() {
			if ( !keepData ) {
				if ( !selector || $.filter( selector, [ this ] ).length ) {
					$( "*", this ).add( [ this ] ).each(function() {
						$( this ).triggerHandler( "remove" );
					});
				}
			}
			return _remove.call( $(this), selector, keepData );
		});
	};
}

$.widget = function( name, base, prototype ) {
	var namespace = name.split( "." )[ 0 ],
		fullName;
	name = name.split( "." )[ 1 ];
	fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	// create selector for plugin
	$.expr[ ":" ][ fullName ] = function( elem ) {
		return !!$.data( elem, name );
	};

	$[ namespace ] = $[ namespace ] || {};
	$[ namespace ][ name ] = function( options, element ) {
		// allow instantiation without initializing for simple inheritance
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	var basePrototype = new base();
	// we need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
//	$.each( basePrototype, function( key, val ) {
//		if ( $.isPlainObject(val) ) {
//			basePrototype[ key ] = $.extend( {}, val );
//		}
//	});
	basePrototype.options = $.extend( true, {}, basePrototype.options );
	$[ namespace ][ name ].prototype = $.extend( true, basePrototype, {
		namespace: namespace,
		widgetName: name,
		widgetEventPrefix: $[ namespace ][ name ].prototype.widgetEventPrefix || name,
		widgetBaseClass: fullName
	}, prototype );

	$.widget.bridge( name, $[ namespace ][ name ] );
};

$.widget.bridge = function( name, object ) {
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string",
			args = Array.prototype.slice.call( arguments, 1 ),
			returnValue = this;

		// allow multiple hashes to be passed on init
		options = !isMethodCall && args.length ?
			$.extend.apply( null, [ true, options ].concat(args) ) :
			options;

		// prevent calls to internal methods
		if ( isMethodCall && options.charAt( 0 ) === "_" ) {
			return returnValue;
		}

		if ( isMethodCall ) {
			this.each(function() {
				var instance = $.data( this, name ),
					methodValue = instance && $.isFunction( instance[options] ) ?
						instance[ options ].apply( instance, args ) :
						instance;
				// TODO: add this back in 1.9 and use $.error() (see #5972)
//				if ( !instance ) {
//					throw "cannot call methods on " + name + " prior to initialization; " +
//						"attempted to call method '" + options + "'";
//				}
//				if ( !$.isFunction( instance[options] ) ) {
//					throw "no such method '" + options + "' for " + name + " widget instance";
//				}
//				var methodValue = instance[ options ].apply( instance, args );
				if ( methodValue !== instance && methodValue !== undefined ) {
					returnValue = methodValue;
					return false;
				}
			});
		} else {
			this.each(function() {
				var instance = $.data( this, name );
				if ( instance ) {
					instance.option( options || {} )._init();
				} else {
					$.data( this, name, new object( options, this ) );
				}
			});
		}

		return returnValue;
	};
};

$.Widget = function( options, element ) {
	// allow instantiation without initializing for simple inheritance
	if ( arguments.length ) {
		this._createWidget( options, element );
	}
};

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	options: {
		disabled: false
	},
	_createWidget: function( options, element ) {
		// $.widget.bridge stores the plugin instance, but we do it anyway
		// so that it's stored even before the _create function runs
		$.data( element, this.widgetName, this );
		this.element = $( element );
		this.options = $.extend( true, {},
			this.options,
			this._getCreateOptions(),
			options );

		var self = this;
		this.element.bind( "remove." + this.widgetName, function() {
			self.destroy();
		});

		this._create();
		this._trigger( "create" );
		this._init();
	},
	_getCreateOptions: function() {
		return $.metadata && $.metadata.get( this.element[0] )[ this.widgetName ];
	},
	_create: function() {},
	_init: function() {},

	destroy: function() {
		this.element
			.unbind( "." + this.widgetName )
			.removeData( this.widgetName );
		this.widget()
			.unbind( "." + this.widgetName )
			.removeAttr( "aria-disabled" )
			.removeClass(
				this.widgetBaseClass + "-disabled " +
				"ui-state-disabled" );
	},

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;

		if ( arguments.length === 0 ) {
			// don't return a reference to the internal hash
			return $.extend( {}, this.options );
		}

		if  (typeof key === "string" ) {
			if ( value === undefined ) {
				return this.options[ key ];
			}
			options = {};
			options[ key ] = value;
		}

		this._setOptions( options );

		return this;
	},
	_setOptions: function( options ) {
		var self = this;
		$.each( options, function( key, value ) {
			self._setOption( key, value );
		});

		return this;
	},
	_setOption: function( key, value ) {
		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this.widget()
				[ value ? "addClass" : "removeClass"](
					this.widgetBaseClass + "-disabled" + " " +
					"ui-state-disabled" )
				.attr( "aria-disabled", value );
		}

		return this;
	},

	enable: function() {
		return this._setOption( "disabled", false );
	},
	disable: function() {
		return this._setOption( "disabled", true );
	},

	_trigger: function( type, event, data ) {
		var callback = this.options[ type ];

		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();
		data = data || {};

		// copy original event properties over to the new event
		// this would happen if we could call $.event.fix instead of $.Event
		// but we don't have a way to force an event to be fixed multiple times
		if ( event.originalEvent ) {
			for ( var i = $.event.props.length, prop; i; ) {
				prop = $.event.props[ --i ];
				event[ prop ] = event.originalEvent[ prop ];
			}
		}

		this.element.trigger( event, data );

		return !( $.isFunction(callback) &&
			callback.call( this.element[0], event, data ) === false ||
			event.isDefaultPrevented() );
	}
};

})( jQuery );

},{}],7:[function(require,module,exports){
var BreadCrumbModel;

module.exports = BreadCrumbModel = (function() {
  function BreadCrumbModel(arg) {
    this.title = arg.title, this.friendlyName = arg.friendlyName, this.id = arg.id, this.href = arg.href, this.showSeparator = arg.showSeparator, this.showHref = arg.showHref;
    if (this.showHref == null) {
      this.showHref = true;
    }
    if (this.showSeparator == null) {
      this.showSeparator = true;
    }
  }

  BreadCrumbModel.prototype.getTitle = function() {
    var ref;
    return (ref = this.title) != null ? ref : this.friendlyName;
  };

  return BreadCrumbModel;

})();



},{}],8:[function(require,module,exports){
(function (global){
var BreadcrumbModel, BreadcrumbPresenter, Crumb, TreeTraversalHelper, contains, extend, find, getDefaultCategoryCrumb, getFacetValues, getGoodsFriendlyName, getOrderedCommonNodes, getParsedParams, getSelectedNodes, grpnParams, isArray, last, map, ref,
  slice = [].slice;

BreadcrumbModel = require('../../common/models/crumb');

TreeTraversalHelper = require('../../../shared/common/helpers/tree_traversal');

ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), isArray = ref.isArray, contains = ref.contains, extend = ref.extend, find = ref.find, last = ref.last, map = ref.map;

getOrderedCommonNodes = TreeTraversalHelper.getOrderedCommonNodes, getSelectedNodes = TreeTraversalHelper.getSelectedNodes;

grpnParams = require('grpn-params');

Crumb = BreadcrumbModel;

module.exports = BreadcrumbPresenter = (function() {
  var CATEGORY_FACET_KEY;

  CATEGORY_FACET_KEY = {
    raw: 'topcategory|category|category2|category3',
    structured: 'categories'
  };

  BreadcrumbPresenter.prototype.crumbs = [];

  function BreadcrumbPresenter(arg) {
    var page, params;
    page = arg.page, params = arg.params;
    if (!page.facets) {
      return {};
    }
    if (Groupon.inRAPI) {
      CATEGORY_FACET_KEY.raw = 'topcategory|category|subcategory|subcategory2';
    }
    this.division = Groupon.division;
    this.isSeoEnabled = params.isSeoEnabled, this.collectionType = params.collectionType;
    this.breadcrumbHash = page.breadcrumbHash, this.facets = page.facets;
    this.categories = getFacetValues(this.facets, CATEGORY_FACET_KEY);
    this.baseURL = (function() {
      switch (false) {
        case !this.collectionType:
          return Groupon.urls.collections + "/" + Groupon.collection.id;
        default:
          return Groupon.urls.browse;
      }
    }).call(this);
    this.parsedParams = getParsedParams(params, this.categories);
  }

  BreadcrumbPresenter.prototype.toHash = function() {
    return {
      breadcrumb: this._getCrumbsHash()
    };
  };

  BreadcrumbPresenter.prototype._getCrumbsHash = function() {
    var categories, crumbs, ref1, ref2;
    if (((ref1 = (crumbs = (ref2 = this.breadcrumbHash) != null ? ref2.crumbs : void 0)) != null ? ref1.length : void 0) && !this.collectionType) {
      crumbs = map(crumbs, function(crumbData) {
        return new Crumb(crumbData);
      });
      return {
        crumbs: crumbs,
        lowestCategory: last(crumbs)
      };
    }
    categories = this._getCategoryCrumbs();
    if (this.collectionType) {
      categories.shift();
    }
    return {
      crumbs: this._getGoodsCrumbs(categories),
      lowestCategory: last(categories)
    };
  };

  BreadcrumbPresenter.prototype._getGoodsCrumbs = function(categories) {
    var goodsCrumbs;
    if (this.collectionType) {
      goodsCrumbs = [this._getGoodsCrumb(Groupon.urls.browse), this._getFeaturedCollectionsCrumb(Groupon.urls.collections), this._getCollectionCrumb(categories)];
    } else {
      goodsCrumbs = [this._getGoodsCrumb(this.baseURL)];
    }
    return goodsCrumbs.concat(categories);
  };

  BreadcrumbPresenter.prototype._getGoodsCrumb = function(baseUrl) {
    return new Crumb({
      title: this.division.name,
      friendlyName: I18n.translate('js.modules.breadcrumb.presenters.goods_friendly_name'),
      href: baseUrl,
      showSeparator: false
    });
  };

  BreadcrumbPresenter.prototype._getFeaturedCollectionsCrumb = function(collectionsUrl) {
    var featuredName;
    if (this.collectionType === 'brands') {
      featuredName = I18n.translate('js.modules.breadcrumb.presenters.featured_brands_friendly_name');
    } else {
      featuredName = I18n.translate('js.modules.breadcrumb.presenters.featured_collections_friendly_name');
    }
    return new Crumb({
      friendlyName: featuredName,
      href: collectionsUrl,
      showSeparator: true
    });
  };

  BreadcrumbPresenter.prototype._getCollectionCrumb = function(categories) {
    return new Crumb({
      friendlyName: Groupon.collection.name,
      href: this.baseURL,
      showHref: categories.length,
      showSeparator: true
    });
  };

  BreadcrumbPresenter.prototype._getCategoryCrumbs = function() {
    var category, categoryCrumbs, i, len, lowestCategory, matchingCategory, orderedCategories, ref1, ref2;
    if (!this.parsedParams.category) {
      return [getDefaultCategoryCrumb()];
    }
    categoryCrumbs = [];
    if (this.parsedParams.subCategories.length) {
      ref2 = (ref1 = getOrderedCommonNodes(this.categories, this.parsedParams.subCategories)) != null ? ref1 : [], this.topCategory = ref2[0], orderedCategories = 2 <= ref2.length ? slice.call(ref2, 1) : [];
      if (!orderedCategories.length) {
        matchingCategory = find(this.categories[0].children, (function(_this) {
          return function(cat) {
            return cat.id === _this.parsedParams.category;
          };
        })(this));
        orderedCategories = matchingCategory != null ? [matchingCategory] : [];
      }
    } else {
      matchingCategory = find(this.categories[0].children, (function(_this) {
        return function(cat) {
          return cat.id === _this.parsedParams.category;
        };
      })(this));
      orderedCategories = matchingCategory != null ? [matchingCategory] : [];
    }
    if (!orderedCategories.length) {
      return [getDefaultCategoryCrumb()];
    }
    lowestCategory = (function() {
      switch (false) {
        case !this.parsedParams.selectedl6s.length:
          return this.parsedParams.selectedl6s;
        case !this.parsedParams.selectedl5s.length:
          return this.parsedParams.selectedl5s;
        case !this.parsedParams.selectedl4s.length:
          return this.parsedParams.selectedl4s;
        case !this.parsedParams.selectedl3s.length:
          return this.parsedParams.selectedl3s;
        case !this.parsedParams.selectedl2s.length:
          return this.parsedParams.selectedl2s;
      }
    }).call(this);
    for (i = 0, len = orderedCategories.length; i < len; i++) {
      category = orderedCategories[i];
      categoryCrumbs.push(new Crumb({
        id: category.id,
        friendlyName: getGoodsFriendlyName(category),
        href: this._getCategoryHref(category),
        showHref: contains(lowestCategory, category.id) ? false : void 0
      }));
    }
    return categoryCrumbs;
  };

  BreadcrumbPresenter.prototype._getCategoryHref = function(category) {
    var l2Categories, l3Categories, l4Categories, l5Categories, l6Categories;
    if (this.isSeoEnabled) {
      return this.baseURL + "/" + category.id;
    }
    l2Categories = [];
    l3Categories = [];
    l4Categories = [];
    l5Categories = [];
    l6Categories = [];
    if (contains(this.parsedParams.selectedl6s, category.id)) {
      l6Categories.push(category.id);
      l5Categories.push(category.parent.id);
      l4Categories.push(category.parent.parent.id);
      l3Categories.push(category.parent.parent.parent.id);
      l2Categories.push(category.parent.parent.parent.parent.id);
    } else if (contains(this.parsedParams.selectedl5s, category.id)) {
      l5Categories.push(category.id);
      l4Categories.push(category.parent.id);
      l3Categories.push(category.parent.parent.id);
      l2Categories.push(category.parent.parent.parent.id);
    } else if (contains(this.parsedParams.selectedl4s, category.id)) {
      l4Categories.push(category.id);
      l3Categories.push(category.parent.id);
      l2Categories.push(category.parent.parent.id);
    } else if (contains(this.parsedParams.selectedl3s, category.id)) {
      l3Categories.push(category.id);
      l2Categories.push(category.parent.id);
    } else if (contains(this.parsedParams.selectedl2s, category.id)) {
      l2Categories.push(category.id);
    }
    if (this.collectionType) {
      l2Categories = [];
    }
    return grpnParams.V1.construct({
      baseURL: this.baseURL,
      l2Categories: l2Categories,
      l3Categories: l3Categories,
      l4Categories: l4Categories,
      l5Categories: l5Categories,
      l6Categories: l6Categories,
      interests: []
    });
  };

  return BreadcrumbPresenter;

})();

getGoodsFriendlyName = function(category) {
  return category.friendlyNameShort || category.friendlyName;
};

getDefaultCategoryCrumb = function() {
  var defaultCategory, friendlyNameToUse;
  defaultCategory = Groupon.Categories.defaultCategory;
  friendlyNameToUse = getGoodsFriendlyName(defaultCategory);
  return new Crumb({
    id: defaultCategory.id,
    friendlyName: friendlyNameToUse === "Goods" ? I18n.t("js.modules.breadcrumb.presenters.all_goods_friendly_name") : friendlyNameToUse,
    showHref: false
  });
};

getParsedParams = function(params, categories) {
  var category, category2, category3, category4, category5, division, i, j, l4Categories, l4Category, len, len1, selectedl2s, selectedl3s, selectedl4, selectedl4s, selectedl5s, selectedl6s, subCategories;
  category = params.category, category2 = params.category2, category3 = params.category3, category4 = params.category4, category5 = params.category5, division = params.division;
  selectedl2s = [category];
  selectedl3s = category2 ? category2.split(',') : [];
  selectedl4s = category3 ? category3.split(',') : [];
  selectedl5s = category4 ? category4.split(',') : [];
  selectedl6s = category5 ? category5.split(',') : [];
  subCategories = [].concat(selectedl3s, selectedl4s, selectedl5s, selectedl6s);
  for (i = 0, len = selectedl4s.length; i < len; i++) {
    selectedl4 = selectedl4s[i];
    l4Categories = getSelectedNodes(categories, 'children', function(cat) {
      return contains(selectedl4s, cat.id);
    });
    for (j = 0, len1 = l4Categories.length; j < len1; j++) {
      l4Category = l4Categories[j];
      if (!contains(selectedl3s, l4Category.parent.id)) {
        selectedl3s.push(l4Category.parent.id);
      }
    }
  }
  return {
    category: category,
    division: division,
    selectedl2s: selectedl2s,
    selectedl3s: selectedl3s,
    selectedl4s: selectedl4s,
    selectedl5s: selectedl5s,
    selectedl6s: selectedl6s,
    subCategories: subCategories
  };
};

getFacetValues = function(facets, facetKey) {
  var facet;
  if (isArray(facets)) {
    facet = find(facets, function(facet) {
      return facet.id === facetKey.raw;
    });
    return facet != null ? facet.values : void 0;
  } else {
    return facets[facetKey.structured];
  }
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../../shared/common/helpers/tree_traversal":51,"../../common/models/crumb":7,"grpn-params":56}],9:[function(require,module,exports){
var Backbone, BreadcrumbIndexTemplate, BreadcrumbView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

BreadcrumbIndexTemplate = require('../../index.html.mustache');

module.exports = BreadcrumbView = (function(superClass) {
  var BREADCRUMB_SELECTOR;

  extend(BreadcrumbView, superClass);

  BREADCRUMB_SELECTOR = '#breadcrumb-container';

  BreadcrumbView.prototype.template = BreadcrumbIndexTemplate;

  function BreadcrumbView(presenter) {
    var $module, breadcrumb;
    this.presenter = presenter;
    breadcrumb = this.presenter.breadcrumb;
    if (!$(BREADCRUMB_SELECTOR).length) {
      return;
    }
    $module = $(BREADCRUMB_SELECTOR);
    this.$el = $module;
  }

  BreadcrumbView.prototype.render = function() {
    return this.$el.replaceWith(this.toHtml());
  };

  BreadcrumbView.prototype.toHtml = function() {
    return this.template.render(this.presenter);
  };

  BreadcrumbView.prototype.getSelector = function() {
    var selector;
    selector = $(BREADCRUMB_SELECTOR);
    if (selector.length) {
      return selector;
    }
  };

  return BreadcrumbView;

})(Backbone.View);



},{"../../index.html.mustache":10,"backbone":55}],10:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("breadcrumb",c,p,1),c,p,0,17,753,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div id=\"breadcrumb-container\" class=\"module-container\">");t.b("\n" + i);t.b("    <div class=\"module breadcrumb c-txt-black\" data-bhw=\"GoodsBreadcrumb\">");t.b("\n" + i);t.b("      <nav class=\"breadcrumb-nav\">");t.b("\n" + i);t.b("        <ul>");t.b("\n" + i);if(t.s(t.f("crumbs",c,p,1),c,p,0,223,692,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <li>");t.b("\n" + i);if(t.s(t.f("showSeparator",c,p,1),c,p,0,275,360,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                <span class=\"separator c-txt-gray-md\">&rsaquo;</span>");t.b("\n" + i);});c.pop();}if(t.s(t.f("showHref",c,p,1),c,p,0,410,526,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                <a class=\"crumb\" href=\"");t.b(t.v(t.f("href",c,p,0)));t.b("\" title=\"");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("\">");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("showHref",c,p,1),c,p,1,0,0,"")){t.b("                <span class=\"crumb\">");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("</span>");t.b("\n" + i);};t.b("            </li>");t.b("\n" + i);});c.pop();}t.b("        </ul>");t.b("\n" + i);t.b("      </nav>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# breadcrumb }}\n  <div id=\"breadcrumb-container\" class=\"module-container\">\n    <div class=\"module breadcrumb c-txt-black\" data-bhw=\"GoodsBreadcrumb\">\n      <nav class=\"breadcrumb-nav\">\n        <ul>\n          {{# crumbs }}\n            <li>\n              {{# showSeparator }}\n                <span class=\"separator c-txt-gray-md\">&rsaquo;</span>\n              {{/ showSeparator }}\n              {{# showHref }}\n                <a class=\"crumb\" href=\"{{ href }}\" title=\"{{ friendlyName }}\">{{ friendlyName }}</a>\n              {{/ showHref }}\n              {{^ showHref }}\n                <span class=\"crumb\">{{ friendlyName }}</span>\n              {{/ showHref }}\n            </li>\n          {{/ crumbs }}\n        </ul>\n      </nav>\n    </div>\n  </div>\n{{/ breadcrumb }}\n", Hogan);
},{"hogan.js":119}],11:[function(require,module,exports){
(function (global){
var CURRENT_PAGE_NUMBER_WITH_BOX, DEFAULT_MAX_EXPANDED_PAGINATION_SLOTS_PER_PAGE, DEFAULT_MAX_PAGINATION_SLOTS_PER_PAGE, TERMINATOR_AND_DOTS, getDotsAndLastPage, getFirstPageAndDots, getPageHash, getPagesByRange, omitUndefined, toArray,
  slice = [].slice;

omitUndefined = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).omitUndefined;

DEFAULT_MAX_PAGINATION_SLOTS_PER_PAGE = 10;

DEFAULT_MAX_EXPANDED_PAGINATION_SLOTS_PER_PAGE = 9;

TERMINATOR_AND_DOTS = 2;

CURRENT_PAGE_NUMBER_WITH_BOX = 1;

toArray = function(arg) {
  var currentPageNumber, endDotsThreshold, endNumber, expandingPaginationEnabled, getPageUrl, maxPaginationSlotsPerPage, numbersRadius, startDotsThreshold, startNumber, totalPages;
  currentPageNumber = arg.currentPageNumber, totalPages = arg.totalPages, getPageUrl = arg.getPageUrl, expandingPaginationEnabled = arg.expandingPaginationEnabled;
  if (expandingPaginationEnabled) {
    maxPaginationSlotsPerPage = DEFAULT_MAX_EXPANDED_PAGINATION_SLOTS_PER_PAGE;
  } else {
    maxPaginationSlotsPerPage = DEFAULT_MAX_PAGINATION_SLOTS_PER_PAGE;
  }
  currentPageNumber = parseInt(currentPageNumber);
  endDotsThreshold = maxPaginationSlotsPerPage - TERMINATOR_AND_DOTS;
  startDotsThreshold = totalPages - maxPaginationSlotsPerPage + TERMINATOR_AND_DOTS + 1;
  if (totalPages <= maxPaginationSlotsPerPage) {
    return getPagesByRange(1, totalPages, currentPageNumber, getPageUrl);
  } else if (currentPageNumber < endDotsThreshold) {
    if (expandingPaginationEnabled) {
      if (currentPageNumber <= 2) {
        return slice.call(getPagesByRange(1, 3, currentPageNumber, getPageUrl)).concat(slice.call(getDotsAndLastPage(currentPageNumber, totalPages, getPageUrl)));
      } else {
        return slice.call(getPagesByRange(1, currentPageNumber + 1, currentPageNumber, getPageUrl)).concat(slice.call(getDotsAndLastPage(currentPageNumber, totalPages, getPageUrl)));
      }
    } else {
      return slice.call(getPagesByRange(1, endDotsThreshold, currentPageNumber, getPageUrl)).concat(slice.call(getDotsAndLastPage(currentPageNumber, totalPages, getPageUrl)));
    }
  } else if (currentPageNumber > startDotsThreshold) {
    return slice.call(getFirstPageAndDots(currentPageNumber, getPageUrl)).concat(slice.call(getPagesByRange(startDotsThreshold, totalPages, currentPageNumber, getPageUrl)));
  } else {
    numbersRadius = (maxPaginationSlotsPerPage - (TERMINATOR_AND_DOTS * 2) - CURRENT_PAGE_NUMBER_WITH_BOX) / 2;
    startNumber = currentPageNumber - Math.floor(numbersRadius);
    endNumber = currentPageNumber + Math.ceil(numbersRadius);
    return slice.call(getFirstPageAndDots(currentPageNumber, getPageUrl)).concat(slice.call(getPagesByRange(startNumber, endNumber, currentPageNumber, getPageUrl)), slice.call(getDotsAndLastPage(currentPageNumber, totalPages, getPageUrl)));
  }
};

getFirstPageAndDots = function(currentPageNumber, getPageUrl) {
  return [
    getPageHash(1, currentPageNumber, getPageUrl), {
      text: '...',
      "box": false
    }
  ];
};

getDotsAndLastPage = function(currentPageNumber, totalPages, getPageUrl) {
  return [
    {
      text: '...',
      "box": false
    }, getPageHash(totalPages, currentPageNumber, getPageUrl)
  ];
};

getPagesByRange = function(from, to, currentPageNumber, getPageUrl) {
  var i, pageNumber, ref, ref1, results;
  results = [];
  for (pageNumber = i = ref = from, ref1 = to; i <= ref1; pageNumber = i += 1) {
    results.push(getPageHash(pageNumber, currentPageNumber, getPageUrl));
  }
  return results;
};

getPageHash = function(pageNumber, currentPageNumber, getPageUrl) {
  var isCurrentPage;
  isCurrentPage = pageNumber === currentPageNumber;
  return omitUndefined({
    box: isCurrentPage,
    text: pageNumber,
    url: !isCurrentPage ? getPageUrl(pageNumber) : void 0
  });
};

module.exports = {
  toArray: toArray
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],12:[function(require,module,exports){
(function (global){
var BrowsePaginationFooterPresenter, PaginationSlots, getNextPageTranslation, getNextPageUrl, getPreviousPageTranslation, getPreviousPageUrl, getUrlForPageNumber, isEmpty, isSinglePageDeals, omit, partial, prefixI18n, qs, ref, resultsHtml, toHash;

ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), isEmpty = ref.isEmpty, omit = ref.omit, partial = ref.partial;

prefixI18n = require('../../../shared/common/helpers/translations').prefixI18n;

PaginationSlots = require('../helpers/pagination_slots');

qs = require('qs');

toHash = function(attributes, expandingPaginationEnabled, modules, isClientSide) {
  var I18n, currentPageNumber, endingIndex, fetchedDealCount, getPageUrl, nextPageSize, query, queryParams, requestURL, startingIndex, totalDealCount, totalPages;
  I18n = modules.I18n;
  requestURL = attributes.requestURL, query = attributes.query, currentPageNumber = attributes.currentPageNumber, totalPages = attributes.totalPages, nextPageSize = attributes.nextPageSize, totalDealCount = attributes.totalDealCount, startingIndex = attributes.startingIndex, endingIndex = attributes.endingIndex, fetchedDealCount = attributes.fetchedDealCount;
  if (requestURL == null) {
    return;
  }
  queryParams = query;
  getPageUrl = partial(getUrlForPageNumber, requestURL, queryParams);
  if (isClientSide) {
    I18n = prefixI18n(I18n, 'js.');
  }
  return {
    number: currentPageNumber,
    resultsHtml: resultsHtml(startingIndex, endingIndex, totalDealCount, I18n),
    displayPagination: !isSinglePageDeals(currentPageNumber, nextPageSize),
    previousPage: getPreviousPageTranslation(I18n, expandingPaginationEnabled),
    nextPage: getNextPageTranslation(I18n),
    previousPageUrl: getPreviousPageUrl(requestURL, queryParams, currentPageNumber),
    nextPageUrl: getNextPageUrl(requestURL, queryParams, currentPageNumber, nextPageSize, totalPages),
    paginationSlots: PaginationSlots.toArray({
      currentPageNumber: currentPageNumber,
      totalPages: totalPages,
      getPageUrl: getPageUrl,
      expandingPaginationEnabled: expandingPaginationEnabled
    }),
    expandingPagination: expandingPaginationEnabled
  };
};

getPreviousPageTranslation = function(I18n, expandingPaginationEnabled) {
  if (expandingPaginationEnabled) {
    return I18n.t('modules.browse.presenters.pagination.prev');
  } else {
    return I18n.t('modules.browse.presenters.pagination.previous');
  }
};

getNextPageTranslation = function(I18n) {
  return I18n.t('modules.browse.presenters.pagination.next');
};

getPreviousPageUrl = function(requestURL, queryParams, currentPageNumber) {
  if (currentPageNumber === 1) {
    return;
  }
  return getUrlForPageNumber(requestURL, queryParams, parseInt(currentPageNumber) - 1);
};

getNextPageUrl = function(requestURL, queryParams, currentPageNumber, nextPageSize, totalPages) {
  if (currentPageNumber === totalPages || !(nextPageSize > 0)) {
    return;
  }
  return getUrlForPageNumber(requestURL, queryParams, parseInt(currentPageNumber) + 1);
};

resultsHtml = function(startingIndex, endingIndex, totalDealCount, I18n) {
  var translateOptions;
  translateOptions = {
    strongOpen: "<strong>",
    strongClose: "</strong>",
    totalDealCount: totalDealCount,
    startingIndex: startingIndex,
    endingIndex: endingIndex
  };
  return "<span>" + (I18n.t('modules.browse.presenters.pagination.results', translateOptions)) + "</span>";
};

getUrlForPageNumber = function(requestURL, queryParams, pageNumber) {
  var baseUri, paginationParams, ref1, stringify;
  if (queryParams == null) {
    queryParams = {};
  }
  paginationParams = queryParams;
  if (paginationParams.page) {
    delete paginationParams.page;
  }
  if (pageNumber !== 1) {
    paginationParams.page = pageNumber;
  }
  baseUri = requestURL;
  if (baseUri.indexOf('?') > -1) {
    baseUri = baseUri.substring(0, baseUri.indexOf('?'));
  }
  if (isEmpty(paginationParams)) {
    return baseUri;
  }
  stringify = (ref1 = qs != null ? qs.stringify : void 0) != null ? ref1 : $.param;
  return baseUri + "?" + (stringify(paginationParams));
};

isSinglePageDeals = function(pageNumber, nextPageSize) {
  if (!((pageNumber != null) && (nextPageSize != null))) {
    return true;
  }
  if (pageNumber !== 1) {
    return false;
  }
  if (!(nextPageSize <= 0)) {
    return false;
  }
  return true;
};

module.exports = BrowsePaginationFooterPresenter = {
  toHash: toHash
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../../shared/common/helpers/translations":50,"../helpers/pagination_slots":11,"qs":122}],13:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"error\">");t.b("\n" + i);t.b("  <h1>");t.b(t.v(t.f("error_message_header",c,p,0)));t.b("</h1>");t.b("\n");t.b("\n" + i);t.b("  <div class=\"error-content\">");t.b("\n" + i);t.b("    <p>");t.b(t.t(t.f("error_message_content_p1",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("    <p>");t.b(t.t(t.f("error_message_content_p2",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"error\">\n  <h1>{{ error_message_header }}</h1>\n\n  <div class=\"error-content\">\n    <p>{{{ error_message_content_p1 }}}</p>\n    <p>{{{ error_message_content_p2 }}}</p>\n  </div>\n</div>\n", Hogan);
},{"hogan.js":119}],14:[function(require,module,exports){
var BROWSE_REFINEMENT_KEYS, BrowseApplication, BrowseContentView, BrowseHeaderTitleHelper, BrowseParsedParamsHelper, BrowseUpdateAppUrlHelper, BrowseUrlContructionHelper, DealsMmSearch, DealsPaginationEvents, PaginatedDealsBuilder, RefinementUI, SortToggleApplication, SpinnerGroup, ToolTipDelayView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

BrowseContentView = require('./views/content');

BrowseHeaderTitleHelper = require('./helpers/header_title');

BrowseUpdateAppUrlHelper = require('./helpers/update_app_url');

BrowseUrlContructionHelper = require('./helpers/url_construction');

BrowseParsedParamsHelper = require('./helpers/parsed_params');

DealsMmSearch = require('../../deals/frontend/mm_search');

DealsPaginationEvents = require('../../deals/frontend/pagination_events');

PaginatedDealsBuilder = require('../../deals/frontend/helpers/paginated_deals_builder');

RefinementUI = require('grpn-refinement-ui/lib/frontend/application');

SortToggleApplication = require('../../grpn-sorts/frontend/application');

SpinnerGroup = require('./helpers/spinner_group');

ToolTipDelayView = require('./views/tool_tip_delay');

BROWSE_REFINEMENT_KEYS = ['category', 'category2', 'interest', 'minPrice', 'maxPrice', 'price', 'query'];

module.exports = BrowseApplication = (function() {
  var browseContentViewInstance, fetchAndRenderDeals, initAppWithoutRefinementUI, initNewRatingSortMessage, initRefinementUI, initSortsApp, refinementUIAppInstance, relocateInAppMessages, updatePageContent;

  refinementUIAppInstance = browseContentViewInstance = void 0;

  function BrowseApplication(arg) {
    this.isLeftBarVisible = arg.isLeftBarVisible, this.isOnNoDealsPage = arg.isOnNoDealsPage, this.goodsBrowsePageLayoutValue = arg.goodsBrowsePageLayoutValue, this.inNewHomepage = arg.inNewHomepage, this.carouselConfig = arg.carouselConfig, this.homeWidgetPreview = arg.homeWidgetPreview, this.showFreeShippingModal = arg.showFreeShippingModal, this.selectedCategory = arg.selectedCategory, this.isSeoEnabled = arg.isSeoEnabled, this.isVanityUrl = arg.isVanityUrl, this.collection = arg.collection, this.inRAPI = arg.inRAPI, this.useNewGAPIConnector = arg.useNewGAPIConnector;
    this.renderContent = bind(this.renderContent, this);
    this.resetRefinementUi = bind(this.resetRefinementUi, this);
    this.assignUrlBuilder();
  }

  BrowseApplication.prototype.assignUrlBuilder = function() {
    return this.constructUrl = (function() {
      switch (false) {
        case !this.collection:
          return BrowseUrlContructionHelper.getConstructCollectionById(this.collection.id, this.collection.type);
        case !this.isSeoEnabled:
          return BrowseUrlContructionHelper.constructV3;
        default:
          return BrowseUrlContructionHelper.constructV1;
      }
    }).call(this);
  };

  BrowseApplication.prototype.isMmHome = function() {
    var queryKeys;
    queryKeys = _.keys(Groupon.Utils.unparam());
    return this.goodsBrowsePageLayoutValue === 'mmhome' && !_.intersection(queryKeys, BROWSE_REFINEMENT_KEYS).length && !this.collection && !this.isVanityUrl;
  };

  BrowseApplication.prototype.startApp = function() {
    if (this.isMmHome()) {
      return this.renderMmHomeDeals(new DealsMmSearch({
        inNewHomepage: this.inNewHomepage,
        carouselConfig: this.carouselConfig,
        homeWidgetPreview: this.homeWidgetPreview,
        showFreeShippingModal: this.showFreeShippingModal
      }));
    } else {
      if (this.isLeftBarVisible) {
        initRefinementUI(this.constructUrl);
      } else {
        initAppWithoutRefinementUI();
      }
      relocateInAppMessages();
      return initSortsApp();
    }
  };

  BrowseApplication.prototype.resetRefinementUi = function() {
    if (refinementUIAppInstance != null) {
      refinementUIAppInstance.updateRefinements(Groupon.refinementUiPageData, {
        queue: true
      });
      return BrowseUpdateAppUrlHelper.updateFromRefinements(refinementUIAppInstance.selectedRefinements, this.constructUrl);
    }
  };

  BrowseApplication.prototype.renderContent = function(options) {
    return browseContentViewInstance != null ? browseContentViewInstance.render(options) : void 0;
  };

  initAppWithoutRefinementUI = function() {
    return browseContentViewInstance = new BrowseContentView({
      isContentRendered: true
    });
  };

  initRefinementUI = function(constructionLibrary) {
    var categoryAttributeWhitelistRemoval, categoryAttributesEnabled, enabledFacets, facetFilterKeys, getEnabledFacets, getParsedParams, ref, ref1, ref2, ref3, refinementUiOptions, updateFromRefinements;
    updateFromRefinements = BrowseUpdateAppUrlHelper.updateFromRefinements, getEnabledFacets = BrowseUpdateAppUrlHelper.getEnabledFacets, getParsedParams = BrowseUpdateAppUrlHelper.getParsedParams;
    facetFilterKeys = (ref = Groupon.facetFilterKeys) != null ? ref : [];
    categoryAttributesEnabled = (ref1 = Groupon.categoryAttributesEnabled) != null ? ref1 : {};
    categoryAttributeWhitelistRemoval = (ref2 = Groupon.categoryAttributeWhitelistRemoval) != null ? ref2 : false;
    refinementUiOptions = (ref3 = Groupon.refinementUiOptions) != null ? ref3 : {};
    refinementUiOptions.container = '#refinement-ui';
    refinementUIAppInstance = new RefinementUI(Groupon.refinementUiPageData, refinementUiOptions);
    BrowseHeaderTitleHelper.updateHeaderTitle($('.page-header .title'), Groupon.refinementUiPageData, Groupon.seoMetaHash);
    refinementUIAppInstance.events.on('refinementsUpdated', function(selectedRefinements, selectedId) {
      var _filterSelectedRefinements, l1, l2, l3, l4, ref4, ref5, ref6;
      Groupon.browseApp.lastUpdatedRefinementId = selectedId;
      if (!categoryAttributeWhitelistRemoval) {
        _filterSelectedRefinements = function(Lm, categoryName) {
          var LmWhitelist, facetName, i, len, ref4, results, whitelist;
          if (!(LmWhitelist = categoryAttributesEnabled[Lm])) {
            return;
          }
          whitelist = (ref4 = LmWhitelist[categoryName]) != null ? ref4 : [];
          results = [];
          for (i = 0, len = facetFilterKeys.length; i < len; i++) {
            facetName = facetFilterKeys[i];
            if (indexOf.call(whitelist, facetName) < 0) {
              results.push(delete selectedRefinements[facetName]);
            } else {
              results.push(void 0);
            }
          }
          return results;
        };
        if (!(l1 = selectedRefinements.category)) {

        } else if (!(l2 = (ref4 = l1.selectedValues) != null ? ref4[0] : void 0)) {
          _filterSelectedRefinements('L2', 'all');
        } else if (!(l3 = (ref5 = l2.selectedValues) != null ? ref5[0] : void 0)) {
          _filterSelectedRefinements('L2', l2.name);
        } else if (!(l4 = (ref6 = l3.selectedValues) != null ? ref6[0] : void 0)) {
          _filterSelectedRefinements('L3', l3.name);
        }
      }
      updateFromRefinements(selectedRefinements, constructionLibrary);
      return updatePageContent();
    });
    browseContentViewInstance = new BrowseContentView({
      isContentRendered: true,
      refinementUIAppInstance: refinementUIAppInstance
    });
    if (refinementUIAppInstance.selectedRefinements) {
      enabledFacets = getEnabledFacets(refinementUIAppInstance.selectedRefinements);
      return BrowseParsedParamsHelper.setParsedParams(getParsedParams(enabledFacets));
    }
  };

  updatePageContent = function() {
    fetchAndRenderDeals();
    return OptimizeSuite.treatAsNewPage(window.location.href);
  };

  initNewRatingSortMessage = function() {
    var ratingTooltipElem;
    if ((Cookie.get('goodsNewRatingSortMessage') === 'hide') || !Groupon.showSortByRatings || !(ratingTooltipElem = $('.rating-sort-tooltip-container')).length) {
      return;
    }
    ratingTooltipElem.fadeIn(200);
    return $('.rating-sort-tooltip-container .rating-sort-tooltip-close').one('click', function() {
      ratingTooltipElem.fadeOut(200);
      return Cookie.set('goodsNewRatingSortMessage', 'hide');
    });
  };

  initSortsApp = function(constructionLibrary) {
    return $(function() {
      var ref, ref1, sortsApp;
      sortsApp = SortToggleApplication;
      sortsApp.initialize();
      BrowseUpdateAppUrlHelper.updateFromSorts({
        sort: (ref = sortsApp.sortToggleView) != null ? (ref1 = ref.$el) != null ? ref1.val() : void 0 : void 0
      });
      sortsApp.on('change:sort', function(selectedRefinements) {
        BrowseUpdateAppUrlHelper.updateFromSorts(selectedRefinements);
        return fetchAndRenderDeals();
      });
      if (browseContentViewInstance != null) {
        browseContentViewInstance.setSortsApp(sortsApp);
      }
      return initNewRatingSortMessage();
    });
  };

  relocateInAppMessages = function() {
    return $(function() {
      var banner;
      banner = $('#in-app-messages').detach();
      banner.find('.hide-link').click(function() {
        return banner.slideUp();
      });
      return banner.appendTo('#inAppMessageBanner');
    });
  };

  fetchAndRenderDeals = function() {
    var paginatedBuilder;
    paginatedBuilder = new PaginatedDealsBuilder;
    if (browseContentViewInstance == null) {
      browseContentViewInstance = new BrowseContentView();
    }
    browseContentViewInstance.setDealsSearch(paginatedBuilder.search);
    browseContentViewInstance.render({
      paginatedDealsBuilder: paginatedBuilder
    });
    return paginatedBuilder.on('fetchSuccess', function(search) {
      var ref, refinementUiPageData, seoMetaHash;
      if (Groupon.refinementUiPageData) {
        ref = search.page, refinementUiPageData = ref.refinementUiPageData, seoMetaHash = ref.seoMetaHash;
        Groupon.refinementUiPageData = refinementUiPageData;
        if (seoMetaHash) {
          Groupon.seoMetaHash = seoMetaHash;
        }
        refinementUIAppInstance.updateRefinements(refinementUiPageData);
        BrowseHeaderTitleHelper.updateHeaderTitle($('.page-header .title'), refinementUiPageData, seoMetaHash);
      }
      return DealsPaginationEvents.trigger('newPage', search.page);
    });
  };

  BrowseApplication.prototype.renderMmHomeDeals = function(mmSearch) {
    this._startSpinner();
    mmSearch.on('error', (function(_this) {
      return function() {
        return _this._onDoneFetchingDeals(function() {});
      };
    })(this));
    return mmSearch.on('success', (function(_this) {
      return function(deals, dealIdList) {
        return _this._onDoneFetchingDeals(function() {
          return $(function() {
            $('#browse_deals_container').replaceWith(deals);
            return GIG.Tooltip.reloadBindings(document.body);
          });
        });
      };
    })(this));
  };

  BrowseApplication.prototype._onDoneFetchingDeals = function(renderContentCallback) {
    renderContentCallback();
    return this._stopSpinner();
  };

  BrowseApplication.prototype._stopSpinner = function() {
    return SpinnerGroup.stop('deal-space', {
      remove: true
    });
  };

  BrowseApplication.prototype._startSpinner = function() {
    return SpinnerGroup.start('deal-space', {
      parentElem: $('#deal-space'),
      css: {
        marginTop: '100px'
      },
      useV2: true
    });
  };

  return BrowseApplication;

})();



},{"../../deals/frontend/helpers/paginated_deals_builder":33,"../../deals/frontend/mm_search":36,"../../deals/frontend/pagination_events":37,"../../grpn-sorts/frontend/application":42,"./helpers/header_title":16,"./helpers/parsed_params":17,"./helpers/spinner_group":18,"./helpers/update_app_url":20,"./helpers/url_construction":21,"./views/content":25,"./views/tool_tip_delay":28,"grpn-refinement-ui/lib/frontend/application":68}],15:[function(require,module,exports){
var BrowseContentHelper, DEAL_CONTENT_CONTAINER, DEAL_SPACE_MSG_CONTENT;

DEAL_CONTENT_CONTAINER = '#deal_content';

DEAL_SPACE_MSG_CONTENT = '#deal_space_message_content';

module.exports = BrowseContentHelper = {
  getDealsMessageSelector: function() {
    return $(DEAL_SPACE_MSG_CONTENT);
  },
  getDealsContentSelector: function() {
    return $(DEAL_CONTENT_CONTAINER);
  }
};



},{}],16:[function(require,module,exports){
(function (global){
var BrowseHeaderTitleHelper, DISCOUNT_ID, PageHeaderTitleTemplate, _getClearanceRefinement, _getPageHeaderTitleHash, _getRefinementData, _getSelectedNestedRefinement, _isHighestLevelCategory, find, findWhere, ref;

ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), findWhere = ref.findWhere, find = ref.find;

PageHeaderTitleTemplate = require('../../../page_header/title.html.mustache');

DISCOUNT_ID = 'gg-clearance';

_getSelectedNestedRefinement = function(nestedRefinements) {
  var ref1, selectedChild, selectedRefinement;
  if (nestedRefinements == null) {
    return;
  }
  selectedRefinement = findWhere(nestedRefinements, {
    selected: true
  });
  if (!selectedRefinement || selectedRefinement.id === 'all') {
    return;
  }
  if (selectedRefinement != null ? (ref1 = selectedRefinement.children) != null ? ref1.length : void 0 : void 0) {
    selectedChild = _getSelectedNestedRefinement(selectedRefinement.children);
  }
  if (selectedChild) {
    return selectedChild;
  }
  return selectedRefinement;
};

_getRefinementData = function(refinementUiPageData, id) {
  var ref1;
  return ((ref1 = findWhere(refinementUiPageData, {
    id: id
  })) != null ? ref1.refinementData : void 0) || [];
};

_getClearanceRefinement = function(refinementUiPageData) {
  var refinementDiscounts;
  refinementDiscounts = _getRefinementData(refinementUiPageData, 'discount');
  return find(refinementDiscounts, function(discount) {
    return (discount != null ? discount.id : void 0) === DISCOUNT_ID;
  });
};

_isHighestLevelCategory = function(categoryRefinements, selectedCategoryRefinementId) {
  return find(categoryRefinements, function(category) {
    return category.id === selectedCategoryRefinementId;
  }) != null;
};

_getPageHeaderTitleHash = function(refinementUiPageData, seoMetaHash) {
  var categoryRefinements, clearanceRefinement, collection, pageTitle, pageTitleBhc, ref1, ref2, ref3, ref4, ref5, ref6, selectedCategoryRefinement, selectedCategoryRefinementId;
  collection = Groupon.collection;
  categoryRefinements = _getRefinementData(refinementUiPageData, 'category');
  selectedCategoryRefinement = _getSelectedNestedRefinement(categoryRefinements);
  selectedCategoryRefinementId = (ref1 = selectedCategoryRefinement != null ? selectedCategoryRefinement.id : void 0) != null ? ref1 : 'all';
  if (collection) {
    pageTitle = collection.name;
    pageTitleBhc = collection.type === 'brands' ? "brand:" + collection.id : "collection:" + collection.id;
    if ((categoryRefinements != null ? categoryRefinements.length : void 0) && (selectedCategoryRefinement != null) && !_isHighestLevelCategory(categoryRefinements, selectedCategoryRefinementId)) {
      pageTitle += " - " + selectedCategoryRefinement.friendlyNameShort;
      pageTitleBhc += "-" + selectedCategoryRefinementId;
    }
  } else {
    pageTitle = (ref2 = (ref3 = seoMetaHash != null ? (ref4 = seoMetaHash.pageMeta) != null ? ref4.h1 : void 0 : void 0) != null ? ref3 : selectedCategoryRefinement != null ? selectedCategoryRefinement.friendlyNameShort : void 0) != null ? ref2 : I18n.translate('js.modules.browse.presenters.all_goods');
    pageTitleBhc = (ref5 = selectedCategoryRefinement != null ? selectedCategoryRefinement.dataBhc : void 0) != null ? ref5 : "category:" + selectedCategoryRefinementId;
    if (selectedCategoryRefinementId === 'all' && ((ref6 = (clearanceRefinement = _getClearanceRefinement(refinementUiPageData))) != null ? ref6.selected : void 0)) {
      pageTitle += " - " + clearanceRefinement.friendlyNameShort;
      pageTitleBhc += "#-{DISCOUNT_ID}";
    }
  }
  return {
    titleHeading: {
      pageTitle: pageTitle,
      pageTitleBhc: pageTitleBhc
    }
  };
};

module.exports = BrowseHeaderTitleHelper = {
  updateHeaderTitle: function(elem, refinementUiPageData, seoMetaHash) {
    var viewHash;
    viewHash = _getPageHeaderTitleHash(refinementUiPageData, seoMetaHash);
    return elem != null ? elem.html(PageHeaderTitleTemplate.render(viewHash)) : void 0;
  }
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../../page_header/title.html.mustache":44}],17:[function(require,module,exports){
var Backbone, BrowseParsedParamsHelper, handlers, parsedParams;

Backbone = require('backbone');

parsedParams = new Backbone.Model();

handlers = {};

module.exports = BrowseParsedParamsHelper = {
  setParsedParams: function(params, options) {
    parsedParams.clear({
      silent: true
    });
    parsedParams.set(params, {
      silent: true
    });
    return parsedParams.trigger('change', parsedParams, options);
  },
  getParsedParams: function() {
    return parsedParams.toJSON();
  },
  onUpdate: function(cb, key) {
    var changeHandler;
    changeHandler = function(model, options) {
      return cb(model.toJSON(), options);
    };
    if (key != null) {
      handlers[key] = changeHandler;
    }
    return parsedParams.on('change', changeHandler);
  },
  offUpdate: function(key) {
    if (handlers[key]) {
      parsedParams.off('change', handlers[key]);
      return delete handlers[key];
    }
  }
};



},{"backbone":55}],18:[function(require,module,exports){
var SpinnerGroup, SpinnerView;

SpinnerView = require('../../../spinner/frontend/views/spinner');

module.exports = SpinnerGroup = {
  spinners: {},
  addSpinner: function(name, options) {
    return this.spinners[name] = (new SpinnerView(options)).render();
  },
  removeSpinner: function(name) {
    var ref;
    if ((ref = this.spinners[name]) != null) {
      ref.remove();
    }
    return delete this.spinners[name];
  },
  start: function(name, options) {
    var ref, spinner;
    spinner = (ref = this.spinners[name]) != null ? ref : this.addSpinner(name, options).render();
    return spinner != null ? spinner.start() : void 0;
  },
  stop: function(name, options) {
    var ref, spinner;
    if (options != null ? options.remove : void 0) {
      return this.removeSpinner(name);
    }
    if (!((ref = (spinner = this.spinners[name])) != null ? ref.isRunning() : void 0)) {
      return;
    }
    return spinner.stop();
  }
};



},{"../../../spinner/frontend/views/spinner":53}],19:[function(require,module,exports){
var TrackingHelper;

TrackingHelper = (function() {
  function TrackingHelper() {
    this.recordedFirstPage = false;
  }

  TrackingHelper.prototype.pageReady = function() {
    if (this.recordedFirstPage) {
      return;
    }
    if (!Groupon.Performance) {
      return;
    }
    Groupon.Performance.pageReady();
    return this.recordedFirstPage = true;
  };

  return TrackingHelper;

})();

module.exports = TrackingHelper;



},{}],20:[function(require,module,exports){
(function (global){
var ALL_FACET_NAMES, BrowseParsedParamsHelper, BrowseUpdateAppUrlHelper, FACET_FILTER_KEYS, PARAM_WHITELIST, UpdateAppURLHelper, _addSort, _getCategoryHash, _getEnabledFacets, _getExtraQS, _getNestedRefinements, _getParsedParams, _getSelectedFlatRefinements, _getSelectedRange, _removeDefaultSort, _setParsedParamsWithSelected, extend, isEmpty, keys, pluck, ref, ref1, ref2, ref3, where;

ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), extend = ref.extend, isEmpty = ref.isEmpty, keys = ref.keys, pluck = ref.pluck, where = ref.where;

BrowseParsedParamsHelper = require('./parsed_params');

UpdateAppURLHelper = require('../../../shared/frontend/helpers/app_url');

PARAM_WHITELIST = ['interest', 'discount', 'query', 'minPrice', 'maxPrice', 'price', 'brand', 'sort', 'rating'];

FACET_FILTER_KEYS = (ref1 = Groupon.facetFilterKeys) != null ? ref1 : (ref2 = Groupon.PageAppData) != null ? (ref3 = ref2.config) != null ? ref3.facetFilterKeys : void 0 : void 0;

ALL_FACET_NAMES = PARAM_WHITELIST.concat(FACET_FILTER_KEYS);

_getCategoryHash = function(categoryHash) {
  var ref4, ref5, selectedCategory;
  if ((ref4 = Groupon.PageAppData) != null ? (ref5 = ref4.experiments) != null ? ref5.inTouchFilters : void 0 : void 0) {
    selectedCategory = _getNestedRefinements(categoryHash, 'category2');
    if (!selectedCategory.length) {
      selectedCategory = _getNestedRefinements(categoryHash, 'category');
    }
    return {
      category: selectedCategory,
      category2: _getNestedRefinements(categoryHash, 'category3'),
      category3: _getNestedRefinements(categoryHash, 'category4')
    };
  } else {
    return {
      category: _getNestedRefinements(categoryHash, 'category'),
      category2: _getNestedRefinements(categoryHash, 'category2'),
      category3: _getNestedRefinements(categoryHash, 'category3'),
      category4: _getNestedRefinements(categoryHash, 'category4'),
      category5: _getNestedRefinements(categoryHash, 'category5')
    };
  }
};

_getParsedParams = function(enabledFacets) {
  var attr, param, parsedParams;
  parsedParams = {};
  for (attr in enabledFacets) {
    param = enabledFacets[attr];
    if ((param != null ? param.constructor : void 0) === Array) {
      if (param.length) {
        parsedParams[attr] = param.join(',');
      }
    } else {
      parsedParams[attr] = param;
    }
  }
  return parsedParams;
};

_getEnabledFacets = function(selectedRefinements) {
  var enabledFacets, facet, i, len, ref4;
  enabledFacets = extend({}, _getCategoryHash(selectedRefinements.category), {
    interest: _getSelectedFlatRefinements(selectedRefinements.interest),
    discount: _getSelectedFlatRefinements(selectedRefinements.discount),
    minPrice: _getSelectedRange(selectedRefinements, 'price', 'min'),
    maxPrice: _getSelectedRange(selectedRefinements, 'price', 'max'),
    price: _getSelectedFlatRefinements(selectedRefinements.price),
    brand: _getSelectedFlatRefinements(selectedRefinements.brand),
    query: _getSelectedFlatRefinements(selectedRefinements.search),
    rating: _getSelectedFlatRefinements(selectedRefinements.rating)
  });
  if (selectedRefinements.sort != null) {
    enabledFacets.sort = _getSelectedFlatRefinements(selectedRefinements.sort);
  }
  ref4 = FACET_FILTER_KEYS || [];
  for (i = 0, len = ref4.length; i < len; i++) {
    facet = ref4[i];
    enabledFacets[facet] = _getSelectedFlatRefinements(selectedRefinements[facet]);
  }
  return enabledFacets;
};

_setParsedParamsWithSelected = function(selectedRefinements, options) {
  var parsedParams;
  if (options == null) {
    options = {};
  }
  parsedParams = _getParsedParams(_getEnabledFacets(selectedRefinements));
  return BrowseParsedParamsHelper.setParsedParams(parsedParams, options);
};

_getExtraQS = function(enabledFacets, whitelist) {
  var currentParam, extraQS, i, len, param, ref4;
  extraQS = {};
  for (i = 0, len = whitelist.length; i < len; i++) {
    param = whitelist[i];
    if (currentParam = (ref4 = enabledFacets[param]) != null ? ref4.join(',') : void 0) {
      extraQS[param] = currentParam;
    }
  }
  return extraQS;
};

_getSelectedRange = function(selectedRefinements, rangeType, value) {
  var range, ref4;
  if ((selectedRefinements != null ? (ref4 = selectedRefinements.range) != null ? ref4.selectedValues.length : void 0 : void 0) > 0) {
    range = where(selectedRefinements.range.selectedValues, {
      id: rangeType
    });
    if (range.length > 0) {
      if (value === 'min') {
        return [range[0].selectedMin];
      } else {
        return [range[0].selectedMax];
      }
    }
  }
};

_getSelectedFlatRefinements = function(selectedRefinement) {
  var ref4;
  if (!(selectedRefinement != null ? (ref4 = selectedRefinement.selectedValues) != null ? ref4.length : void 0 : void 0)) {
    return;
  }
  return pluck(selectedRefinement.selectedValues, 'name');
};

_getNestedRefinements = function(selectedRefinement, key, refinementNames) {
  var i, len, ref4, refinement, selectedRefinements;
  if (refinementNames == null) {
    refinementNames = [];
  }
  if (!(selectedRefinement != null ? (ref4 = selectedRefinement.selectedValues) != null ? ref4.length : void 0 : void 0)) {
    return [];
  }
  selectedRefinements = selectedRefinement.selectedValues;
  for (i = 0, len = selectedRefinements.length; i < len; i++) {
    refinement = selectedRefinements[i];
    if (refinement.id === key) {
      refinementNames.push(refinement.name);
    } else {
      _getNestedRefinements(refinement, key, refinementNames);
    }
  }
  return refinementNames;
};

_removeDefaultSort = function(hash) {
  if (!Groupon.showRatingSortByDefault) {
    if (hash.sort === 'relevance') {
      return delete hash.sort;
    }
  }
};

_addSort = function(extraQS) {
  var queryParams;
  if (!extraQS.sort) {
    queryParams = Groupon.Utils.unparam();
    if (queryParams.sort) {
      return extraQS.sort = queryParams.sort;
    }
  }
};

module.exports = BrowseUpdateAppUrlHelper = {
  getEnabledFacets: _getEnabledFacets,
  getParsedParams: _getParsedParams,
  setParsedParamsWithSelected: _setParsedParamsWithSelected,
  updateFromRefinements: function(selectedRefinements, constructionLibrary, options) {
    var adjustedURL, enabledFacets, extraQS, parsedParams;
    if (options == null) {
      options = {};
    }
    enabledFacets = _getEnabledFacets(selectedRefinements);
    extraQS = _getExtraQS(enabledFacets, ALL_FACET_NAMES);
    _addSort(extraQS);
    _removeDefaultSort(extraQS);
    adjustedURL = constructionLibrary(enabledFacets, extraQS);
    parsedParams = _getParsedParams(enabledFacets);
    BrowseParsedParamsHelper.setParsedParams(parsedParams, options);
    return UpdateAppURLHelper(adjustedURL);
  },
  updateFromSorts: function(sortRefinement) {
    var adjustedURL, queryParams, queryString;
    queryParams = Groupon.Utils.unparam();
    if (sortRefinement.sort) {
      queryParams.sort = sortRefinement.sort;
    }
    _removeDefaultSort(queryParams);
    queryString = $.param(queryParams);
    if (!isEmpty(queryString)) {
      queryString = "?" + queryString;
    }
    adjustedURL = "" + window.location.pathname + queryString;
    return UpdateAppURLHelper(adjustedURL, {
      pushState: true
    });
  }
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../../shared/frontend/helpers/app_url":52,"./parsed_params":17}],21:[function(require,module,exports){
var BrowseUrlConstructionHelper, _constructCollection, _getAppRoot, grpnParams;

grpnParams = require('grpn-params');

_constructCollection = function(collectionId, collectionType, enabledFacets, extraQS) {
  var collectionsRoot;
  if (collectionType) {
    collectionsRoot = Groupon.urls.collections;
  }
  delete extraQS.query;
  return grpnParams.V1.construct({
    baseURL: collectionsRoot + "/" + collectionId,
    l2Categories: enabledFacets['category'],
    l3Categories: enabledFacets['category2'],
    l4Categories: enabledFacets['category3'],
    l5Categories: enabledFacets['category4'],
    l6Categories: enabledFacets['category5'],
    interests: enabledFacets['interest'],
    brands: enabledFacets['brand'],
    discounts: enabledFacets['discount'],
    extraQS: extraQS
  });
};

_getAppRoot = function() {
  var ref, ref1, ref2;
  return (ref = (ref1 = Groupon.urls) != null ? ref1.browse : void 0) != null ? ref : (ref2 = Groupon.PageAppData) != null ? ref2.baseUrl : void 0;
};

module.exports = BrowseUrlConstructionHelper = {
  constructCollection: _constructCollection,
  constructV1: function(enabledFacets, extraQS) {
    var appRoot;
    appRoot = _getAppRoot();
    return grpnParams.V1.construct({
      baseURL: appRoot,
      l2Categories: enabledFacets['category'],
      l3Categories: enabledFacets['category2'],
      l4Categories: enabledFacets['category3'],
      l5Categories: enabledFacets['category4'],
      l6Categories: enabledFacets['category5'],
      interests: enabledFacets['interest'],
      brands: enabledFacets['brand'],
      discounts: enabledFacets['discount'],
      extraQS: extraQS
    });
  },
  constructV3: function(enabledFacets, extraQS) {
    var appRoot, permalink, ref, ref1, ref2, ref3, ref4;
    appRoot = _getAppRoot();
    permalink = ((ref = enabledFacets.category5) != null ? ref[0] : void 0) || ((ref1 = enabledFacets.category4) != null ? ref1[0] : void 0) || ((ref2 = enabledFacets.category3) != null ? ref2[0] : void 0) || ((ref3 = enabledFacets.category2) != null ? ref3[0] : void 0) || ((ref4 = enabledFacets.category) != null ? ref4[0] : void 0) || 'all';
    return grpnParams.V3.construct(appRoot, permalink, extraQS);
  },
  getConstructCollectionById: function(collectionId, collectionType) {
    return function(enabledFacets, extraQS) {
      return _constructCollection(collectionId, collectionType, enabledFacets, extraQS);
    };
  }
};



},{"grpn-params":56}],22:[function(require,module,exports){
var Backbone, BrowsePageEvents;

Backbone = require('backbone');

module.exports = BrowsePageEvents = _.extend({}, Backbone.Events);



},{"backbone":55}],23:[function(require,module,exports){
var BrowseErrorPresenter;

module.exports = BrowseErrorPresenter = (function() {
  function BrowseErrorPresenter() {}

  BrowseErrorPresenter.prototype.toHash = function() {
    var aClose, aOpen, breakline, category, href, isClearanceSelected, isPriceFilterSelected, queryParams;
    href = window.location.href;
    aOpen = "<a href='" + href + "'>";
    aClose = "</a>";
    breakline = "<br>";
    queryParams = Groupon.Utils.unparam();
    isPriceFilterSelected = ((queryParams != null ? queryParams.minPrice : void 0) != null) || ((queryParams != null ? queryParams.maxPrice : void 0) != null);
    isClearanceSelected = (queryParams != null ? queryParams.discount : void 0) === "gg-clearance";
    if (isPriceFilterSelected) {
      category = (queryParams != null ? queryParams.category : void 0) || 'all';
      href = "/goods?category=" + category;
      aOpen = "<a href='" + href + "'>";
      return {
        error_message_header: I18n.translate('js.modules.browse.presenters.error_message.message_header'),
        error_message_content_p1: I18n.translate('js.modules.browse.presenters.error_message.price_range_message_content_p1', {
          aOpen: aOpen,
          aClose: aClose
        }),
        error_message_content_p2: I18n.translate('js.modules.browse.presenters.error_message.message_content_p2', {
          breakline: breakline
        })
      };
    } else if (isClearanceSelected) {
      href = "/goods?category=all&discount=gg-clearance";
      aOpen = "<a href='" + href + "'>";
      return {
        error_message_header: I18n.translate('js.modules.browse.presenters.error_message.message_header'),
        error_message_content_p1: I18n.translate('js.modules.browse.presenters.error_message.clearance_message_content_p1', {
          aOpen: aOpen,
          aClose: aClose
        })
      };
    } else {
      return {
        error_message_header: I18n.translate('js.modules.browse.presenters.error_message.message_header'),
        error_message_content_p1: I18n.translate('js.modules.browse.presenters.error_message.message_content_p1', {
          aOpen: aOpen,
          aClose: aClose
        }),
        error_message_content_p2: I18n.translate('js.modules.browse.presenters.error_message.message_content_p2', {
          breakline: breakline
        })
      };
    }
  };

  return BrowseErrorPresenter;

})();



},{}],24:[function(require,module,exports){
var BrowseNoDealsErrorPresenter;

module.exports = BrowseNoDealsErrorPresenter = {
  toHash: function(lastUpdatedRefinementId) {
    switch (lastUpdatedRefinementId) {
      case 'range':
        return {
          noDealsMessage: I18n.translate('js.modules.browse.presenters.no_deals_discoverability.range.message'),
          noDealsSuggestion: I18n.translate('js.modules.browse.presenters.no_deals_discoverability.range.suggestion')
        };
      case 'discount':
        return {
          noDealsMessage: I18n.translate('js.modules.browse.presenters.no_deals_discoverability.discount.message'),
          noDealsSuggestion: I18n.translate('js.modules.browse.presenters.no_deals_discoverability.discount.suggestion')
        };
    }
  }
};



},{}],25:[function(require,module,exports){
(function (global){
var BreadcrumbPresenter, BreadcrumbView, BrowseContentHelper, BrowseContentView, BrowseErrorHtml, BrowseNoDealsErrorView, DealsApplication, PaginatedDealsListView, RefinementContextLoggerDesktop, SpinnerGroup, isEmpty,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

isEmpty = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).isEmpty;

BrowseContentHelper = require('../helpers/content');

SpinnerGroup = require('../helpers/spinner_group');

BrowseErrorHtml = require('./error');

BreadcrumbPresenter = require('../../../breadcrumb/frontend/presenters/breadcrumb');

BreadcrumbView = require('../../../breadcrumb/frontend/views/breadcrumb');

RefinementContextLoggerDesktop = require('../../../refinement_context_logger/frontend/views/rcl-desktop');

BrowseNoDealsErrorView = require('./no_deals_error');

PaginatedDealsListView = require('../../../deals/frontend/views/paginated_deals_list');

DealsApplication = require('../../../deals/frontend/application');

module.exports = BrowseContentView = (function() {
  var refinementContextLoggerInstance;

  refinementContextLoggerInstance = void 0;

  BrowseContentView.prototype.SELECTORS = {
    CONTENT: '#content',
    DEAL_CONTENT: '#content #deal_content .content',
    DEAL_SPACE: '#deal-space',
    REFINEMENT_DICOUNTS: '.refinement-box.flat-refinements.discounts'
  };

  function BrowseContentView(options) {
    this._fetchSuccess = bind(this._fetchSuccess, this);
    this._fetchError = bind(this._fetchError, this);
    this.render(options);
  }

  BrowseContentView.prototype.render = function(arg) {
    var isContentRendered, options, paginatedDealsBuilder, ref, refinementUIAppInstance;
    ref = arg != null ? arg : {}, refinementUIAppInstance = ref.refinementUIAppInstance, paginatedDealsBuilder = ref.paginatedDealsBuilder, isContentRendered = ref.isContentRendered;
    this._renderedContent = isContentRendered;
    this._renderedSpinner = false;
    $((function(_this) {
      return function() {
        if (!isContentRendered) {
          return _this._startSpinner();
        } else {
          return _this._renderedOnServer();
        }
      };
    })(this));
    if (paginatedDealsBuilder != null) {
      paginatedDealsBuilder.on('fetchError', this._fetchError).on('fetchSuccess', this._fetchSuccess);
    }
    if (Groupon.goodsRCLDesktopEnabled) {
      options = {
        _logDealAndCard: Groupon.inGoodsRCLDesktopExperimentV2
      };
      if (refinementContextLoggerInstance == null) {
        refinementContextLoggerInstance = new RefinementContextLoggerDesktop({
          el: $(this.SELECTORS.CONTENT),
          refinementUIAppInstance: refinementUIAppInstance,
          options: options
        });
      }
      this.setPaginatedDealsBuilder(paginatedDealsBuilder);
    }
    return void 0;
  };

  BrowseContentView.prototype.setSortsApp = function(sortsApp) {
    return refinementContextLoggerInstance != null ? refinementContextLoggerInstance.setSortsApp(sortsApp) : void 0;
  };

  BrowseContentView.prototype.setDealsSearch = function(search) {
    return refinementContextLoggerInstance != null ? refinementContextLoggerInstance.setDealsSearch(search) : void 0;
  };

  BrowseContentView.prototype.setPaginatedDealsBuilder = function(paginatedDealsBuilder) {
    return refinementContextLoggerInstance != null ? refinementContextLoggerInstance.setPaginatedDealsBuilder(paginatedDealsBuilder) : void 0;
  };

  BrowseContentView.prototype._renderedOnServer = function() {
    return $((function(_this) {
      return function() {
        var completedDealSearch, overwriteExisting, pageData;
        pageData = {
          dealContent: Groupon.dealContent,
          metadata: {
            pagination: Groupon.pagination
          }
        };
        completedDealSearch = new DealsApplication({
          pageData: pageData
        });
        _this.setDealsSearch(completedDealSearch);
        overwriteExisting = false;
        return _this._updateContent(completedDealSearch, overwriteExisting);
      };
    })(this));
  };

  BrowseContentView.prototype._updateContent = function(search, overwriteExisting) {
    var $breadcrumbSelector, $dealsContent, $dealsMessage, breadcrumb, breadcrumbPresenter, breadcrumbPresenterHash, clearanceDealsCount, dealsList, ref;
    if (overwriteExisting == null) {
      overwriteExisting = true;
    }
    $dealsMessage = BrowseContentHelper.getDealsMessageSelector();
    $dealsContent = BrowseContentHelper.getDealsContentSelector();
    $breadcrumbSelector = BreadcrumbView.prototype.getSelector();
    breadcrumb = void 0;
    if ($breadcrumbSelector) {
      breadcrumbPresenter = new BreadcrumbPresenter(search);
      if (!isEmpty(breadcrumbPresenter)) {
        breadcrumb = (breadcrumbPresenterHash = breadcrumbPresenter.toHash()).breadcrumb;
        new BreadcrumbView(breadcrumbPresenterHash).render();
      }
    }
    if (Groupon.onNoDealsPage) {
      $dealsMessage.show();
    }
    clearanceDealsCount = (ref = search.page.clearanceDealsCount) != null ? ref.values : void 0;
    if (clearanceDealsCount != null) {
      if (clearanceDealsCount) {
        $(this.SELECTORS.REFINEMENT_DICOUNTS).show();
      } else {
        $(this.SELECTORS.REFINEMENT_DICOUNTS).hide();
      }
    }
    dealsList = new PaginatedDealsListView($dealsContent, search);
    if (overwriteExisting) {
      dealsList.render();
    } else {
      dealsList.postRender(overwriteExisting);
    }
    return Groupon.Utils.lazyLoadImages();
  };

  BrowseContentView.prototype._fetchError = function() {
    $((function(_this) {
      return function() {
        var $dealContentContainer, $noDealsContainer, lastUpdatedRefinementId, noDealsHtml, ref, resetRefinementUi;
        ref = Groupon.browseApp, lastUpdatedRefinementId = ref.lastUpdatedRefinementId, resetRefinementUi = ref.resetRefinementUi;
        $dealContentContainer = $(_this.SELECTORS.DEAL_CONTENT);
        if (Groupon.showNoDealsMessage) {
          noDealsHtml = BrowseNoDealsErrorView.render(lastUpdatedRefinementId);
        }
        if (noDealsHtml) {
          if (($noDealsContainer = $dealContentContainer.find('.notification.info')).length) {
            $noDealsContainer.replaceWith(noDealsHtml);
          } else {
            $dealContentContainer.prepend(noDealsHtml);
          }
          return resetRefinementUi();
        } else {
          $dealContentContainer.html(BrowseErrorHtml());
          return Groupon.BrowseTracking.pageReady();
        }
      };
    })(this));
    return this._stopSpinner();
  };

  BrowseContentView.prototype._fetchSuccess = function(search) {
    $((function(_this) {
      return function() {
        return _this._updateContent(search);
      };
    })(this));
    return this._stopSpinner();
  };

  BrowseContentView.prototype._startSpinner = function() {
    if (!this._renderedContent) {
      SpinnerGroup.start('deal-content', {
        parentElem: $(this.SELECTORS.DEAL_SPACE),
        css: {
          marginTop: '100px'
        },
        useV2: true
      });
      return this._renderedSpinner = true;
    }
  };

  BrowseContentView.prototype._stopSpinner = function() {
    this._renderedContent = true;
    if (this._renderedSpinner) {
      return SpinnerGroup.stop('deal-content');
    }
  };

  return BrowseContentView;

})();


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../../breadcrumb/frontend/presenters/breadcrumb":8,"../../../breadcrumb/frontend/views/breadcrumb":9,"../../../deals/frontend/application":31,"../../../deals/frontend/views/paginated_deals_list":38,"../../../refinement_context_logger/frontend/views/rcl-desktop":45,"../helpers/content":15,"../helpers/spinner_group":18,"./error":26,"./no_deals_error":27}],26:[function(require,module,exports){
var BrowseErrorHtml, BrowseErrorMessageTemplate, BrowseErrorPresenter;

BrowseErrorPresenter = require('../presenters/error');

BrowseErrorMessageTemplate = require('../../error_message.html.mustache');

module.exports = BrowseErrorHtml = function() {
  var hash, presenter;
  presenter = new BrowseErrorPresenter;
  hash = presenter.toHash();
  return BrowseErrorMessageTemplate.render(hash);
};



},{"../../error_message.html.mustache":13,"../presenters/error":23}],27:[function(require,module,exports){
var BrowseNoDealsErrorPresenter, BrowseNoDealsErrorView, BrowseNoDealsMessageTemplate;

BrowseNoDealsErrorPresenter = require('../presenters/no_deals_error');

BrowseNoDealsMessageTemplate = require('../../no_deals_message.html.mustache');

module.exports = BrowseNoDealsErrorView = {
  template: BrowseNoDealsMessageTemplate,
  render: function(lastUpdatedRefinementId) {
    var noDealsHash;
    if (!(lastUpdatedRefinementId != null ? lastUpdatedRefinementId.length : void 0)) {
      return;
    }
    noDealsHash = BrowseNoDealsErrorPresenter.toHash(lastUpdatedRefinementId);
    if (noDealsHash) {
      return this.template.render(noDealsHash);
    }
  }
};



},{"../../no_deals_message.html.mustache":29,"../presenters/no_deals_error":24}],28:[function(require,module,exports){
var DEFAULT_HIDE_DELAY, DEFAULT_SHOW_DELAY, ToolTipDelayView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

DEFAULT_SHOW_DELAY = 1000;

DEFAULT_HIDE_DELAY = 100;

module.exports = ToolTipDelayView = (function(superClass) {
  extend(ToolTipDelayView, superClass);

  function ToolTipDelayView() {
    this.hideToolTip = bind(this.hideToolTip, this);
    this.showToolTip = bind(this.showToolTip, this);
    return ToolTipDelayView.__super__.constructor.apply(this, arguments);
  }

  ToolTipDelayView.prototype.showDebounce = null;

  ToolTipDelayView.prototype.hideDebounce = null;

  ToolTipDelayView.prototype.events = {
    'mouseenter': 'showToolTip',
    'mouseleave': 'hideToolTip'
  };

  ToolTipDelayView.prototype.initialize = function(arg) {
    this.eventName = arg.eventName, this.showDelay = arg.showDelay, this.hideDelay = arg.hideDelay;
    if (this.eventName == null) {
      this.eventName = 'showdelayed';
    }
    if (this.showDelay == null) {
      this.showDelay = DEFAULT_SHOW_DELAY;
    }
    if (this.hideDelay == null) {
      this.hideDelay = DEFAULT_HIDE_DELAY;
    }
    this.cacheElem();
    return this.initToolTipElemHandlers();
  };

  ToolTipDelayView.prototype.cacheElem = function() {
    return this.$toolTipElem = $("#" + (this.$el.data('tooltip-id')));
  };

  ToolTipDelayView.prototype.initToolTipElemHandlers = function() {
    this.$toolTipElem.on('mouseenter', this.showToolTip);
    return this.$toolTipElem.on('mouseleave', this.hideToolTip);
  };

  ToolTipDelayView.prototype.showToolTip = function() {
    if (this.hideDebounce) {
      this.hideDebounce = clearTimeout(this.hideDebounce);
    }
    if (this.showDebounce) {
      return;
    }
    return this.showDebounce = setTimeout(((function(_this) {
      return function() {
        return _this.$el.trigger(_this.eventName);
      };
    })(this)), this.showDelay);
  };

  ToolTipDelayView.prototype.hideToolTip = function() {
    if (this.showDebounce) {
      this.showDebounce = clearTimeout(this.showDebounce);
    }
    if (this.hideDebounce) {
      return;
    }
    return this.hideDebounce = setTimeout(((function(_this) {
      return function() {
        return GIG.Tooltip.close(_this.$toolTipElem);
      };
    })(this)), this.hideDelay);
  };

  return ToolTipDelayView;

})(Backbone.View);



},{}],29:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("noDealsMessage",c,p,1),c,p,0,21,251,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	<div class=\"notification info\">");t.b("\n" + i);t.b("	  <div class=\"no-deals-message\">");t.b(t.t(t.f("noDealsMessage",c,p,0)));t.b("</div>");t.b("\n" + i);if(t.s(t.f("noDealsSuggestion",c,p,1),c,p,0,144,218,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	    <div class=\"no-deals-suggestion\">");t.b(t.t(t.f("noDealsSuggestion",c,p,0)));t.b("</div>");t.b("\n" + i);});c.pop();}t.b("	</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# noDealsMessage }}\n\t<div class=\"notification info\">\n\t  <div class=\"no-deals-message\">{{{ noDealsMessage }}}</div>\n\t  {{# noDealsSuggestion }}\n\t    <div class=\"no-deals-suggestion\">{{{ noDealsSuggestion }}}</div>\n\t  {{/ noDealsSuggestion }}\n\t</div>\n{{/ noDealsMessage }}\n", Hogan);
},{"hogan.js":119}],30:[function(require,module,exports){
var HomepageCarousel, carouselIntervalInstance,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

carouselIntervalInstance = null;

module.exports = HomepageCarousel = (function() {
  function HomepageCarousel(arg) {
    var ref, ref1, showSubnavWidget;
    ref = arg != null ? arg : {}, this.carouselConfig = ref.carouselConfig, this.showFreeShippingModal = ref.showFreeShippingModal;
    this._startCarousel = bind(this._startCarousel, this);
    this.widget = $("#carousel-widget");
    this.wrapper = this.widget.find("#carousel-wrapper");
    this.length = this.wrapper.children().length - 1;
    this.index = 0;
    this.advance = true;
    if (this.carouselConfig != null) {
      ref1 = this.carouselConfig, this.carouselInterval = ref1.carouselInterval, this.numOfSlots = ref1.numOfSlots, showSubnavWidget = ref1.showSubnavWidget, this.overlayControls = ref1.overlayControls, this.maxNumOfMenuItems = ref1.maxNumOfMenuItems, this.maxNumOfMenuCols = ref1.maxNumOfMenuCols, this.moreCategoriesId = ref1.moreCategoriesId;
      this.maxNumOfSubnavItems = this.numOfSlots;
      if (showSubnavWidget) {
        this.maxNumOfSubnavItems = this.numOfSlots - 1;
      }
    }
    this.menuItemHeight = 28;
    this.menuTopPadding = 3;
    this.moreCategoriesLabel = I18n.translate('js.modules.home.more_categories');
    if (this.showFreeShippingModal) {
      this._loadFreeShippingModal();
    }
    if ($("#homepage-header").length && $("#homepage-header-temp").length) {
      $("#homepage-header-temp").children().appendTo("#homepage-header");
    }
    if (this.widget.length) {
      if (this._hasNoControls()) {
        $("#homepage-header").addClass('carousel-height-no-controls');
      } else {
        $("#homepage-header").addClass('carousel-height');
      }
    }
    if (this.widget.length) {
      this._initializeCarousel();
      if (!$('html').hasClass('lt-ie9' && this.wrapper.children().length > 1)) {
        carouselIntervalInstance = setTimeout(this._startCarousel, this.carouselInterval);
      }
      this._loadControls();
      this._loadSubnav();
    }
  }

  HomepageCarousel.prototype._hasNoControls = function() {
    return this.wrapper.children().length === 1 || this.overlayControls;
  };

  HomepageCarousel.prototype._initializeCarousel = function() {
    var child, circles;
    child = this.wrapper.children().get(0);
    if (child) {
      $(child).css("opacity", 1).css("display", "block");
    }
    circles = this.widget.find(".icon-circle");
    if (circles.length) {
      $(circles[0]).addClass("selected");
      $(circles[0]).removeClass("c-txt-gray-lt");
      return $(circles[0]).addClass("c-txt-black");
    }
  };

  HomepageCarousel.prototype._startCarousel = function() {
    this._advanceCarousel("right");
    return carouselIntervalInstance = setTimeout(this._startCarousel, this.carouselInterval);
  };

  HomepageCarousel.prototype._advanceCarousel = function(direction) {
    var prevIndex;
    prevIndex = this.index;
    this._incrementIndex(direction);
    if (prevIndex !== this.index) {
      this._showSlide(prevIndex, this.index);
      return this._showCircle(prevIndex, this.index);
    }
  };

  HomepageCarousel.prototype._jumpCarousel = function(from, to) {
    if (from !== to) {
      this._showSlide(from, to);
      this._showCircle(from, to);
      return this.index = to;
    }
  };

  HomepageCarousel.prototype._stopCarousel = function() {
    return carouselIntervalInstance = window.clearInterval(carouselIntervalInstance);
  };

  HomepageCarousel.prototype._incrementIndex = function(direction) {
    if (direction === 'right') {
      this.index += 1;
      if (this.index > this.length) {
        return this.index = 0;
      }
    } else {
      this.index -= 1;
      if (this.index < 0) {
        return this.index = this.length;
      }
    }
  };

  HomepageCarousel.prototype._showSlide = function(from, to) {
    var children;
    if (from !== to) {
      children = this.wrapper.children();
      from = $(children.get(from));
      to = $(children.get(to));
      from.fadeTo('fast', 0);
      to.fadeTo('fast', 1);
      return from.hide();
    }
  };

  HomepageCarousel.prototype._showCircle = function(from, to) {
    var circles;
    if (from !== to) {
      circles = this.widget.find(".icon-circle");
      if (circles.length) {
        $(circles[from]).removeClass("selected");
        $(circles[from]).removeClass("c-txt-black");
        $(circles[to]).addClass("selected");
        $(circles[to]).removeClass("c-txt-gray-lt");
        return $(circles[to]).addClass("c-txt-black");
      }
    }
  };

  HomepageCarousel.prototype._loadFreeShippingModal = function() {
    if (window.GIG) {
      return window.GIG.init();
    }
  };

  HomepageCarousel.prototype._loadControls = function() {
    $('.homepage-carousel-left').on('click', (function(_this) {
      return function(e) {
        _this.advance = false;
        _this._stopCarousel();
        return _this._advanceCarousel('left');
      };
    })(this));
    $('.homepage-carousel-right').on('click', (function(_this) {
      return function(e) {
        _this.advance = false;
        _this._stopCarousel();
        return _this._advanceCarousel('right');
      };
    })(this));
    $('.carousel-item, .nav-bar-item, .menu').on('mouseenter', (function(_this) {
      return function(e) {
        return _this._stopCarousel();
      };
    })(this));
    $('.carousel-item, .nav-bar-item, .menu').on('mouseleave', (function(_this) {
      return function(e) {
        _this._stopCarousel();
        if (_this.advance) {
          return carouselIntervalInstance = setTimeout(_this._startCarousel, _this.carouselInterval);
        }
      };
    })(this));
    return $('.icon-circle').on('click', (function(_this) {
      return function(e) {
        var from, ref, ref1, ref2, to;
        to = parseInt((ref = e.target) != null ? (ref1 = ref.attributes) != null ? (ref2 = ref1.getNamedItem("index")) != null ? ref2.value : void 0 : void 0 : void 0, 10);
        from = _this.index;
        if (from !== to) {
          _this._stopCarousel();
          return _this._jumpCarousel(from, to);
        }
      };
    })(this));
  };

  HomepageCarousel.prototype._numOfCols = function(numOfItems) {
    return Math.ceil(numOfItems / this.maxNumOfMenuItems);
  };

  HomepageCarousel.prototype._numOfItemsPerCol = function(numOfItems, numOfCols) {
    return Math.ceil(numOfItems / numOfCols);
  };

  HomepageCarousel.prototype._flyoutPosition = function(navBarItemPos, numOfItemsPerCol) {
    var pos;
    pos = numOfItemsPerCol <= 1 ? 0 : Math.floor(numOfItemsPerCol / 2) - 1;
    if (pos > navBarItemPos) {
      return navBarItemPos;
    } else {
      return pos;
    }
  };

  HomepageCarousel.prototype._indexStartingFromEnd = function(navBarItemPos) {
    return (this.numOfSlots - 1) - navBarItemPos;
  };

  HomepageCarousel.prototype._calculateMenuTop = function(flyoutPosition) {
    return (this.menuItemHeight * flyoutPosition) + this.menuTopPadding;
  };

  HomepageCarousel.prototype._setMenuTop = function(menu, menuHoverContainer, menuTop) {
    menu.css('top', -menuTop + 'px');
    return menuHoverContainer.css('top', -menuTop + 'px');
  };

  HomepageCarousel.prototype._repositionMenu = function(menu, menuHoverContainer, navBarItemPos, numOfItemsPerCol) {
    var flyoutPosition, menuTop, newFlyoutPos, newNavBarItemPos;
    flyoutPosition = this._flyoutPosition(navBarItemPos, numOfItemsPerCol);
    menuTop = this._calculateMenuTop(flyoutPosition);
    if (navBarItemPos < (this.numOfSlots / 2)) {
      if (flyoutPosition <= navBarItemPos) {
        this._setMenuTop(menu, menuHoverContainer, menuTop);
      }
    } else {
      newFlyoutPos = (numOfItemsPerCol - 1) - flyoutPosition;
      newNavBarItemPos = this._indexStartingFromEnd(navBarItemPos);
      if (newFlyoutPos > newNavBarItemPos) {
        flyoutPosition = (numOfItemsPerCol - 1) - newNavBarItemPos;
        menuTop = this._calculateMenuTop(flyoutPosition);
      }
      this._setMenuTop(menu, menuHoverContainer, menuTop);
    }
    return menu.addClass('flyout-pos' + flyoutPosition);
  };

  HomepageCarousel.prototype._updateMenuWidth = function(menu, numOfCols) {
    if (numOfCols > this.maxNumOfMenuCols) {
      numOfCols = this.maxNumOfMenuCols;
    }
    return menu.addClass('columns-' + numOfCols);
  };

  HomepageCarousel.prototype._createCol = function(colNum, menu, numOfItemsPerCol, menuItems) {
    var colEnd, colStart, column, j, len, menuItem, ref, results;
    menu.append("<div class='menu-column c-bdr-gray-clr'><ul></ul></div>");
    column = menu.find("ul")[colNum];
    colStart = colNum * numOfItemsPerCol;
    colEnd = colStart + numOfItemsPerCol;
    ref = menuItems.slice(colStart, colEnd);
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      menuItem = ref[j];
      results.push($(column).append(menuItem));
    }
    return results;
  };

  HomepageCarousel.prototype._createCols = function(numOfCols, menu, numOfItemsPerCol, menuItems) {
    var i, j, ref, results;
    results = [];
    for (i = j = 0, ref = numOfCols - 1; j <= ref; i = j += 1) {
      if (i === this.maxNumOfMenuCols) {
        break;
      }
      results.push(this._createCol(i, menu, numOfItemsPerCol, menuItems));
    }
    return results;
  };

  HomepageCarousel.prototype._formatMenu = function(navBarItemPos, el) {
    var menu, menuHoverContainer, menuItems, numOfCols, numOfItems, numOfItemsPerCol;
    menu = $(el).find('.menu');
    menuHoverContainer = $(el).find('.menu-hover-container');
    menuItems = menu.find('.menu-item');
    numOfItems = menuItems.length;
    numOfCols = this._numOfCols(numOfItems);
    numOfItemsPerCol = this._numOfItemsPerCol(numOfItems, numOfCols);
    this._repositionMenu(menu, menuHoverContainer, navBarItemPos, numOfItemsPerCol);
    if (numOfItems > this.maxNumOfMenuItems) {
      menu.empty();
      this._updateMenuWidth(menu, numOfCols);
      this._createCols(numOfCols, menu, numOfItemsPerCol, menuItems);
    }
    return menuHoverContainer.height(menu.outerHeight());
  };

  HomepageCarousel.prototype._appendL2Category = function(menu, itemPos, el, menuItems) {
    var bhc, li, navBarLabel, title, url;
    navBarLabel = $(el).find('.nav-bar-label');
    bhc = navBarLabel.attr('data-bhc');
    title = navBarLabel.text().trim();
    url = $(el).find('a').attr('href');
    menu.append("<li class='menu-item' data-bhc='" + bhc + "'><a href='" + url + "'>" + title + "</a></li>");
    li = $(menu.find('li')[itemPos]);
    return menuItems.push(li);
  };

  HomepageCarousel.prototype._moreCategoriesNavBarItem = function(el) {
    var moreCategoriesLabel, moreCategoriesLink;
    $(el).attr('id', this.moreCategoriesId);
    moreCategoriesLink = $(el).find('a')[0];
    $(moreCategoriesLink).removeAttr('href');
    moreCategoriesLabel = $(el).find('.nav-bar-label');
    $(moreCategoriesLabel).attr('data-bhc', 'category:' + this.moreCategoriesId);
    $(moreCategoriesLabel).attr('data-bhc-path', 'LeftNavCategories|category:' + this.moreCategoriesId);
    return $(moreCategoriesLabel).html(this.moreCategoriesLabel);
  };

  HomepageCarousel.prototype._moreCategoriesMenu = function(moreCategories) {
    var i, j, menu, menuHoverContainer, menuItems, numOfCols, numOfItems, numOfItemsPerCol, ref;
    numOfItems = moreCategories.length;
    numOfCols = this._numOfCols(numOfItems);
    numOfItemsPerCol = this._numOfItemsPerCol(numOfItems, numOfCols);
    menu = $('#' + this.moreCategoriesId).find('.menu');
    menuHoverContainer = $('#' + this.moreCategoriesId).find('.menu-hover-container');
    menu.attr('class', 'menu arrow').empty();
    menuItems = [];
    for (i = j = 0, ref = numOfItems - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
      this._appendL2Category(menu, i, moreCategories[i], menuItems);
    }
    this._createCols(numOfCols, menu, numOfItemsPerCol, menuItems);
    return this._repositionMenu(menu, menuHoverContainer, this.maxNumOfSubnavItems - 1, numOfItemsPerCol);
  };

  HomepageCarousel.prototype._loadSubnav = function() {
    var el, hasMoreCategories, i, j, lastl2CategorySlot, len, moreCategories, navBarItems;
    moreCategories = [];
    navBarItems = $('.nav-bar-item');
    lastl2CategorySlot = this.maxNumOfSubnavItems - 1;
    hasMoreCategories = navBarItems.length > this.maxNumOfSubnavItems;
    for (i = j = 0, len = navBarItems.length; j < len; i = ++j) {
      el = navBarItems[i];
      if (hasMoreCategories && i >= lastl2CategorySlot) {
        moreCategories.push($(el).clone());
        if (i === lastl2CategorySlot) {
          this._moreCategoriesNavBarItem(el);
        } else {
          $(el).remove();
        }
      }
      this._formatMenu(i, el);
    }
    if (moreCategories.length > 0) {
      return this._moreCategoriesMenu(moreCategories);
    }
  };

  return HomepageCarousel;

})();



},{}],31:[function(require,module,exports){
var BrowseContentHelper, DealsApplication, DealsGTMHelper, DealsSearchParamsHelper, Page, performSearch, updateSeoPageMetaHash,
  slice = [].slice,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

DealsSearchParamsHelper = require('./helpers/search_params');

DealsGTMHelper = require('./helpers/gtm-update');

BrowseContentHelper = require('../../browse/frontend/helpers/content');

updateSeoPageMetaHash = require('../../seo/frontend/page_meta_updater').updateSeoPageMetaHash;

Page = (function() {
  function Page(pageNumber, data) {
    var paginationData, ref, ref1, ref2, ref3;
    paginationData = data.metadata.pagination || {};
    _.extend(this, {
      clearanceDealsCount: data.clearanceDealsCount,
      countHtml: paginationData.countHtml,
      totalDealCount: paginationData.availableCount,
      bloodhoundHtml: paginationData.bloodhoundHtml,
      deals: (ref = data.dealContent) != null ? ref.deals : void 0,
      dealCount: paginationData.dealsCount,
      dealIdList: ((ref1 = data.metadata) != null ? (ref2 = ref1.pagination) != null ? ref2.dealIdList : void 0 : void 0) || [],
      dealsHtml: data.dealsHtml,
      hasFeaturedDeal: (ref3 = data.dealContent) != null ? ref3.hasFeaturedDeal : void 0,
      featuredHtml: data.featuredHtml,
      carouselHtml: data.carouselHtml,
      topDealsHtml: data.topDealsHtml,
      nextPageSize: paginationData.nextPageSize,
      number: pageNumber,
      totalPages: paginationData.totalPages,
      facets: data.metadata.facets,
      firstDeal: data.metadata.firstDeal,
      startingIndex: paginationData.startingIndex,
      endingIndex: paginationData.endingIndex,
      refinementUiPageData: data.refinementUiPageData,
      cardsHtml: data.cardsHtml,
      seoMetaHash: data.seoMetaHash,
      breadcrumbHash: data.breadcrumbHash
    });
  }

  return Page;

})();

performSearch = function(params) {
  var ref, search;
  if (params == null) {
    params = {};
  }
  if ((ref = this.xhr) != null) {
    ref.abort();
  }
  this.xhr = $.ajax({
    url: '/goods/deals/partial',
    data: params
  });
  search = _.clone(Backbone.Events);
  this.xhr.done(_(search.trigger).bind(search, 'success'));
  this.xhr.fail((function(_this) {
    return function(xhr, textStatus) {
      if (textStatus !== "abort") {
        return search.trigger('error');
      }
    };
  })(this));
  this.xhr.always(function() {
    search.trigger.apply(search, ['complete'].concat(slice.call(arguments)));
    return search.off();
  });
  return {
    on: _(search.once).bind(search)
  };
};

module.exports = DealsApplication = (function() {
  function DealsApplication(options) {
    var dealsSearch;
    if (options == null) {
      options = {};
    }
    this._triggerSuccessHandler = bind(this._triggerSuccessHandler, this);
    this._triggerErrorHandler = bind(this._triggerErrorHandler, this);
    this._events = _.extend({}, Backbone.Events);
    this.params = DealsSearchParamsHelper.getBaseParams(options);
    this._searchedServerSide = false;
    this._pageNumber = isNaN(Number(this.params.page)) ? 1 : Number(this.params.page);
    if (!/^\d+$/.test(this.params.minPrice)) {
      delete this.params.minPrice;
    }
    if (!/^\d+$/.test(this.params.maxPrice)) {
      delete this.params.maxPrice;
    }
    if ((this.params.minPrice != null) && (this.params.maxPrice != null) && parseInt(this.params.minPrice, 10) > parseInt(this.params.maxPrice, 10)) {
      delete this.params.minPrice;
      delete this.params.maxPrice;
    }
    if (!options.pageData) {
      if (options.pageNumber != null) {
        _.extend(this.params, {
          page: options.pageNumber
        });
        this._pageNumber = options.pageNumber;
      }
      this._dealsCount = options.dealsCount;
      this._startingIndex = options.startingIndex;
      dealsSearch = performSearch(this.params);
      dealsSearch.on('error', this._triggerErrorHandler);
      dealsSearch.on('success', this._triggerSuccessHandler);
    } else {
      this.page = new Page(this._pageNumber, options.pageData);
      this._searchedServerSide = true;
      null;
    }
  }

  DealsApplication.prototype.on = function(event, callback) {
    return this._events.on(event, callback);
  };

  DealsApplication.prototype.unfilteredParams = function() {
    return unfilteredParams(this.params);
  };

  DealsApplication.prototype.getPageNumber = function() {
    var ref;
    return ((ref = this.page) != null ? ref.number : void 0) || this._pageNumber;
  };

  DealsApplication.prototype.getDealsCount = function() {
    var ref;
    return ((ref = this.page) != null ? ref.dealCount : void 0) || this._dealsCount;
  };

  DealsApplication.prototype.getDealAt = function(index) {
    var deals, ref, selectIndex;
    if (!((this.page != null) && (ref = this.page, deals = ref.deals, ref))) {
      return {};
    }
    selectIndex = this.page.hasFeaturedDeal ? Math.max(0, index - 1) : index;
    return {
      deal: deals[selectIndex],
      index: selectIndex
    };
  };

  DealsApplication.prototype.getStartingIndex = function() {
    var ref;
    return ((ref = this.page) != null ? ref.startingIndex : void 0) || this._startingIndex;
  };

  DealsApplication.prototype.nextPage = function() {
    return new this.constructor({
      params: this.params,
      pageNumber: this._pageNumber + 1
    });
  };

  DealsApplication.prototype._triggerErrorHandler = function() {
    var resetButton;
    if (Groupon.categoryAttributeWhitelistRemoval && Groupon.browseApp.lastUpdatedRefinementId === 'category' && (resetButton = $('#clear-module')).is(':visible')) {
      return resetButton.click();
    } else {
      this._events.trigger('error');
      return this._events.stopListening();
    }
  };

  DealsApplication.prototype._triggerSuccessHandler = function(arg, textStatus) {
    var deals, ref, ref1, seoMetaHash;
    deals = (arg != null ? arg : {}).deals;
    if (textStatus !== 'success') {
      return this._triggerErrorHandler();
    } else {
      this.page = new Page(this._pageNumber, deals);
      Groupon.pagination = (ref = deals.metadata) != null ? ref.pagination : void 0;
      this._events.trigger('success', deals);
      this._events.stopListening();
      if (this.params) {
        DealsGTMHelper.update(this.params);
      }
      if (((ref1 = Groupon.enabledFeatures) != null ? ref1.isSEOMetadataEnabled : void 0) && (seoMetaHash = this.page.seoMetaHash)) {
        return updateSeoPageMetaHash(seoMetaHash);
      }
    }
  };

  DealsApplication.prototype.isEmptySearch = function() {
    var ref;
    return ((ref = this.page) != null ? ref.totalDealCount : void 0) === 0;
  };

  DealsApplication.prototype.isSearchedServerSide = function() {
    return this._searchedServerSide;
  };

  return DealsApplication;

})();



},{"../../browse/frontend/helpers/content":15,"../../seo/frontend/page_meta_updater":48,"./helpers/gtm-update":32,"./helpers/search_params":35}],32:[function(require,module,exports){
var DealsGTMHelper;

module.exports = DealsGTMHelper = {
  update: function(params) {
    var category2, category3, dlUpdate;
    category2 = params.category2, category3 = params.category3;
    if (window.dataLayer != null) {
      dlUpdate = {
        event: 'cat-nav'
      };
      window.dataLayer.push(['dl_categories.splice', 1, 2]);
      dlUpdate.dl_category_sub = category2 || '';
      if (category2 != null) {
        window.dataLayer.push(['dl_categories.push', category2]);
      }
      if (category3 != null) {
        window.dataLayer.push(['dl_categories.push', category3]);
      }
      return window.dataLayer.push(dlUpdate);
    }
  }
};



},{}],33:[function(require,module,exports){
var DealsApplication, PaginatedDealsBuilder,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

DealsApplication = require('../application');

module.exports = PaginatedDealsBuilder = (function() {
  function PaginatedDealsBuilder(arg) {
    this.omitSearch = (arg != null ? arg : {}).omitSearch;
    this.triggerFetchSuccess = bind(this.triggerFetchSuccess, this);
    this.triggerFetchError = bind(this.triggerFetchError, this);
    this.events = _.clone(Backbone.Events);
    this.search = new DealsApplication(this._searchOptions());
    this.search.on('error', this.triggerFetchError);
    this.search.on('success', this.triggerFetchSuccess);
  }

  PaginatedDealsBuilder.prototype._searchOptions = function() {
    if (Groupon.onNoDealsPage) {
      return {
        unfiltered: true
      };
    } else {
      return _.omitUndefined({
        omitSearch: this.omitSearch
      });
    }
  };

  PaginatedDealsBuilder.prototype.triggerFetchError = function() {
    this.events.trigger('fetchError');
    return this.events.stopListening();
  };

  PaginatedDealsBuilder.prototype.triggerFetchSuccess = function() {
    return $((function(_this) {
      return function() {
        _this.events.trigger('fetchSuccess', _this.search);
        return _this.events.stopListening();
      };
    })(this));
  };

  PaginatedDealsBuilder.prototype.on = function() {
    var ref;
    return (ref = this.events).on.apply(ref, arguments);
  };

  return PaginatedDealsBuilder;

})();



},{"../application":31}],34:[function(require,module,exports){
var DealsPaginationEvents, DealsPaginationEventsHelper, PaginatedDealsBuilder, UpdateAppURLHelper, fetchAndRenderDeals, sendPaginationEvent, updateURLAndFetch;

UpdateAppURLHelper = require('../../../shared/frontend/helpers/app_url');

PaginatedDealsBuilder = require('./paginated_deals_builder');

DealsPaginationEvents = require('../pagination_events');

module.exports = DealsPaginationEventsHelper = {
  updatePageByHref: function(url, shouldScroll) {
    if (shouldScroll == null) {
      shouldScroll = true;
    }
    return updateURLAndFetch(url, shouldScroll);
  },
  updateToPreviousPage: function(shouldScroll) {
    var qs, queryString, url;
    if (shouldScroll == null) {
      shouldScroll = true;
    }
    qs = Groupon.Utils.unparam();
    if (!(qs.page > 1)) {
      return;
    }
    qs.page--;
    if (qs.page <= 1) {
      delete qs.page;
    }
    queryString = !_.isEmpty(qs) ? "?" + ($.param(qs)) : "";
    url = "" + window.location.pathname + queryString;
    return updateURLAndFetch(url, shouldScroll);
  },
  updateToNextPage: function(shouldScroll) {
    var qs, url;
    if (shouldScroll == null) {
      shouldScroll = true;
    }
    qs = Groupon.Utils.unparam();
    if (qs.page != null) {
      qs.page++;
    } else {
      qs.page = 2;
    }
    if (qs.page > Groupon.pagination.totalPages) {
      return;
    }
    url = window.location.pathname + "?" + ($.param(qs));
    return updateURLAndFetch(url, shouldScroll);
  },
  popStateHandler: function(currentSearchPage) {
    var popStatePage, ref;
    popStatePage = (ref = Groupon.Utils.unparam().page) != null ? ref : 1;
    if (currentSearchPage !== popStatePage) {
      return fetchAndRenderDeals();
    }
  }
};

updateURLAndFetch = function(url, shouldScroll) {
  UpdateAppURLHelper(url, {
    pushState: true
  });
  if (shouldScroll) {
    $(document).scrollTop(0);
  }
  return fetchAndRenderDeals();
};

fetchAndRenderDeals = function() {
  var paginatedBuilder;
  paginatedBuilder = new PaginatedDealsBuilder;
  Groupon.browseApp.renderContent({
    paginatedDealsBuilder: paginatedBuilder
  });
  return paginatedBuilder.on("fetchSuccess", function(search) {
    return sendPaginationEvent(search);
  });
};

sendPaginationEvent = function(dealSearch) {
  return DealsPaginationEvents.trigger("newPage", dealSearch.page);
};



},{"../../../shared/frontend/helpers/app_url":52,"../pagination_events":37,"./paginated_deals_builder":33}],35:[function(require,module,exports){
var BrowseParsedParamsHelper, DealsSearchParamsHelper, getFacetGroupFiltersParam, initializeParams, unfilteredParams;

BrowseParsedParamsHelper = require('../../../browse/frontend/helpers/parsed_params');

module.exports = DealsSearchParamsHelper = {
  getBaseParams: function(options) {
    var params, ref, ref1;
    if (options == null) {
      options = {};
    }
    params = initializeParams(options);
    params.division = Cookie.get('division');
    params.facet_group_filters = getFacetGroupFiltersParam(options);
    if ((ref = Groupon.RefinementBar) != null ? ref.isLeftBarVisible : void 0) {
      params.isRefinementBarDisplayed = true;
    }
    params.isSeoEnabled = Groupon.isSeoEnabled;
    params.collectionType = (ref1 = Groupon.collection) != null ? ref1.type : void 0;
    if (params.category == null) {
      params.category = 'all';
    }
    if (Groupon.isSeoEnabled) {
      _.extend(params, BrowseParsedParamsHelper.getParsedParams());
    }
    if (options.omitSearch) {
      delete params.query;
    }
    if (params.collectionType) {
      params.query = Groupon.collection.id;
    }
    return params;
  }
};

initializeParams = function(options) {
  var parsedParams;
  if (options.params != null) {
    return _.clone(options.params);
  }
  parsedParams = Groupon.Utils.unparam();
  if (options.unfiltered) {
    return unfilteredParams(parsedParams);
  }
  return parsedParams;
};

unfilteredParams = function(params) {
  return _.pick(params, 'page', 'sort');
};

getFacetGroupFiltersParam = function(options) {
  if (options.facet_group_filters != null) {
    return options.facet_group_filters;
  } else if (!Groupon.refinementUiPageData) {
    if (Groupon.inRAPI) {
      return 'topcategory|category|subcategory|subcategory2,deal_type';
    } else {
      return 'topcategory|category|category2|category3;deal_type;city|neighborhood';
    }
  }
};



},{"../../../browse/frontend/helpers/parsed_params":17}],36:[function(require,module,exports){
var DealsMmSearch, HomepageCarousel, performSearch,
  slice = [].slice,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

HomepageCarousel = require('../../carousel/frontend/carousel');

performSearch = function(params) {
  var ref, search;
  if (params == null) {
    params = {};
  }
  if ((ref = this.xhr) != null) {
    ref.abort();
  }
  this.xhr = $.ajax({
    url: '/goods/deals/megamindhome',
    data: params
  });
  search = _.clone(Backbone.Events);
  this.xhr.done(_(search.trigger).bind(search, 'success'));
  this.xhr.fail((function(_this) {
    return function(xhr, textStatus) {
      if (!textStatus === "abort") {
        return _(search.trigger).bind(search, 'error');
      }
    };
  })(this));
  this.xhr.always(function() {
    search.trigger.apply(search, ['complete'].concat(slice.call(arguments)));
    return search.off();
  });
  return {
    on: _(search.once).bind(search)
  };
};

module.exports = DealsMmSearch = (function() {
  function DealsMmSearch(options) {
    var datetime, dealsSearch, megamindPreview, ref;
    if (options == null) {
      options = {};
    }
    this._triggerSuccessHandler = bind(this._triggerSuccessHandler, this);
    this._triggerErrorHandler = bind(this._triggerErrorHandler, this);
    this._events = _.extend({}, Backbone.Events);
    this.inNewHomepage = options.inNewHomepage, this.carouselConfig = options.carouselConfig, this.homeWidgetPreview = options.homeWidgetPreview, this.showFreeShippingModal = options.showFreeShippingModal;
    if (this.homeWidgetPreview) {
      ref = this.homeWidgetPreview, datetime = ref.datetime, megamindPreview = ref.megamindPreview;
    }
    if (datetime && megamindPreview) {
      this.params = {
        datetime: datetime,
        megamindPreview: megamindPreview
      };
    }
    dealsSearch = performSearch(this.params);
    dealsSearch.on('error', this._triggerErrorHandler);
    dealsSearch.on('success', this._triggerSuccessHandler);
    null;
  }

  DealsMmSearch.prototype.on = function(event, callback) {
    return this._events.on(event, callback);
  };

  DealsMmSearch.prototype._triggerErrorHandler = function() {
    this._events.trigger('error');
    return this._events.stopListening();
  };

  DealsMmSearch.prototype._triggerSuccessHandler = function(arg, textStatus) {
    var dealIdList, deals, ref;
    ref = arg != null ? arg : {}, deals = ref.deals, dealIdList = ref.dealIdList;
    if (textStatus !== 'success') {
      return this._triggerErrorHandler();
    } else {
      this._events.trigger('success', deals, dealIdList);
      Groupon.Utils.lazyLoadImages();
      if (this.inNewHomepage) {
        new HomepageCarousel({
          carouselConfig: this.carouselConfig,
          showFreeShippingModal: this.showFreeShippingModal
        });
      }
      return this._events.stopListening();
    }
  };

  return DealsMmSearch;

})();



},{"../../carousel/frontend/carousel":30}],37:[function(require,module,exports){
var Backbone, DealsPaginationEvents;

Backbone = require('backbone');

module.exports = DealsPaginationEvents = _.extend({}, Backbone.Events);



},{"backbone":55}],38:[function(require,module,exports){
var DealsPaginationEventsHelper, DealsPaginationFooterView, PaginatedDealsListTemplate, PaginatedDealsListView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

DealsPaginationFooterView = require('./pagination_footer');

DealsPaginationEventsHelper = require('../helpers/pagination_events');

PaginatedDealsListTemplate = require('../../paginated_deals_list.html.mustache');

module.exports = PaginatedDealsListView = (function() {
  PaginatedDealsListView.prototype.template = PaginatedDealsListTemplate;

  PaginatedDealsListView.prototype.dealsListId = 'browse-deals';

  function PaginatedDealsListView($el, dealSearch) {
    var currentSearchPage, ref;
    this.$el = $el;
    this.dealSearch = dealSearch;
    this.searchError = bind(this.searchError, this);
    this.searchSuccess = bind(this.searchSuccess, this);
    this.$content = this.$el.find('.content');
    this.prevSearch = null;
    this.footer = new DealsPaginationFooterView();
    this.footer.on('click:paginationLink', this.paginationClickHandler);
    currentSearchPage = (ref = this.dealSearch.params.page) != null ? ref : 1;
    window.onpopstate = _.partial(DealsPaginationEventsHelper.popStateHandler, currentSearchPage);
  }

  PaginatedDealsListView.prototype.render = function() {
    if (this.dealSearch.isEmptySearch()) {
      return;
    }
    this.$content.html(this.toHtml());
    this.postRender();
    return Groupon.BrowseTracking.pageReady();
  };

  PaginatedDealsListView.prototype.postRender = function(overwriteExisting) {
    var element, options;
    if (overwriteExisting == null) {
      overwriteExisting = true;
    }
    this.footer.updatePresenter(this.dealSearch).setElement(this.$el.find('.pagination_footer'));
    if (overwriteExisting) {
      this.footer.render();
    }
    GIG.Utils.truncateElements(element = this.$content, options = {
      watch: false
    });
    return GIG.Tooltip.reloadBindings(element = this.$content, false);
  };

  PaginatedDealsListView.prototype.toHtml = function() {
    return this.template.render(this.present());
  };

  PaginatedDealsListView.prototype.present = function() {
    var hash;
    hash = _.extend({}, this.dealSearch.page, {
      dealsListId: this.dealsListId,
      columnLayoutClass: Groupon.columnLayoutClass,
      cardUIClass: Groupon.cardUIClass
    });
    return hash;
  };

  PaginatedDealsListView.prototype.searchSuccess = function() {
    this.$content.find("#" + this.dealsListId).append(this.dealSearch.page.dealsHtml);
    return this.postRender();
  };

  PaginatedDealsListView.prototype.searchError = function() {
    this.dealSearch = this.prevSearch;
    this.footer.removeLoadingState();
    return this.$el.find('.pagination_footer').remove();
  };

  PaginatedDealsListView.prototype.paginationClickHandler = function(event) {
    return DealsPaginationEventsHelper.updatePageByHref(event.target.href);
  };

  return PaginatedDealsListView;

})();



},{"../../paginated_deals_list.html.mustache":40,"../helpers/pagination_events":34,"./pagination_footer":39}],39:[function(require,module,exports){
var BrowsePaginationFooterPresenter, DealsPaginationFooterTemplate, DealsPaginationFooterView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

BrowsePaginationFooterPresenter = require('../../../browse/common/presenters/pagination_footer');

DealsPaginationFooterTemplate = require('../../pagination_footer.html.mustache');

module.exports = DealsPaginationFooterView = (function(superClass) {
  extend(DealsPaginationFooterView, superClass);

  function DealsPaginationFooterView() {
    this.paginationClickHandler = bind(this.paginationClickHandler, this);
    return DealsPaginationFooterView.__super__.constructor.apply(this, arguments);
  }

  DealsPaginationFooterView.prototype.template = DealsPaginationFooterTemplate;

  DealsPaginationFooterView.prototype.events = {
    'click .pagination a': 'paginationClickHandler'
  };

  DealsPaginationFooterView.prototype.initialize = function() {
    if (this.fetchedDealCount == null) {
      this.fetchedDealCount = 0;
    }
    return this.presenter = null;
  };

  DealsPaginationFooterView.prototype.updatePresenter = function(dealSearch) {
    var dealCount, endingIndex, nextPageSize, number, page, paginationFooter, startingIndex, totalDealCount, totalPages;
    page = dealSearch.page;
    number = page.number, totalPages = page.totalPages, dealCount = page.dealCount, nextPageSize = page.nextPageSize, totalDealCount = page.totalDealCount, startingIndex = page.startingIndex, endingIndex = page.endingIndex;
    this.fetchedDealCount += dealCount;
    paginationFooter = _.extend({}, BrowsePaginationFooterPresenter.toHash({
      requestURL: window.location.pathname,
      query: Groupon.Utils.unparam(),
      currentPageNumber: number,
      totalPages: totalPages,
      nextPageSize: nextPageSize,
      fetchedDealCount: this.fetchedDealCount,
      totalDealCount: totalDealCount,
      startingIndex: startingIndex,
      endingIndex: endingIndex
    }, Groupon.expandingPaginationEnabled, {
      I18n: I18n
    }, true));
    this.presenter = {
      paginationFooter: paginationFooter
    };
    return this;
  };

  DealsPaginationFooterView.prototype.render = function() {
    return this.$el.html(this.toHtml());
  };

  DealsPaginationFooterView.prototype.toHtml = function() {
    return this.template.render(this.presenter);
  };

  DealsPaginationFooterView.prototype.removeLoadingState = function() {
    return $('.pagination button').removeClass('loading');
  };

  DealsPaginationFooterView.prototype.paginationClickHandler = function(event) {
    event.preventDefault();
    return this.trigger('click:paginationLink', event);
  };

  return DealsPaginationFooterView;

})(Backbone.View);



},{"../../../browse/common/presenters/pagination_footer":12,"../../pagination_footer.html.mustache":41}],40:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("cardsHtml",c,p,1),c,p,0,16,139,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div id=\"");t.b(t.v(t.f("dealsListId",c,p,0)));t.b("\" data-bhw=\"BrowseDeals\" class=\"block-grid ");t.b(t.v(t.f("cardUIClass",c,p,0)));t.b("\">");t.b("\n" + i);t.b("    ");t.b(t.t(t.f("cardsHtml",c,p,0)));t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(!t.s(t.f("cardsHtml",c,p,1),c,p,1,0,0,"")){t.b("  ");t.b(t.t(t.f("carouselHtml",c,p,0)));t.b("\n" + i);t.b("  ");t.b(t.t(t.f("topDealsHtml",c,p,0)));t.b("\n" + i);t.b("  ");t.b(t.t(t.f("featuredHtml",c,p,0)));t.b("\n");t.b("\n" + i);t.b("  <div id=\"");t.b(t.v(t.f("dealsListId",c,p,0)));t.b("\" data-bhw=\"BrowseDeals\" class=\"block-grid browse-deals ");t.b(t.v(t.f("columnLayoutClass",c,p,0)));t.b("\">");t.b("\n" + i);t.b("    ");t.b(t.t(t.f("dealsHtml",c,p,0)));t.b("\n" + i);t.b("  </div>");t.b("\n" + i);};t.b("\n" + i);t.b("<div class=\"pagination_footer\"></div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{# cardsHtml }}\n  <div id=\"{{ dealsListId }}\" data-bhw=\"BrowseDeals\" class=\"block-grid {{ cardUIClass }}\">\n    {{{ cardsHtml }}}\n  </div>\n{{/ cardsHtml }}\n\n{{^ cardsHtml }}\n  {{{ carouselHtml }}}\n  {{{ topDealsHtml }}}\n  {{{ featuredHtml }}}\n\n  <div id=\"{{ dealsListId }}\" data-bhw=\"BrowseDeals\" class=\"block-grid browse-deals {{ columnLayoutClass }}\">\n    {{{ dealsHtml }}}\n  </div>\n{{/ cardsHtml }}\n\n<div class=\"pagination_footer\"></div>\n", Hogan);
},{"hogan.js":119}],41:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("paginationFooter",c,p,1),c,p,0,23,1648,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("displayPagination",c,p,1),c,p,0,50,1623,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"pagination\" data-bhw=\"BrowsePaginationLinks\">");t.b("\n" + i);t.b("      <ul class=\"pagination_links");if(t.s(t.f("expandingPagination",c,p,1),c,p,0,172,193,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" expanding-pagination");});c.pop();}t.b("\">");t.b("\n" + i);t.b("        <li class=\"c-txt-gray-md\">");t.b("\n" + i);if(t.s(t.f("previousPageUrl",c,p,1),c,p,0,289,483,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <a href=\"");t.b(t.v(t.f("previousPageUrl",c,p,0)));t.b("\" class=\"previous");if(t.s(t.f("expandingPagination",c,p,1),c,p,0,375,397,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" c-bg-prim c-txt-white");});c.pop();}t.b("\" data-bhc=\"page:previous\">");t.b(t.v(t.f("previousPage",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("previousPageUrl",c,p,1),c,p,1,0,0,"")){t.b("            <span class=\"previous\">");t.b(t.v(t.f("previousPage",c,p,0)));t.b("</span>");t.b("\n" + i);};t.b("        </li>");t.b("\n" + i);if(t.s(t.f("paginationSlots",c,p,1),c,p,0,677,1124,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <li ");if(t.s(t.f("box",c,p,1),c,p,0,702,877,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("class=\"box");if(!t.s(t.f("expandingPagination",c,p,1),c,p,1,0,0,"")){t.b(" c-bdr-gray-lt c-bg-gray-bg");};if(t.s(t.f("expandingPagination",c,p,1),c,p,0,817,850,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" c-txt-prim c-bdr-prim c-bg-white");});c.pop();}t.b("\"");});c.pop();}t.b(">");t.b("\n" + i);t.b("            ");if(t.s(t.f("url",c,p,1),c,p,0,911,1046,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<a href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\" class=\"");if(t.s(t.f("expandingPagination",c,p,1),c,p,0,964,977,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("c-txt-gray-dk");});c.pop();}t.b("\" data-bhc=\"page:");t.b(t.v(t.f("text",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</a>");});c.pop();}t.b("\n" + i);t.b("            ");if(!t.s(t.f("url",c,p,1),c,p,1,0,0,"")){t.b(t.v(t.f("text",c,p,0)));};t.b("\n" + i);t.b("          </li>");t.b("\n" + i);});c.pop();}t.b("\n" + i);t.b("        <li class=\"c-txt-gray-md\">");t.b("\n" + i);if(t.s(t.f("nextPageUrl",c,p,1),c,p,0,1211,1389,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <a href=\"");t.b(t.v(t.f("nextPageUrl",c,p,0)));t.b("\" class=\"next");if(t.s(t.f("expandingPagination",c,p,1),c,p,0,1289,1311,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" c-bg-prim c-txt-white");});c.pop();}t.b("\" data-bhc=\"page:next\">");t.b(t.v(t.f("nextPage",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("nextPageUrl",c,p,1),c,p,1,0,0,"")){t.b("            <span class=\"next\">");t.b(t.v(t.f("nextPage",c,p,0)));t.b("</span>");t.b("\n" + i);};t.b("        </li>");t.b("\n" + i);t.b("      </ul>");t.b("\n" + i);t.b("      <p class='results'>");t.b("\n" + i);t.b("        ");t.b(t.t(t.f("resultsHtml",c,p,0)));t.b("\n" + i);t.b("      </p>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# paginationFooter }}\n  {{# displayPagination }}\n    <div class=\"pagination\" data-bhw=\"BrowsePaginationLinks\">\n      <ul class=\"pagination_links{{# expandingPagination }} expanding-pagination{{/ expandingPagination }}\">\n        <li class=\"c-txt-gray-md\">\n          {{# previousPageUrl }}\n            <a href=\"{{ previousPageUrl }}\" class=\"previous{{# expandingPagination }} c-bg-prim c-txt-white{{/ expandingPagination }}\" data-bhc=\"page:previous\">{{ previousPage }}</a>\n          {{/ previousPageUrl }}\n          {{^ previousPageUrl }}\n            <span class=\"previous\">{{ previousPage }}</span>\n          {{/ previousPageUrl }}\n        </li>\n        {{# paginationSlots }}\n          <li {{# box }}class=\"box{{^ expandingPagination }} c-bdr-gray-lt c-bg-gray-bg{{/ expandingPagination }}{{# expandingPagination }} c-txt-prim c-bdr-prim c-bg-white{{/ expandingPagination }}\"{{/ box }}>\n            {{# url }}<a href=\"{{ url }}\" class=\"{{# expandingPagination }}c-txt-gray-dk{{/ expandingPagination }}\" data-bhc=\"page:{{ text }}\">{{ text }}</a>{{/ url }}\n            {{^ url }}{{ text }}{{/ url }}\n          </li>\n        {{/ paginationSlots }}\n\n        <li class=\"c-txt-gray-md\">\n          {{# nextPageUrl }}\n            <a href=\"{{ nextPageUrl }}\" class=\"next{{# expandingPagination }} c-bg-prim c-txt-white{{/ expandingPagination }}\" data-bhc=\"page:next\">{{ nextPage }}</a>\n          {{/ nextPageUrl }}\n          {{^ nextPageUrl }}\n            <span class=\"next\">{{ nextPage }}</span>\n          {{/ nextPageUrl }}\n        </li>\n      </ul>\n      <p class='results'>\n        {{{ resultsHtml }}}\n      </p>\n    </div>\n  {{/ displayPagination }}\n{{/ paginationFooter }}\n", Hogan);
},{"hogan.js":119}],42:[function(require,module,exports){
(function (global){
var Application, Backbone, SORT_TOGGLE_SELECTOR, SortToggleView, _, ref, ref1;

Backbone = (ref = typeof window !== "undefined" && window !== null ? window.Backbone : void 0) != null ? ref : require('backbone');

_ = (ref1 = typeof window !== "undefined" && window !== null ? window._ : void 0) != null ? ref1 : (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

SORT_TOGGLE_SELECTOR = '#grpn-sorts-select';

SortToggleView = void 0;

Application = _.extend({}, Backbone.Events, {
  initialize: function() {
    this._createModelsAndViews();
    return this._addListeners();
  },
  _createModelsAndViews: function() {
    var ref2, ref3, ref4;
    if (SortToggleView == null) {
      SortToggleView = (ref2 = typeof Modules !== "undefined" && Modules !== null ? (ref3 = Modules.SortToggle) != null ? (ref4 = ref3.Views) != null ? ref4.SortToggle : void 0 : void 0 : void 0) != null ? ref2 : require('./views/sort_toggle');
    }
    return this.sortToggleView = new SortToggleView({
      el: SORT_TOGGLE_SELECTOR
    });
  },
  _addListeners: function() {
    return this.listenTo(this.sortToggleView, 'change:value', function(event) {
      return this.trigger('change:sort', event);
    });
  }
});

if (typeof module !== "undefined" && module !== null ? module.exports : void 0) {
  module.exports = Application;
} else {
  Modules.SortToggle.Application = Application;
}


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./views/sort_toggle":43,"backbone":55}],43:[function(require,module,exports){
var Backbone, SortToggleView, ref,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = (ref = typeof window !== "undefined" && window !== null ? window.Backbone : void 0) != null ? ref : require('backbone');

SortToggleView = (function(superClass) {
  extend(SortToggleView, superClass);

  function SortToggleView() {
    return SortToggleView.__super__.constructor.apply(this, arguments);
  }

  SortToggleView.prototype.events = {
    'change': '_onChange'
  };

  SortToggleView.prototype._onChange = function() {
    return this.trigger('change:value', {
      sort: this.$el.val()
    });
  };

  return SortToggleView;

})(Backbone.View);

if (typeof module !== "undefined" && module !== null ? module.exports : void 0) {
  module.exports = SortToggleView;
} else {
  Modules.SortToggle.Views.SortToggle = SortToggleView;
}



},{"backbone":55}],44:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("titleHeading",c,p,1),c,p,0,19,243,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  ");if(t.s(t.f("pageTitleBhc",c,p,1),c,p,0,41,75,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span data-bhc=\"");t.b(t.v(t.f("pageTitleBhc",c,p,0)));t.b("\">");});c.pop();}t.b("\n" + i);t.b("    ");if(t.s(t.f("pageTitle",c,p,1),c,p,0,115,130,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.v(t.f("pageTitle",c,p,0)));});c.pop();}t.b("\n" + i);t.b("    ");if(!t.s(t.f("pageTitle",c,p,1),c,p,1,0,0,"")){t.b(t.v(t.f("title",c,p,0)));};t.b("\n" + i);t.b("  ");if(t.s(t.f("pageTitleBhc",c,p,1),c,p,0,216,223,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("</span>");});c.pop();}t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# titleHeading }}\n  {{# pageTitleBhc }}<span data-bhc=\"{{pageTitleBhc}}\">{{/ pageTitleBhc }}\n    {{# pageTitle }}{{ pageTitle }}{{/ pageTitle }}\n    {{^ pageTitle }}{{ title }}{{/ pageTitle }}\n  {{# pageTitleBhc }}</span>{{/ pageTitleBhc }}\n{{/ titleHeading }}\n", Hogan);
},{"hogan.js":119}],45:[function(require,module,exports){
var RefinementContextLogger, RefinementContextLoggerDesktop,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

RefinementContextLogger = require('./rcl');

RefinementContextLoggerDesktop = (function(superClass) {
  var dealsSearch, paginatedDealsBuilder, selectors, sortsApp;

  extend(RefinementContextLoggerDesktop, superClass);

  function RefinementContextLoggerDesktop() {
    return RefinementContextLoggerDesktop.__super__.constructor.apply(this, arguments);
  }

  sortsApp = void 0;

  dealsSearch = void 0;

  paginatedDealsBuilder = void 0;

  selectors = {
    CARD: '.card-ui',
    PAGE_CURRENT: '.pagination_links li.box',
    PAGE_DEALCOUNT: '.pagination .results',
    SORTS_DROPDOWN: '#grpn-sorts-select'
  };

  RefinementContextLoggerDesktop.prototype.events = {
    'click .card-ui a': '_addLoggerEvent'
  };

  RefinementContextLoggerDesktop.prototype.initialize = function(config) {
    RefinementContextLoggerDesktop.__super__.initialize.call(this, config);
    return this.refinementUIAppInstance = config.refinementUIAppInstance, config;
  };

  RefinementContextLoggerDesktop.prototype.setSortsApp = function(sorts) {
    return sortsApp != null ? sortsApp : sortsApp = sorts;
  };

  RefinementContextLoggerDesktop.prototype.setDealsSearch = function(search) {
    return dealsSearch = search;
  };

  RefinementContextLoggerDesktop.prototype.setPaginatedDealsBuilder = function(paginatedBuilder) {
    return paginatedDealsBuilder = paginatedBuilder;
  };

  RefinementContextLoggerDesktop.prototype._getDealAt = function(index) {
    if (paginatedDealsBuilder != null) {
      return paginatedDealsBuilder.search.getDealAt(index);
    }
    if (dealsSearch != null) {
      return dealsSearch.getDealAt(index);
    }
    return {};
  };

  RefinementContextLoggerDesktop.prototype._addLoggerEvent = function(event) {
    var deal, index, ref;
    if (this._logDealAndCard) {
      ref = this._getDealAt($(event.currentTarget).parent(selectors.CARD).index()), deal = ref.deal, index = ref.index;
      this._currentDeal = deal;
      this._currentIndex = index + 1;
    }
    return RefinementContextLoggerDesktop.__super__._addLoggerEvent.call(this, event);
  };

  RefinementContextLoggerDesktop.prototype._getEventMeta = function(event) {
    var eventDetails;
    eventDetails = RefinementContextLoggerDesktop.__super__._getEventMeta.call(this, event);
    eventDetails.pagination.offset = this._getOffset();
    eventDetails.pagination.count = this._getDealsCount();
    return eventDetails;
  };

  RefinementContextLoggerDesktop.prototype._getSort = function() {
    if ((sortsApp != null ? sortsApp.sortToggleView : void 0) != null) {
      return sortsApp.sortToggleView.$el.val();
    }
    return this.$el.find(selectors.SORTS_DROPDOWN).val();
  };

  RefinementContextLoggerDesktop.prototype._getDealId = function() {
    return this._currentDeal.permalink;
  };

  RefinementContextLoggerDesktop.prototype._getDealUuid = function() {
    return this._currentDeal.uuid;
  };

  RefinementContextLoggerDesktop.prototype._getDealHref = function() {
    return this._currentDeal.dealShowUrl;
  };

  RefinementContextLoggerDesktop.prototype._getDealCategorization = function() {
    return this._currentDeal.categorization;
  };

  RefinementContextLoggerDesktop.prototype._getDealReviewInfo = function() {
    var productReviews, ratingCount;
    productReviews = this._currentDeal.productReviews;
    if (productReviews == null) {
      return;
    }
    ratingCount = productReviews.ratingCount || {};
    return {
      averageRating: ratingCount.averageRating || 0,
      ratingCount: ratingCount.countNumber || 0,
      reviewCount: productReviews.reviewCount || 0
    };
  };

  RefinementContextLoggerDesktop.prototype._getCardPosition = function() {
    return this._currentIndex;
  };

  RefinementContextLoggerDesktop.prototype._getCategoryHierarchy = function() {
    var categoryLogEntry, currentCategory, currentDepth, ref, ref1, selectedRefinements;
    selectedRefinements = (ref = this.refinementUIAppInstance) != null ? ref.selectedRefinements : void 0;
    currentCategory = selectedRefinements != null ? selectedRefinements.category.selectedValues[0] : void 0;
    categoryLogEntry = RefinementContextLoggerDesktop.__super__._getCategoryHierarchy.call(this);
    while (currentCategory != null) {
      categoryLogEntry.id = currentCategory.name;
      currentDepth = ++categoryLogEntry.level;
      categoryLogEntry["category" + currentDepth] = currentCategory.name;
      currentCategory = (ref1 = currentCategory.selectedValues) != null ? ref1[0] : void 0;
    }
    return categoryLogEntry;
  };

  RefinementContextLoggerDesktop.prototype._getCurrentPageNumber = function() {
    if (paginatedDealsBuilder != null) {
      return paginatedDealsBuilder.search.getPageNumber();
    }
    if (dealsSearch != null) {
      return dealsSearch.getPageNumber();
    }
    return parseInt(this.$el.find(selectors.PAGE_CURRENT).text(), 10);
  };

  RefinementContextLoggerDesktop.prototype._getOffset = function() {
    if (paginatedDealsBuilder != null) {
      return paginatedDealsBuilder.search.getStartingIndex();
    }
    if (dealsSearch != null) {
      return dealsSearch.getStartingIndex();
    }
    return parseInt(this.$el.find(selectors.PAGE_DEALCOUNT).text(), 10);
  };

  RefinementContextLoggerDesktop.prototype._getDealsCount = function() {
    var range;
    if (paginatedDealsBuilder != null) {
      return paginatedDealsBuilder.search.getDealsCount();
    }
    if (dealsSearch != null) {
      return dealsSearch.getDealsCount();
    }
    range = this.$el.find(selectors.PAGE_DEALCOUNT).text().split(' of')[0].trim().split(' - ');
    return range[1] - range[0] + 1;
  };

  RefinementContextLoggerDesktop.prototype._getRefinements = function() {
    var friendlyNameShort, i, len, name, ref, ref1, refinementKey, refinementList, selectedRefinements, selectedValues;
    refinementList = RefinementContextLoggerDesktop.__super__._getRefinements.call(this);
    selectedRefinements = (ref = this.refinementUIAppInstance) != null ? ref.selectedRefinements : void 0;
    for (refinementKey in selectedRefinements) {
      selectedValues = selectedRefinements[refinementKey].selectedValues;
      if (refinementKey !== 'category') {
        for (i = 0, len = selectedValues.length; i < len; i++) {
          ref1 = selectedValues[i], name = ref1.name, friendlyNameShort = ref1.friendlyNameShort;
          refinementList.push({
            filter: refinementKey,
            uuid: name,
            value: friendlyNameShort
          });
        }
      }
    }
    return refinementList;
  };

  return RefinementContextLoggerDesktop;

})(RefinementContextLogger);

module.exports = RefinementContextLoggerDesktop;



},{"./rcl":46}],46:[function(require,module,exports){
var Backbone, RefinementContextLogger,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

RefinementContextLogger = (function(superClass) {
  extend(RefinementContextLogger, superClass);

  function RefinementContextLogger() {
    return RefinementContextLogger.__super__.constructor.apply(this, arguments);
  }

  RefinementContextLogger.prototype._selectors = {
    ATTR_BHC: 'data-bhc',
    CARD_BADGE: '.cui-badge',
    CARD_BOUGHT_COUNT: '.cui-quantity-bought',
    CARD_DISTANCE: '.cui-location-distance',
    CARD_IN_STORE_PICKUP: '.cui-location',
    CARD_PRICE_ORIGINAL: '.cui-price-original',
    CARD_PRICE_DISCOUNT: '.cui-price-discount',
    CARD_RATING_CONTAINER: '.cui-review-rating .rating',
    CARD_RATING_COUNT: '.rating-count',
    CARD_RATING_FULL_STAR: '.full-star',
    CARD_RATING_HALF_STAR: '.half-star',
    CARD_TITLE: '.cui-udc-title',
    CARD_URGENCY_PRICING: '.cui-promotions'
  };

  RefinementContextLogger.prototype._DEFAULT_CATEGORY = 'goods';

  RefinementContextLogger.prototype._DEFAULT_SORT = 'relevance';

  RefinementContextLogger.prototype.initialize = function(arg) {
    var options;
    options = arg.options;
    return this._logDealAndCard = options._logDealAndCard, options;
  };

  RefinementContextLogger.prototype._addLoggerEvent = function(event) {
    return OptimizeSuite.TrackingHub.add('deal-card-click', this._getEventMeta(event));
  };

  RefinementContextLogger.prototype._getEventMeta = function(event) {
    var eventMeta;
    eventMeta = {
      category: this._getCategoryHierarchy(),
      pagination: {
        page: this._getCurrentPageNumber(),
        sort: this._getSort()
      },
      selectedRefinements: this._getRefinements()
    };
    if (this._logDealAndCard) {
      eventMeta.deal = this._getDealInfo();
      eventMeta.card = this._getCardInfo(event.currentTarget);
    }
    return eventMeta;
  };

  RefinementContextLogger.prototype._getDealInfo = function() {
    return {
      id: this._getDealId(),
      uuid: this._getDealUuid(),
      href: this._getDealHref(),
      categorization: this._getDealCategorization(),
      reviews: this._getDealReviewInfo()
    };
  };

  RefinementContextLogger.prototype._getCardInfo = function(target) {
    var inStorePickup;
    inStorePickup = this._getCardInStorePickup(target);
    return {
      title: this._getCardTitle(target),
      position: this._getCardPosition(target),
      value: this._getCardValue(target),
      price: this._getCardPrice(target),
      badge: this._getCardBadge(target),
      boughtCount: this._getCardBoughtCount(target),
      urgencyPricing: this._getCardUrgencyPricing(target),
      inStorePickup: inStorePickup,
      distance: inStorePickup ? this._getCardDistance(target) : void 0,
      reviews: this._getCardReviewInfo(target)
    };
  };

  RefinementContextLogger.prototype._getDealId = function() {
    return null;
  };

  RefinementContextLogger.prototype._getDealUuid = function() {
    return null;
  };

  RefinementContextLogger.prototype._getDealHref = function() {
    return null;
  };

  RefinementContextLogger.prototype._getDealCategorization = function() {
    return [];
  };

  RefinementContextLogger.prototype._getDealReviewInfo = function() {
    return {};
  };

  RefinementContextLogger.prototype._getCardTitle = function(target) {
    return $(target).find(this._selectors.CARD_TITLE).text().trim();
  };

  RefinementContextLogger.prototype._getCardPosition = function() {
    return null;
  };

  RefinementContextLogger.prototype._getCardValue = function(target) {
    return $(target).find(this._selectors.CARD_PRICE_ORIGINAL).first().text().trim();
  };

  RefinementContextLogger.prototype._getCardPrice = function(target) {
    return $(target).find(this._selectors.CARD_PRICE_DISCOUNT).first().text().trim();
  };

  RefinementContextLogger.prototype._getCardBadge = function(target) {
    return $(target).find(this._selectors.CARD_BADGE).first().text().trim() || null;
  };

  RefinementContextLogger.prototype._getCardBoughtCount = function(target) {
    return parseInt($(target).find(this._selectors.CARD_BOUGHT_COUNT).first().text().replace(/[^\d]/g, ''), 10) || null;
  };

  RefinementContextLogger.prototype._getCardUrgencyPricing = function(target) {
    return $(target).find(this._selectors.CARD_URGENCY_PRICING).first().text().trim() || null;
  };

  RefinementContextLogger.prototype._getCardInStorePickup = function(target) {
    return !!$(target).find(this._selectors.CARD_IN_STORE_PICKUP).length;
  };

  RefinementContextLogger.prototype._getCardDistance = function(target) {
    var rawDistance, ref;
    rawDistance = $(target).find(this._selectors.CARD_DISTANCE).first().text();
    if (!rawDistance) {
      return -1;
    }
    return parseInt((ref = rawDistance.match(/[\d,]+/)) != null ? ref[0] : void 0, 10);
  };

  RefinementContextLogger.prototype._getCardReviewInfo = function(target) {
    var ratingDisplay, ref;
    ratingDisplay = $(target).find(this._selectors.CARD_RATING_CONTAINER).first();
    return {
      ratingCount: parseInt((ref = $(target).find(this._selectors.CARD_RATING_COUNT).attr(this._selectors.ATTR_BHC)) != null ? ref.split(':')[1] : void 0, 10) || 0,
      averageRating: ratingDisplay.find(this._selectors.CARD_RATING_FULL_STAR).length + 0.5 * ratingDisplay.find(this._selectors.CARD_RATING_HALF_STAR).length
    };
  };

  RefinementContextLogger.prototype._getSort = function() {
    return this._DEFAULT_SORT;
  };

  RefinementContextLogger.prototype._getCategoryHierarchy = function() {
    return {
      category: this._DEFAULT_CATEGORY,
      id: this._DEFAULT_CATEGORY,
      level: 1
    };
  };

  RefinementContextLogger.prototype._getCurrentPageNumber = function() {
    return 1;
  };

  RefinementContextLogger.prototype._getRefinements = function() {
    return [];
  };

  return RefinementContextLogger;

})(Backbone.View);

module.exports = RefinementContextLogger;



},{"backbone":55}],47:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("seoCrosslinks",c,p,1),c,p,0,20,395,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div id=\"seo-crosslinks-");t.b(t.v(t.f("index",c,p,0)));t.b("\">");t.b("\n" + i);t.b("    <header>");t.b("\n" + i);t.b("      <h2 class=\"row seo-title\">");t.b(t.v(t.f("title",c,p,0)));t.b("</h2>");t.b("\n" + i);t.b("    </header>");t.b("\n" + i);t.b("    <section>");t.b("\n" + i);t.b("      <ul class=\"unstyled block-grid four-up\">");t.b("\n" + i);if(t.s(t.f("links",c,p,1),c,p,0,218,346,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <li class=\"should-truncate-singleline\">");t.b("\n" + i);t.b("            <a href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\">");t.b(t.v(t.f("anchorText",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("          </li>");t.b("\n" + i);});c.pop();}t.b("      </ul>");t.b("\n" + i);t.b("    </section>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# seoCrosslinks }}\n  <div id=\"seo-crosslinks-{{ index }}\">\n    <header>\n      <h2 class=\"row seo-title\">{{ title }}</h2>\n    </header>\n    <section>\n      <ul class=\"unstyled block-grid four-up\">\n        {{# links }}\n          <li class=\"should-truncate-singleline\">\n            <a href=\"{{ url }}\">{{ anchorText }}</a>\n          </li>\n        {{/ links }}\n      </ul>\n    </section>\n  </div>\n{{/ seoCrosslinks }}\n", Hogan);
},{"hogan.js":119}],48:[function(require,module,exports){
var SeoCrosslinksTemplate, SeoTextsTemplate;

SeoTextsTemplate = require('../texts.html.mustache');

SeoCrosslinksTemplate = require('../crosslinks.html.mustache');

module.exports = {
  updateSeoPageMetaHash: function(seoMetaHash) {
    var $head, $next, $prev, $robots, alternate, alternates, canonical, description, i, keywords, len, next, noindexed, pageMeta, prev, seoCrosslinks, seoCrosslinksHtml, seoTexts, seoTextsHtml, title;
    title = seoMetaHash.title, pageMeta = seoMetaHash.pageMeta, seoCrosslinks = seoMetaHash.seoCrosslinks, seoTexts = seoMetaHash.seoTexts;
    if (!pageMeta) {
      return;
    }
    canonical = pageMeta.canonical, keywords = pageMeta.keywords, description = pageMeta.description, noindexed = pageMeta.noindexed, prev = pageMeta.prev, next = pageMeta.next, alternates = pageMeta.alternates;
    $head = $('head');
    $head.find('title').text(title);
    $head.find('link[rel="canonical"]').attr('href', canonical);
    $head.find('meta[name="keywords"]').attr('content', keywords);
    $head.find('meta[name="description"]').attr('content', description);
    for (i = 0, len = alternates.length; i < len; i++) {
      alternate = alternates[i];
      $head.find("link[hreflang='" + alternate.hreflang + "']").attr('href', alternate.href);
    }
    $robots = $head.find('meta[name="robots"]');
    if (!noindexed) {
      $robots.remove();
    } else if ($robots.length < 1) {
      $head.append('<meta name="robots" content="noindex,nofollow">');
    }
    $prev = $head.find('link[rel="prev"]');
    if (!prev) {
      $prev.remove();
    } else if ($prev.length) {
      $prev.attr('href', prev);
    } else {
      $head.append("<link rel='prev' href='" + prev + "'>");
    }
    $next = $head.find('link[rel="next"]');
    if (!next) {
      $next.remove();
    } else if ($next.length) {
      $next.attr('href', next);
    } else {
      $head.append("<link rel='next' href='" + next + "'>");
    }
    seoTextsHtml = (seoTexts != null ? seoTexts.length : void 0) ? SeoTextsTemplate.render({
      seoTexts: seoTexts
    }) : '';
    $('#seo-texts-container').html(seoTextsHtml);
    seoCrosslinksHtml = (seoCrosslinks != null ? seoCrosslinks.length : void 0) ? SeoCrosslinksTemplate.render({
      seoCrosslinks: seoCrosslinks
    }) : '';
    return $('#seo-crosslinks-container').html(seoCrosslinksHtml);
  },
  updateTouchSeoPageMeta: function(seoMetaHash) {
    var $head, $robots, alternate, alternates, canonical, description, i, keywords, len, noindexed, pageMeta, title;
    title = seoMetaHash.title, pageMeta = seoMetaHash.pageMeta;
    if (!pageMeta) {
      return;
    }
    canonical = pageMeta.canonical, keywords = pageMeta.keywords, description = pageMeta.description, noindexed = pageMeta.noindexed, alternates = pageMeta.alternates;
    $head = $('head');
    $head.find('title').text(title);
    $head.find('link[rel="canonical"]').attr('href', canonical);
    $head.find('meta[name="keywords"]').attr('content', keywords);
    $head.find('meta[name="description"]').attr('content', description);
    for (i = 0, len = alternates.length; i < len; i++) {
      alternate = alternates[i];
      $head.find("link[hreflang='" + alternate.hreflang + "']").attr('href', alternate.href);
    }
    $robots = $head.find('meta[name="robots"]');
    if (!noindexed) {
      return $robots.remove();
    } else if ($robots.length < 1) {
      return $head.append('<meta name="robots" content="noindex,nofollow">');
    }
  }
};



},{"../crosslinks.html.mustache":47,"../texts.html.mustache":49}],49:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("seoTexts",c,p,1),c,p,0,15,160,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div id=\"seo-text-");t.b(t.v(t.f("index",c,p,0)));t.b("\">");t.b("\n" + i);t.b("    <h2 class=\"row seo-title\">");t.b(t.v(t.f("title",c,p,0)));t.b("</h2>");t.b("\n" + i);t.b("    <div class=\"row seo-text-body\">");t.b(t.t(t.f("body",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{# seoTexts }}\n  <div id=\"seo-text-{{ index }}\">\n    <h2 class=\"row seo-title\">{{ title }}</h2>\n    <div class=\"row seo-text-body\">{{{ body }}}</div>\n  </div>\n{{/ seoTexts }}\n", Hogan);
},{"hogan.js":119}],50:[function(require,module,exports){
(function (global){
var extend;

extend = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).extend;

module.exports = {
  prefixI18n: function(I18n, prefix) {
    return extend({}, I18n, {
      t: function(key, options) {
        key = "" + prefix + key;
        return I18n.t(key, options);
      }
    });
  }
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],51:[function(require,module,exports){
(function (global){
var TreeTraversalHelper, contains, getAncestors, getCommonAncestor, getOrderedCommonNodes, getSelectedNodes, min, ref, uniq;

ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), contains = ref.contains, min = ref.min, uniq = ref.uniq;

getOrderedCommonNodes = function(nodes, selectedIds, idKey, childrenKey) {
  var commonAncestor, selectedNodes;
  if (idKey == null) {
    idKey = 'id';
  }
  if (childrenKey == null) {
    childrenKey = 'children';
  }
  selectedNodes = getSelectedNodes(nodes, childrenKey, (function(_this) {
    return function(node) {
      return contains(selectedIds, node[idKey]);
    };
  })(this));
  if (!selectedNodes.length) {
    return;
  }
  commonAncestor = getCommonAncestor(selectedNodes);
  return getAncestors(commonAncestor);
};

getSelectedNodes = (function(_this) {
  return function(nodes, childrenKey, isSelectedFunction, parent) {
    var j, len, node, selectedChildNodes, selectedNodes;
    selectedNodes = [];
    for (j = 0, len = nodes.length; j < len; j++) {
      node = nodes[j];
      if (node.parent == null) {
        node.parent = parent;
      }
      if (isSelectedFunction(node)) {
        selectedNodes.push(node);
      }
      if (node[childrenKey]) {
        selectedChildNodes = getSelectedNodes(node[childrenKey], childrenKey, isSelectedFunction, node);
      }
      if (selectedChildNodes != null ? selectedChildNodes.length : void 0) {
        selectedNodes = selectedNodes.concat(selectedChildNodes);
      }
    }
    return selectedNodes;
  };
})(this);

getCommonAncestor = function(nodes, parentKey) {
  var ancestor, ancestors, ancestorsAtCurrentLevel, commonAncestor, i, j, k, len, lengths, matrixOfAncestors, node, ref1, shortestLength;
  if (parentKey == null) {
    parentKey = 'parent';
  }
  if (!(nodes != null ? nodes.length : void 0)) {
    return;
  }
  if (nodes.length === 1) {
    return nodes[0];
  }
  if (nodes.length === 2 && nodes[0][parentKey] === nodes[1]) {
    return nodes[0];
  }
  if (nodes.length === 2 && nodes[1][parentKey] === nodes[0]) {
    return nodes[1];
  }
  if (nodes.length === 3 && nodes[2][parentKey] === nodes[1] && nodes[1][parentKey] === nodes[0]) {
    return nodes[2];
  }
  if (nodes.length === 4 && nodes[3][parentKey] === nodes[2] && nodes[2][parentKey] === nodes[1] && nodes[1][parentKey] === nodes[0]) {
    return nodes[3];
  }
  matrixOfAncestors = [];
  lengths = [];
  for (j = 0, len = nodes.length; j < len; j++) {
    node = nodes[j];
    ancestors = getAncestors(node);
    matrixOfAncestors.push(ancestors);
    lengths.push(ancestors.length);
  }
  shortestLength = min(lengths);
  commonAncestor = void 0;
  for (i = k = 0, ref1 = shortestLength - 1; 0 <= ref1 ? k <= ref1 : k >= ref1; i = 0 <= ref1 ? ++k : --k) {
    ancestorsAtCurrentLevel = (function() {
      var l, len1, results;
      results = [];
      for (l = 0, len1 = matrixOfAncestors.length; l < len1; l++) {
        ancestor = matrixOfAncestors[l];
        results.push(ancestor[i]);
      }
      return results;
    })();
    if (uniq(ancestorsAtCurrentLevel).length === 1) {
      commonAncestor = ancestorsAtCurrentLevel[0];
    }
  }
  return commonAncestor;
};

getAncestors = function(node, parentKey) {
  var ancestor, ancestors;
  if (parentKey == null) {
    parentKey = 'parent';
  }
  if (!node) {
    return;
  }
  ancestors = [node];
  ancestor = node;
  while (ancestor[parentKey]) {
    ancestor = ancestor[parentKey];
    ancestors.push(ancestor);
  }
  return ancestors.reverse();
};

module.exports = TreeTraversalHelper = {
  getOrderedCommonNodes: getOrderedCommonNodes,
  getSelectedNodes: getSelectedNodes
};


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],52:[function(require,module,exports){
var UpdateAppURLHelper, usePushState;

module.exports = UpdateAppURLHelper = function(adjustedURL, opts) {
  var ref;
  if (opts == null) {
    opts = {};
  }
  if (usePushState(opts)) {
    return window.history.pushState(null, null, adjustedURL);
  } else if (((ref = window.history) != null ? ref.replaceState : void 0) != null) {
    return window.history.replaceState(null, null, adjustedURL);
  } else {
    return window.location = adjustedURL;
  }
};

usePushState = function(opts) {
  var ref;
  if (!opts.pushState) {
    return false;
  }
  return ((ref = window.history) != null ? ref.pushState : void 0) != null;
};



},{}],53:[function(require,module,exports){
var Backbone, SpinnerTemplate, SpinnerView;

Backbone = require('backbone');

SpinnerTemplate = require('../../spinner.html.mustache');

module.exports = SpinnerView = Backbone.View.extend({
  template: SpinnerTemplate,
  initialize: function(arg) {
    var ref;
    this.parentElem = arg.parentElem, this.css = arg.css, this.useV2 = arg.useV2;
    return (ref = this.parentElem) != null ? typeof ref.append === "function" ? ref.append(this.$el) : void 0 : void 0;
  },
  render: function() {
    this.stop();
    this.$el.html(this.template.render({
      useV2: this.useV2
    }));
    if (this.useV2) {
      if (this.css != null) {
        this.$el.find('.g-spinner').css(this.css);
      }
    } else {
      if (this.css != null) {
        this.$el.find('.t-spinner-small').css(this.css);
      }
    }
    return this;
  },
  isRunning: function() {
    return this.$el.is(':visible');
  },
  isInDom: function() {
    return $.contains(document.documentElement, this.$el[0]);
  },
  start: function() {
    var ref;
    if (!this.isInDom()) {
      if ((ref = this.parentElem) != null) {
        if (typeof ref.append === "function") {
          ref.append(this.$el);
        }
      }
    }
    return this.$el.show();
  },
  stop: function() {
    return this.$el.hide();
  }
});



},{"../../spinner.html.mustache":54,"backbone":55}],54:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"spinner-overlay\">");t.b("\n" + i);if(t.s(t.f("useV2",c,p,1),c,p,0,44,136,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div id=\"spinner-back\">");t.b("\n" + i);t.b("      <div class=\"g-spinner icon-g-loader\"></div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("useV2",c,p,1),c,p,1,0,0,"")){t.b("    <div class=\"t-spinner-small\"></div>");t.b("\n" + i);};t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"spinner-overlay\">\n  {{# useV2 }}\n    <div id=\"spinner-back\">\n      <div class=\"g-spinner icon-g-loader\"></div>\n    </div>\n  {{/ useV2 }}\n  {{^ useV2 }}\n    <div class=\"t-spinner-small\"></div>\n  {{/ useV2 }}\n</div>\n", Hogan);
},{"hogan.js":119}],55:[function(require,module,exports){
(function (global){
//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(){

  // Initial Setup
  // -------------

  // Save a reference to the global object (`window` in the browser, `exports`
  // on the server).
  var root = this;

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // The top-level namespace. All public Backbone classes and modules will
  // be attached to this. Exported for both the browser and the server.
  var Backbone;
  if (typeof exports !== 'undefined') {
    Backbone = exports;
  } else {
    Backbone = root.Backbone = {};
  }

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.0.0';

  // Require Underscore, if we're on the server, and it's not already present.
  var _ = root._;
  if (!_ && (typeof require !== 'undefined')) _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = root.jQuery || root.Zepto || root.ender || root.$;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }

      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeners = this._listeners;
      if (!listeners) return this;
      var deleteListener = !name && !callback;
      if (typeof name === 'object') callback = this;
      if (obj) (listeners = {})[obj._listenerId] = obj;
      for (var id in listeners) {
        listeners[id].off(name, callback, this);
        if (deleteListener) delete this._listeners[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeners = this._listeners || (this._listeners = {});
      var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));
      listeners[id] = obj;
      if (typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var defaults;
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    _.extend(this, _.pick(options, modelOptions));
    if (options.parse) attrs = this.parse(attrs, options) || {};
    if (defaults = _.result(this, 'defaults')) {
      attrs = _.defaults({}, attrs, defaults);
    }
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // A list of options to be attached directly to the model, if provided.
  var modelOptions = ['url', 'urlRoot', 'collection'];

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = true;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      // If we're not waiting and attributes exist, save acts as `set(attr).save(null, opts)`.
      if (attrs && (!options || !options.wait) && !this.set(attrs, options)) return false;

      options = _.extend({validate: true}, options);

      // Do not persist invalid models.
      if (!this._validate(attrs, options)) return false;

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
      if (this.isNew()) return base;
      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return this.id == null;
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options || {}, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.url) this.url = options.url;
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, merge: false, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.defaults(options || {}, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      models = _.isArray(models) ? models.slice() : [models];
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model);
      }
      return this;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults(options || {}, setOptions);
      if (options.parse) models = this.parse(models, options);
      if (!_.isArray(models)) models = models ? [models] : [];
      var i, l, model, attrs, existing, sort;
      var at = options.at;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        if (!(model = this._prepareModel(models[i], options))) continue;

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(model)) {
          if (options.remove) modelMap[existing.cid] = true;
          if (options.merge) {
            existing.set(model.attributes, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }

        // This is a new model, push it to the `toAdd` list.
        } else if (options.add) {
          toAdd.push(model);

          // Listen to added models' events, and index models for lookup by
          // `id` and by `cid`.
          model.on('all', this._onModelEvent, this);
          this._byId[model.cid] = model;
          if (model.id != null) this._byId[model.id] = model;
        }
      }

      // Remove nonexistent models if appropriate.
      if (options.remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          splice.apply(this.models, [at, 0].concat(toAdd));
        } else {
          push.apply(this.models, toAdd);
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      if (options.silent) return this;

      // Trigger `add` events.
      for (i = 0, l = toAdd.length; i < l; i++) {
        (model = toAdd[i]).trigger('add', model, this, options);
      }

      // Trigger `sort` if the collection was sorted.
      if (sort) this.trigger('sort', this, options);
      return this;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i]);
      }
      options.previousModels = this.models;
      this._reset();
      this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return this;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: this.length}, options));
      return model;
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: 0}, options));
      return model;
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function(begin, end) {
      return this.models.slice(begin, end);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj.id != null ? obj.id : obj.cid || obj];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Figure out the smallest index at which a model should be inserted so as
    // to maintain order.
    sortedIndex: function(model, value, context) {
      value || (value = this.comparator);
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _.sortedIndex(this.models, model, iterator, context);
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options || (options = {});
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model._validate(attrs, options)) {
        this.trigger('invalid', this, attrs, options);
        return false;
      }
      return model;
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf',
    'isEmpty', 'chain'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    this._configure(options || {});
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be prefered to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save'
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Performs the initial configuration of a View with a set of options.
    // Keys with special meaning *(e.g. model, collection, id, className)* are
    // attached directly to the view.  See `viewOptions` for an exhaustive
    // list.
    _configure: function(options) {
      if (this.options) options = _.extend({}, _.result(this, 'options'), options);
      _.extend(this, _.pick(options, viewOptions));
      this.options = options;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && window.ActiveXObject &&
          !(window.external && window.external.msActiveXFilteringEnabled)) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        callback && callback.apply(router, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional){
                     return optional ? match : '([^\/]+)';
                   })
                   .replace(splatParam, '(.*?)');
      return new RegExp('^' + route + '$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param) {
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = this.location.pathname;
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.substr(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({}, {root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        this.iframe = Backbone.$('<iframe src="javascript:0" tabindex="-1" />').hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;
      var atRoot = loc.pathname.replace(/[^\/]$/, '$&/') === this.root;

      // If we've started off with a route from a `pushState`-enabled browser,
      // but we're currently in a browser that doesn't support it...
      if (this._wantsHashChange && this._wantsPushState && !this._hasPushState && !atRoot) {
        this.fragment = this.getFragment(null, true);
        this.location.replace(this.root + this.location.search + '#' + this.fragment);
        // Return immediately as browser will do redirect to new url
        return true;

      // Or if we've started out with a hash-based route, but we're currently
      // in a browser where it could be `pushState`-based instead...
      } else if (this._wantsPushState && this._hasPushState && atRoot && loc.hash) {
        this.fragment = this.getHash().replace(routeStripper, '');
        this.history.replaceState({}, document.title, this.root + this.fragment + loc.search);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl() || this.loadUrl(this.getHash());
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragmentOverride) {
      var fragment = this.fragment = this.getFragment(fragmentOverride);
      var matched = _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
      return matched;
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: options};
      fragment = this.getFragment(fragment || '');
      if (this.fragment === fragment) return;
      this.fragment = fragment;
      var url = this.root + fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function (model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

}).call(this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],56:[function(require,module,exports){
exports.V3 = {
  construct: require('./v3/construct'),
  parse: require('./v3/parse')
};

exports.V2 = {
  construct: require('./v2/construct'),
  parse: require('./v2/parse')
};

exports.V1 = {
  construct: require('./v1/construct'),
  parse: require('./v1/parse')
};

exports.helpers = {
  parsedParams: require('./parsed_params'),
  UrlString: require('./url')
};

},{"./parsed_params":58,"./url":59,"./v1/construct":60,"./v1/parse":61,"./v2/construct":62,"./v2/parse":64,"./v3/construct":65,"./v3/parse":67}],57:[function(require,module,exports){
module.exports = {
  pickAndExecute: function(hash, keyList, cb) {
    var i, key, len, results, value;
    results = [];
    for (i = 0, len = keyList.length; i < len; i++) {
      key = keyList[i];
      value = hash[key];
      results.push(cb(key, value));
    }
    return results;
  }
};

},{}],58:[function(require,module,exports){
(function (global){
var any, isArray, isString, ref;

ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), isArray = ref.isArray, isString = ref.isString, any = ref.any;

exports.ParsedParams = (function() {
  var doesParamExist;

  function _Class(paramArgs, paramList) {
    var i, len, paramName, ref1, ref2;
    this.paramList = paramList != null ? paramList : [];
    this.partySize = paramArgs.partySize, this.date = paramArgs.date, this.time = paramArgs.time, this.l1Category = paramArgs.l1Category, this.l2Categories = paramArgs.l2Categories, this.l3Categories = paramArgs.l3Categories, this.l4Categories = paramArgs.l4Categories, this.l5Categories = paramArgs.l5Categories, this.l6Categories = paramArgs.l6Categories, this.interests = paramArgs.interests, this.discounts = paramArgs.discounts, this.minPrice = paramArgs.minPrice, this.maxPrice = paramArgs.maxPrice, this.brands = paramArgs.brands, this.locations = paramArgs.locations, this.mainLocation = paramArgs.mainLocation;
    if (this.l2Categories == null) {
      this.l2Categories = [];
    }
    if (this.l3Categories == null) {
      this.l3Categories = [];
    }
    if (this.l4Categories == null) {
      this.l4Categories = [];
    }
    if (this.l5Categories == null) {
      this.l5Categories = [];
    }
    if (this.l6Categories == null) {
      this.l6Categories = [];
    }
    if (this.interests == null) {
      this.interests = [];
    }
    if (this.discounts == null) {
      this.discounts = [];
    }
    if (this.locations == null) {
      this.locations = [];
    }
    ref1 = this.paramList;
    for (i = 0, len = ref1.length; i < len; i++) {
      paramName = ref1[i];
      this[paramName] = (ref2 = paramArgs[paramName]) != null ? ref2 : [];
    }
  }

  _Class.prototype.applyImplicitCategory2 = function(l2Category) {
    return this._implicitL2Category = l2Category;
  };

  _Class.prototype.getCategory2 = function() {
    var ref1;
    return (ref1 = this.l2Categories[0]) != null ? ref1 : this._implicitL2Category;
  };

  _Class.prototype.anyL1Categories = function() {
    return doesParamExist(this.l1Category);
  };

  _Class.prototype.anyL2Categories = function() {
    return doesParamExist(this.l2Categories);
  };

  _Class.prototype.anyL3Categories = function() {
    return doesParamExist(this.l3Categories);
  };

  _Class.prototype.anyL4Categories = function() {
    return doesParamExist(this.l4Categories);
  };

  _Class.prototype.anyL5Categories = function() {
    return doesParamExist(this.l5Categories);
  };

  _Class.prototype.anyL6Categories = function() {
    return doesParamExist(this.l6Categories);
  };

  _Class.prototype.anyCategoriesPresent = function() {
    return any([this.anyL4Categories(), this.anyL3Categories(), this.anyL2Categories(), this.anyL1Categories()]);
  };

  _Class.prototype.anyFiltersPresent = function() {
    return any([this.anyCategoriesPresent(), this.anyInterests(), this.anyDiscounts(), this.anyPrices(), this.anyLocations(), this.anyAvailabilities(), this.anyBrands(), this.anyExtraParams()]);
  };

  _Class.prototype.anyExtraParams = function() {
    return any(this.paramList.map((function(_this) {
      return function(paramName) {
        return _this.anyParamsByName(paramName);
      };
    })(this)));
  };

  _Class.prototype.anyParamsByName = function(paramName) {
    return doesParamExist(this[paramName]);
  };

  _Class.prototype.anyAvailabilities = function() {
    return doesParamExist(this.date) || doesParamExist(this.time) || doesParamExist(this.partySize);
  };

  _Class.prototype.anyInterests = function() {
    return doesParamExist(this.interests);
  };

  _Class.prototype.anyDiscounts = function() {
    return doesParamExist(this.discounts);
  };

  _Class.prototype.anyPrices = function() {
    return !!this.minPrice || !!this.maxPrice;
  };

  _Class.prototype.anyBrands = function() {
    return doesParamExist(this.brands);
  };

  _Class.prototype.anyLocations = function() {
    return doesParamExist(this.locations) || doesParamExist(this.mainLocation);
  };

  doesParamExist = function(inputParam) {
    if (isArray(inputParam) || isString(inputParam)) {
      return inputParam.length > 0;
    } else {
      return false;
    }
  };

  return _Class;

})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],59:[function(require,module,exports){
(function (global){
var each, keys, omit, ref;

ref = typeof _ !== "undefined" && _ !== null ? _ : (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), keys = ref.keys, each = ref.each, omit = ref.omit;

exports.UrlString = (function() {
  _Class.prototype.RESERVED_PARAMS = ['partySize', 'date', 'time', 'brand', 'category', 'category2', 'category3', 'interest', 'location', 'topcategory'];

  function _Class(baseURL) {
    this.url = "";
    if (baseURL != null) {
      this.append(baseURL);
    }
  }

  _Class.prototype.appendPath = function(pathValue) {
    return this.url += "/" + pathValue;
  };

  _Class.prototype.appendQuery = function(hash) {
    return this.url += "?" + (this.stringifyQS(hash));
  };

  _Class.prototype.append = function(newValue) {
    return this.url += newValue;
  };

  _Class.prototype.removeReservedQS = function(QS) {
    return omit(QS, this.RESERVED_PARAMS);
  };

  _Class.prototype.getUrl = function() {
    return this.url;
  };

  _Class.prototype.stringifyQS = function(hash) {
    var encodedValue, hashKey, hashValue, i, len, ref1, ref2, stingifiedQS;
    stingifiedQS = "";
    ref2 = (ref1 = keys(hash).sort()) != null ? ref1 : [];
    for (i = 0, len = ref2.length; i < len; i++) {
      hashKey = ref2[i];
      if (stingifiedQS.length > 0) {
        stingifiedQS += "&";
      }
      hashValue = hash[hashKey];
      encodedValue = encodeURIComponent(hashValue);
      stingifiedQS += hashKey + "=" + encodedValue;
    }
    return stingifiedQS;
  };

  return _Class;

})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],60:[function(require,module,exports){
(function (global){
var UrlString, compact, each, extend, isEmpty, joinParam, omitUndefined, pickAndExecute, ref;

ref = typeof _ !== "undefined" && _ !== null ? _ : (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), isEmpty = ref.isEmpty, each = ref.each, extend = ref.extend, compact = ref.compact;

UrlString = require('../url').UrlString;

pickAndExecute = require('../param_list_helper').pickAndExecute;

module.exports = function(queryParams, paramList) {
  var baseURL, brands, clonedQS, date, discounts, division, extraQS, interests, l2Categories, l3Categories, l4Categories, locations, maxPrice, minPrice, partySize, time, topcategory, urlInstance;
  partySize = queryParams.partySize, date = queryParams.date, time = queryParams.time, topcategory = queryParams.topcategory, l2Categories = queryParams.l2Categories, l3Categories = queryParams.l3Categories, l4Categories = queryParams.l4Categories, interests = queryParams.interests, discounts = queryParams.discounts, minPrice = queryParams.minPrice, maxPrice = queryParams.maxPrice, brands = queryParams.brands, locations = queryParams.locations, division = queryParams.division, extraQS = queryParams.extraQS, baseURL = queryParams.baseURL;
  urlInstance = new UrlString(baseURL);
  if (division != null) {
    urlInstance.appendPath(division);
  }
  clonedQS = extend({}, urlInstance.removeReservedQS(extraQS), omitUndefined({
    partySize: partySize,
    date: date,
    time: time,
    brand: joinParam(brands),
    category: joinParam(l2Categories),
    category2: joinParam(l3Categories),
    category3: joinParam(l4Categories),
    interest: joinParam(interests),
    discount: joinParam(discounts),
    location: joinParam(locations),
    topcategory: topcategory
  }));
  if (paramList != null) {
    pickAndExecute(queryParams, paramList, function(paramName, paramValue) {
      var joinedValue;
      joinedValue = joinParam(paramValue);
      if (joinedValue != null) {
        return clonedQS[paramName] = joinedValue;
      }
    });
  }
  if (!isEmpty(clonedQS)) {
    urlInstance.appendQuery(clonedQS);
  }
  return urlInstance.getUrl();
};

joinParam = function(array) {
  var compactedArray;
  compactedArray = compact(array);
  if (isEmpty(compactedArray)) {
    return;
  }
  return compactedArray.sort().join(',');
};

omitUndefined = function(hash) {
  var filteredObj, key, value;
  filteredObj = {};
  for (key in hash) {
    value = hash[key];
    if (value != null) {
      filteredObj[key] = value;
    }
  }
  return filteredObj;
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../param_list_helper":57,"../url":59}],61:[function(require,module,exports){
(function (global){
var ParsedParams, defaults, pickAndExecute;

defaults = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).defaults;

ParsedParams = require('../parsed_params').ParsedParams;

pickAndExecute = require('../param_list_helper').pickAndExecute;

module.exports = function(queryParams, paramList) {
  var brand, category, category2, category3, date, discount, interest, location, maxPrice, minPrice, parsedParamArgs, parsedParams, partySize, time, topcategory;
  partySize = queryParams.partySize, date = queryParams.date, time = queryParams.time, category = queryParams.category, category2 = queryParams.category2, category3 = queryParams.category3, interest = queryParams.interest, discount = queryParams.discount, minPrice = queryParams.minPrice, maxPrice = queryParams.maxPrice, brand = queryParams.brand, location = queryParams.location, topcategory = queryParams.topcategory;
  parsedParamArgs = {
    partySize: partySize,
    date: date,
    time: time,
    l1Category: topcategory,
    l2Categories: (category != null ? category.split(",") : void 0) || [],
    l3Categories: (category2 != null ? category2.split(",") : void 0) || [],
    l4Categories: (category3 != null ? category3.split(",") : void 0) || [],
    interests: (interest != null ? interest.split(",") : void 0) || [],
    discounts: (discount != null ? discount.split(",") : void 0) || [],
    locations: (location != null ? location.split(",") : void 0) || [],
    minPrice: minPrice,
    maxPrice: maxPrice,
    brands: (brand != null ? brand.split(",") : void 0) || []
  };
  parsedParams = new ParsedParams(parsedParamArgs);
  if (paramList != null) {
    pickAndExecute(queryParams, paramList, function(paramName, paramValue) {
      return parsedParams[paramName] = (paramValue != null ? paramValue.split(',') : void 0) || [];
    });
    parsedParams.paramList = paramList;
  }
  return parsedParams;
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../param_list_helper":57,"../parsed_params":58}],62:[function(require,module,exports){
(function (global){
var UrlString, addLeadingCategoryToUrl, aggregateRootPaths, clone, constructQueryCategories, constructQueryParams, contains, defaults, each, filterMissingAndDuplicateCategories, groupBy, intersection, isEmpty, keys, last, parseCategories, pickAndExecute, ref, ref1, removeVirtualPrefix, without;

ref = typeof _ !== "undefined" && _ !== null ? _ : (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), each = ref.each, clone = ref.clone, groupBy = ref.groupBy, intersection = ref.intersection, contains = ref.contains, without = ref.without, isEmpty = ref.isEmpty, defaults = ref.defaults, last = ref.last, keys = ref.keys;

UrlString = require('../url').UrlString;

ref1 = require('./helpers'), aggregateRootPaths = ref1.aggregateRootPaths, removeVirtualPrefix = ref1.removeVirtualPrefix;

pickAndExecute = require('../param_list_helper').pickAndExecute;

module.exports = function(flatCategories, queryParams, paramList) {
  var baseURL, clonedQS, extraQS, leadingCategory, leveledCategories, mainLocation, ref2, rewriteVirtualCategoryUrls, secondaryLocations, selectedBrands, selectedCategories, selectedInterests, urlInstance;
  mainLocation = queryParams.mainLocation, secondaryLocations = queryParams.secondaryLocations, selectedCategories = queryParams.selectedCategories, selectedInterests = queryParams.selectedInterests, selectedBrands = queryParams.selectedBrands, baseURL = queryParams.baseURL, extraQS = queryParams.extraQS, rewriteVirtualCategoryUrls = queryParams.rewriteVirtualCategoryUrls;
  urlInstance = new UrlString(baseURL);
  clonedQS = clone(extraQS != null ? extraQS : {});
  clonedQS = urlInstance.removeReservedQS(clonedQS);
  selectedCategories = filterMissingAndDuplicateCategories(flatCategories, selectedCategories);
  ref2 = parseCategories(flatCategories, selectedCategories), leadingCategory = ref2.leadingCategory, leveledCategories = ref2.leveledCategories;
  if ((leadingCategory == null) && baseURL === '/goods') {
    leadingCategory = "all";
  }
  if (mainLocation != null) {
    urlInstance.appendPath(mainLocation);
  }
  constructQueryParams("location", urlInstance, secondaryLocations, clonedQS, true);
  if (leadingCategory != null) {
    addLeadingCategoryToUrl(leadingCategory, rewriteVirtualCategoryUrls, urlInstance);
  }
  constructQueryCategories("category", leveledCategories["2"], leadingCategory, clonedQS);
  constructQueryCategories("category2", leveledCategories["3"], leadingCategory, clonedQS);
  constructQueryCategories("category3", leveledCategories["4"], leadingCategory, clonedQS);
  constructQueryParams("interest", urlInstance, selectedInterests, clonedQS);
  constructQueryParams("brand", urlInstance, selectedBrands, clonedQS);
  if (paramList != null) {
    pickAndExecute(queryParams, paramList, function(paramName, paramValue) {
      return constructQueryParams(paramName, urlInstance, paramValue, clonedQS);
    });
  }
  if (!isEmpty(clonedQS)) {
    urlInstance.appendQuery(clonedQS);
  }
  return urlInstance.getUrl();
};

addLeadingCategoryToUrl = function(leadingCategory, rewriteVirtualCategoryUrls, urlInstance) {
  var categoryPermalink;
  categoryPermalink = leadingCategory;
  if (rewriteVirtualCategoryUrls) {
    categoryPermalink = removeVirtualPrefix(leadingCategory);
  }
  return urlInstance.appendPath(categoryPermalink);
};

constructQueryCategories = function(queryParam, selectedCategories, leadingCategory, clonedQS) {
  var strippedLeading;
  strippedLeading = without(selectedCategories, leadingCategory).sort(function(a, b) {
    return b <= a;
  });
  if ((strippedLeading != null ? strippedLeading.length : void 0) > 0) {
    return clonedQS[queryParam] = strippedLeading.join(",");
  }
};

constructQueryParams = function(queryParam, urlInstance, selectedItems, clonedQS, shouldAppend) {
  if (shouldAppend == null) {
    shouldAppend = false;
  }
  if (isEmpty(selectedItems)) {
    return;
  }
  if (shouldAppend && selectedItems.length === 1) {
    return urlInstance.appendPath(selectedItems[0]);
  } else {
    return clonedQS[queryParam] = selectedItems.sort(function(a, b) {
      return b <= a;
    }).join(",");
  }
};

parseCategories = function(flatCategories, selectedCategories) {
  var groupedCategories, leadingCategory, leadingRoot;
  leadingCategory = void 0;
  leadingRoot = false;
  groupedCategories = groupBy(selectedCategories, function(selectedCategory) {
    var ref2;
    return (ref2 = flatCategories[selectedCategory]) != null ? ref2.level : void 0;
  });
  defaults(groupedCategories, {
    2: [],
    3: [],
    4: []
  });
  each(selectedCategories, function(selectedCategory) {
    var categoryInfo, intersectedPaths, possibleLeadingCategory;
    categoryInfo = flatCategories[selectedCategory];
    if ((categoryInfo == null) || leadingRoot) {
      return;
    }
    if (leadingCategory == null) {
      leadingCategory = categoryInfo;
      return;
    }
    intersectedPaths = intersection(leadingCategory.rootPath, categoryInfo.rootPath);
    if (intersectedPaths.length > 0) {
      possibleLeadingCategory = flatCategories[last(intersectedPaths)];
      if (possibleLeadingCategory.level === 1) {
        return;
      }
      return leadingCategory = possibleLeadingCategory;
    } else if (!contains(categoryInfo.rootPath, leadingCategory.id)) {
      leadingRoot = true;
      return leadingCategory = void 0;
    }
  });
  return {
    leadingCategory: leadingCategory != null ? leadingCategory.id : void 0,
    leveledCategories: groupedCategories
  };
};

filterMissingAndDuplicateCategories = function(flatCategories, selectedCategories) {
  var filteredCategories, rootPaths;
  filteredCategories = {};
  rootPaths = aggregateRootPaths(flatCategories, selectedCategories);
  each(selectedCategories, function(selectedCategory) {
    if (flatCategories[selectedCategory] == null) {
      return;
    }
    if (rootPaths[selectedCategory] != null) {
      return;
    }
    if (filteredCategories[selectedCategory] != null) {
      return;
    }
    return filteredCategories[selectedCategory] = selectedCategory;
  });
  return keys(filteredCategories);
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../param_list_helper":57,"../url":59,"./helpers":63}],63:[function(require,module,exports){
(function (global){
var VIRTUAL_CATEGORY_PREFIX_REGEX, extend, indexArray, initial, object, reduce, ref;

ref = typeof _ !== "undefined" && _ !== null ? _ : (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), extend = ref.extend, initial = ref.initial, object = ref.object, reduce = ref.reduce;

VIRTUAL_CATEGORY_PREFIX_REGEX = /^(v[0-9]?-)/gi;

indexArray = function(array) {
  return object(array, array);
};

module.exports = {
  aggregateRootPaths: function(flatCategories, selectedCategories) {
    return reduce(selectedCategories, (function(allPaths, selectedCategory) {
      var parsedCategory;
      parsedCategory = flatCategories[selectedCategory];
      if (parsedCategory == null) {
        return allPaths;
      }
      return extend(allPaths, indexArray(initial(parsedCategory.rootPath)));
    }), {});
  },
  removeVirtualPrefix: function(categoryId) {
    return categoryId.replace(VIRTUAL_CATEGORY_PREFIX_REGEX, '');
  }
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],64:[function(require,module,exports){
(function (global){
var ParsedParams, _, aggregateRootPaths, anyCategoryChildSelected, fetchImplicitL2, isCategory, isInterest, parsePathPortion, pickAndExecute;

_ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

ParsedParams = require('../parsed_params').ParsedParams;

aggregateRootPaths = require('./helpers').aggregateRootPaths;

pickAndExecute = require('../param_list_helper').pickAndExecute;

module.exports = function(flatInterests, flatCategories, splitPath, queryParams, paramList) {
  var brand, category, category2, category3, discount, implicitL2Category, interest, location, maxPrice, minPrice, parsedParamArgs, parsedParams, rootPaths;
  category = queryParams.category, category2 = queryParams.category2, category3 = queryParams.category3, interest = queryParams.interest, discount = queryParams.discount, location = queryParams.location, minPrice = queryParams.minPrice, maxPrice = queryParams.maxPrice, brand = queryParams.brand;
  parsedParamArgs = {
    l1Category: void 0,
    l2Categories: (category != null ? category.split(",") : void 0) || [],
    l3Categories: (category2 != null ? category2.split(",") : void 0) || [],
    l4Categories: (category3 != null ? category3.split(",") : void 0) || [],
    interests: (interest != null ? interest.split(",") : void 0) || [],
    discounts: (discount != null ? discount.split(",") : void 0) || [],
    locations: (location != null ? location.split(",") : void 0) || [],
    mainLocation: void 0,
    minPrice: minPrice,
    maxPrice: maxPrice,
    brands: (brand != null ? brand.split(",") : void 0) || []
  };
  parsedParams = new ParsedParams(parsedParamArgs);
  if (paramList != null) {
    pickAndExecute(queryParams, paramList, function(paramName, paramValue) {
      return parsedParams[paramName] = (paramValue != null ? paramValue.split(',') : void 0) || [];
    });
    parsedParams.paramList = paramList;
  }
  rootPaths = aggregateRootPaths(flatCategories, _.union(parsedParams.l3Categories, parsedParams.l4Categories));
  _.each(splitPath, function(pathPortion) {
    return parsePathPortion(flatInterests, flatCategories, pathPortion, parsedParams, rootPaths);
  });
  implicitL2Category = fetchImplicitL2(flatCategories, parsedParams);
  if (implicitL2Category) {
    parsedParams.applyImplicitCategory2(implicitL2Category);
  }
  return parsedParams;
};

parsePathPortion = function(flatInterests, flatCategories, pathPortion, parsedParams, rootPaths) {
  if (isCategory(flatCategories, pathPortion) && anyCategoryChildSelected(rootPaths, pathPortion)) {
    return;
  }
  if (pathPortion.indexOf("--") >= 0) {
    return _.each(pathPortion.split("--"), function(splitDashedPath) {
      return parsePathPortion(flatInterests, flatCategories, splitDashedPath, parsedParams, rootPaths);
    });
  } else if (isInterest(flatInterests, pathPortion)) {
    return parsedParams.interests.push(pathPortion);
  } else if (isCategory(flatCategories, pathPortion)) {
    switch (flatCategories[pathPortion].level) {
      case 1:
        return parsedParams.l1Category = pathPortion;
      case 2:
        return parsedParams.l2Categories.push(pathPortion);
      case 3:
        return parsedParams.l3Categories.push(pathPortion);
      case 4:
        return parsedParams.l4Categories.push(pathPortion);
    }
  } else if (!parsedParams.mainLocation) {
    return parsedParams.mainLocation = pathPortion;
  } else {
    return parsedParams.locations.push(pathPortion);
  }
};

fetchImplicitL2 = function(flatCategories, parsedParams) {
  var l2Keys, l2Matches;
  if (parsedParams.anyL2Categories()) {
    return parsedParams.l2Categories[0];
  }
  l2Matches = {};
  _.each(_.union(parsedParams.l3Categories, parsedParams.l4Categories), (function(_this) {
    return function(indexedCategory) {
      var possibleL2Match, ref, ref1;
      if (!(possibleL2Match = (ref = flatCategories[indexedCategory]) != null ? (ref1 = ref.rootPath) != null ? ref1[1] : void 0 : void 0)) {
        return;
      }
      return l2Matches[possibleL2Match] = true;
    };
  })(this));
  l2Keys = _.keys(l2Matches);
  if (l2Keys.length === 1) {
    return l2Keys[0];
  } else {
    return void 0;
  }
};

isInterest = function(flatInterests, item) {
  return flatInterests[item] != null;
};

isCategory = function(flatCategories, item) {
  return flatCategories[item] != null;
};

anyCategoryChildSelected = function(rootPaths, possibleCategory) {
  return rootPaths[possibleCategory] != null;
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../param_list_helper":57,"../parsed_params":58,"./helpers":63}],65:[function(require,module,exports){
(function (global){
var RESERVED_QS, UrlString, _constructQueryParams, getParamValue, isEmpty, keys, omit, pickAndExecute, ref;

ref = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), isEmpty = ref.isEmpty, keys = ref.keys, omit = ref.omit;

UrlString = require('../url').UrlString;

pickAndExecute = require('../param_list_helper').pickAndExecute;

getParamValue = require('./helpers').getParamValue;

RESERVED_QS = ['category', 'category2', 'category3', 'category4', 'category5'];

_constructQueryParams = function(queryToAppend, paramName, paramValue) {
  var parsedValue;
  parsedValue = getParamValue(paramValue).sort(function(a, b) {
    return b <= a;
  }).join(',');
  if (parsedValue != null ? parsedValue.length : void 0) {
    return queryToAppend[paramName] = parsedValue;
  }
};

module.exports = function(baseURL, permalink, queryParams) {
  var queryKeys, queryToAppend, urlInstance;
  if (queryParams == null) {
    queryParams = {};
  }
  urlInstance = new UrlString(baseURL);
  if (permalink) {
    urlInstance.appendPath(permalink);
  }
  queryToAppend = {};
  queryKeys = keys(omit(queryParams, RESERVED_QS));
  pickAndExecute(queryParams, queryKeys, function(paramName, paramValue) {
    return _constructQueryParams(queryToAppend, paramName, paramValue);
  });
  if (!isEmpty(queryToAppend)) {
    urlInstance.appendQuery(queryToAppend);
  }
  return urlInstance.getUrl();
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../param_list_helper":57,"../url":59,"./helpers":66}],66:[function(require,module,exports){
var getParamValue;

getParamValue = function(queryValue) {
  return (queryValue != null ? typeof queryValue.split === "function" ? queryValue.split(',') : void 0 : void 0) || [];
};

module.exports = {
  getParamValue: getParamValue
};

},{}],67:[function(require,module,exports){
(function (global){
var ParsedParams, START_CATEGORY_LEVEL, _applySeoCategory, getParamValue, isEmpty, pickAndExecute;

isEmpty = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).isEmpty;

ParsedParams = require('../parsed_params').ParsedParams;

getParamValue = require('./helpers').getParamValue;

pickAndExecute = require('../param_list_helper').pickAndExecute;

START_CATEGORY_LEVEL = 2;

_applySeoCategory = function(parsedParams, seoCategory) {
  var categoryLevel, categoryPath, i, len, path, permalink, url;
  if (isEmpty(seoCategory)) {
    return parsedParams;
  }
  url = seoCategory.url, path = seoCategory.path;
  if (path == null) {
    path = [];
  }
  categoryLevel = START_CATEGORY_LEVEL;
  categoryPath = path.concat([url]);
  for (i = 0, len = categoryPath.length; i < len; i++) {
    permalink = categoryPath[i];
    parsedParams["l" + (categoryLevel++) + "Categories"] = [permalink];
  }
  return parsedParams;
};

module.exports = function(seoCategory, queryParams, paramList) {
  var brand, category, category2, category3, category4, category5, discount, interest, maxPrice, minPrice, parsedParams;
  category = queryParams.category, category2 = queryParams.category2, category3 = queryParams.category3, category4 = queryParams.category4, category5 = queryParams.category5, discount = queryParams.discount, interest = queryParams.interest, minPrice = queryParams.minPrice, maxPrice = queryParams.maxPrice, brand = queryParams.brand;
  parsedParams = new ParsedParams({
    l1Category: void 0,
    l2Categories: getParamValue(category),
    l3Categories: getParamValue(category2),
    l4Categories: getParamValue(category3),
    l5Categories: getParamValue(category4),
    l6Categories: getParamValue(category5),
    discounts: getParamValue(discount),
    interests: getParamValue(interest),
    minPrice: minPrice,
    maxPrice: maxPrice,
    brands: getParamValue(brand)
  });
  if (paramList != null ? paramList.length : void 0) {
    parsedParams.paramList = paramList;
    pickAndExecute(queryParams, paramList, function(paramName, paramValue) {
      return parsedParams[paramName] = getParamValue(paramValue);
    });
  }
  return _applySeoCategory(parsedParams, seoCategory);
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../param_list_helper":57,"../parsed_params":58,"./helpers":66}],68:[function(require,module,exports){
var BadgeFilters, BreadcrumbQuery, BreadcrumbsView, DateTimeFilters, DatetimeCollection, FEATURED_REFINEMENTS, FeaturedDateTimeFilters, FeaturedSelectionFilters, FeaturedSort, LinksList, ParentNestedLinks, Range, RangeFilters, Ranges, RatingFilters, Ratings, Refinement, RefinementUI, Refinements, ResetAll, ResetFilters, Sort, datetimeCollectionOptions, getCollectionForRefinement, getFeaturedView, getRefinementData, getView, isFeaturedRefinement, rangeRefinementCollectionOptions, ratingRefinementCollectionOptions, refinementCollectionOptions, renderBreadcrumb, renderResetAll, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Refinements = require('./collections/refinements');

Ranges = require('./collections/ranges');

Ratings = require('./collections/ratings');

Refinement = require('./models/refinement');

DatetimeCollection = require('./collections/datetimes');

Range = require('./models/range');

refinementCollectionOptions = require('./presenters/refinement_collection_options');

datetimeCollectionOptions = require('./presenters/datetime_collection_options');

rangeRefinementCollectionOptions = require('./presenters/range_refinement_collection_options');

ratingRefinementCollectionOptions = require('./presenters/rating_refinement_collection_options');

LinksList = require('./views/links_list');

ParentNestedLinks = require('./views/parent_nested_links');

ResetAll = require('./views/reset_all');

ResetFilters = require('./views/reset_filters');

RangeFilters = require('./views/range_filters');

RatingFilters = require('./views/rating_filters');

DateTimeFilters = require('./views/datetime_filters');

FeaturedDateTimeFilters = require('./views/featured/datetime_filters');

FeaturedSelectionFilters = require('./views/featured/selection_filters');

FeaturedSort = require('./views/featured/sort');

Sort = require('./views/sort');

BreadcrumbsView = require('./views/breadcrumbs');

BreadcrumbQuery = require('./views/breadcrumb_query');

BadgeFilters = require('./views/badge_filters');

templates = require('../templates');

FEATURED_REFINEMENTS = ["datetime", "age", "sort"];

RefinementUI = (function() {
  RefinementUI.prototype.template = templates['widget'];

  function RefinementUI(refinements, options) {
    var container, featuredContainer;
    if (refinements == null) {
      refinements = [];
    }
    if (options == null) {
      options = {};
    }
    this._updateSelectedRefinements = bind(this._updateSelectedRefinements, this);
    container = options.container, featuredContainer = options.featuredContainer, this.shouldResetViews = options.shouldResetViews, this.showBreadcrumbFilter = options.showBreadcrumbFilter;
    if (!container) {
      return;
    }
    this.$container = $(container);
    if (featuredContainer) {
      this.$featuredContainer = $(featuredContainer);
    }
    this.events = _.clone(Backbone.Events);
    this.refinementCollections = {};
    this.selectedRefinements = {};
    this.refinementViews = {};
    this.refinementIds = [];
    this.featuredViews = {};
    _.each(refinements, (function(_this) {
      return function(refinement) {
        var collection, featuredView, view;
        collection = _this._createRefinementCollection(refinement);
        _this.refinementCollections[refinement.id] = collection;
        view = _this._createRefinementView(refinement, collection, _this.$container);
        if (collection.isQueryFilter) {
          _this.queryFilterView = view;
        }
        _this.refinementIds.push(refinement.id);
        if (_this.shouldResetViews) {
          _this.refinementViews[refinement.id] = view;
        }
        view.render();
        if (isFeaturedRefinement(refinement)) {
          featuredView = _this._createFeaturedView(refinement, collection, _this.$featuredContainer);
          _this.featuredViews[refinement.id] = featuredView;
          return featuredView.render();
        }
      };
    })(this));
    if (this.showBreadcrumbFilter) {
      this.breadcrumbView = renderBreadcrumb(this.$container, this.refinementCollections);
      this.resetAllView = this.breadcrumbView.resetAllView;
    } else {
      this.resetAllView = renderResetAll(this.$container, this.$featuredContainer, this.refinementCollections);
    }
  }

  RefinementUI.prototype.removeAllFeaturedFilters = function() {
    var j, key, len, ref, results;
    if (!this.featuredViews) {
      return;
    }
    ref = Object.keys(this.featuredViews);
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      key = ref[j];
      results.push(this._removeUnusedId(key));
    }
    return results;
  };

  RefinementUI.prototype.updateRefinements = function(updatedRefinements, updateOptions) {
    if (this.shouldResetViews && this.hasMismatch(updatedRefinements)) {
      return this._rerenderViews(updatedRefinements, updateOptions);
    } else {
      if (this.$featuredContainer) {
        this._updateFeaturedFilters(updatedRefinements);
      }
      return _.each(updatedRefinements, (function(_this) {
        return function(refinement) {
          var ref;
          return (ref = _this.refinementCollections[refinement.id]) != null ? ref.setOrdered(refinement, updateOptions) : void 0;
        };
      })(this));
    }
  };

  RefinementUI.prototype.resetAll = function() {
    return this.resetAllView.resetAll();
  };

  RefinementUI.prototype.hasMismatch = function(refinements) {
    if (refinements.length !== this.refinementIds.length) {
      return true;
    }
    return _.some(refinements, (function(_this) {
      return function(v, i) {
        return v.id !== _this.refinementIds[i];
      };
    })(this));
  };

  RefinementUI.prototype._rerenderViews = function(updatedRefinements, updateOptions) {
    var collections, elems, id, idsToRemove, j, len, oldRefinementIds, ref, ref1, views;
    oldRefinementIds = this.refinementIds;
    this.refinementIds = [];
    collections = [];
    elems = [];
    views = [];
    if (this.queryFilterView) {
      elems.push(this.queryFilterView.el);
      views.push(this.queryFilterView);
    }
    if (this.showBreadcrumbFilter) {
      elems.push(this.breadcrumbView.el);
      views.push(this.breadcrumbView);
    } else {
      elems.push(this.resetAllView.el);
      views.push(this.resetAllView);
    }
    _.each(updatedRefinements, (function(_this) {
      return function(refinement) {
        var collection, view;
        _this.refinementIds.push(refinement.id);
        if ((collection = _this.refinementCollections[refinement.id])) {
          if (collection.isQueryFilter) {
            return;
          }
          collection.collapseFilter = refinement.collapseFilter;
          collection.setOrdered(refinement, updateOptions);
          view = _this.refinementViews[refinement.id];
        } else {
          collection = _this._createRefinementCollection(refinement);
          _this.refinementCollections[refinement.id] = collection;
          view = _this._createRefinementView(refinement, collection);
          _this.refinementViews[refinement.id] = view;
        }
        collections.push(collection);
        elems.push(view.el);
        return views.push(view);
      };
    })(this));
    this.resetAllView.resetRefinements(collections);
    if (this.breadcrumbView != null) {
      idsToRemove = _.difference(oldRefinementIds, this.refinementIds);
      ref = idsToRemove || [];
      for (j = 0, len = ref.length; j < len; j++) {
        id = ref[j];
        this._removeUnusedId(id);
      }
      if ((ref1 = this.breadcrumbView) != null) {
        ref1.resetRefinements(this.refinementCollections, idsToRemove);
      }
    }
    this.$container.html(elems);
    return _.each(views, function(view) {
      return view.render().delegateEvents();
    });
  };

  RefinementUI.prototype._removeUnusedId = function(id) {
    var ref, ref1, ref2, view;
    if ((ref = this.refinementCollections) != null) {
      delete ref[id];
    }
    if (view = (ref1 = this.refinementViews) != null ? ref1[id] : void 0) {
      view.remove();
      delete this.refinementViews[id];
    }
    if ((ref2 = this.featuredViews) != null ? ref2[id] : void 0) {
      this.$featuredContainer.find("#featured-" + id + "-box").remove();
      $("#featured-" + id + "-tooltip").remove();
      return delete this.featuredViews[id];
    }
  };

  RefinementUI.prototype._createRefinementCollection = function(refinement) {
    var collection;
    collection = getCollectionForRefinement(refinement);
    this.events.listenTo(collection, 'selectedModels:updated', this._updateSelectedRefinements);
    this._setSelectedRefinement(refinement.id, collection.getSelectedValues());
    return collection;
  };

  RefinementUI.prototype._setSelectedRefinement = function(id, selectedValues) {
    return this.selectedRefinements[id] = {
      selectedValues: selectedValues
    };
  };

  RefinementUI.prototype._updateSelectedRefinements = function(selected) {
    this._setSelectedRefinement(selected.id, selected.selectedValues);
    if (selected.queue) {
      return;
    }
    return this.events.trigger('refinementsUpdated', this.selectedRefinements, selected.id);
  };

  RefinementUI.prototype._createRefinementView = function(refinement, collection, container) {
    var $containerEl, RefinementViewClass;
    $containerEl = (container != null ? container.find("[data-id='" + refinement.id + "']") : void 0) || $(this.template.render(refinement));
    RefinementViewClass = getView(refinement);
    return new RefinementViewClass({
      collection: collection,
      el: $containerEl
    });
  };

  RefinementUI.prototype._createFeaturedView = function(refinement, collection, container) {
    var $featuredEl, FeaturedViewClass, featuredView;
    FeaturedViewClass = getFeaturedView(refinement);
    $featuredEl = container.find("#featured-" + refinement.id + "-tooltip-content");
    return featuredView = new FeaturedViewClass({
      collection: collection,
      el: $featuredEl
    });
  };

  RefinementUI.prototype._updateFeaturedFilters = function(widgets) {
    var collectionsToKeep, currentCollections, updatedCollections;
    currentCollections = _.values(this.refinementCollections);
    collectionsToKeep = this._removeUnusedFeaturedFilters(widgets, currentCollections);
    updatedCollections = this._addNewFeaturedFilters(widgets, collectionsToKeep);
    this.resetAllView.resetRefinements(updatedCollections);
    this.resetAllView.render();
    return this._orderFeaturedFilters();
  };

  RefinementUI.prototype._orderFeaturedFilters = function(widgets) {
    var resetElement, sortElement;
    sortElement = $('#featured-sort-box');
    resetElement = $('#featured-reset-box');
    if (!sortElement) {
      return;
    }
    sortElement.detach();
    resetElement.detach();
    this.$featuredContainer.append(sortElement);
    return this.$featuredContainer.append(resetElement);
  };

  RefinementUI.prototype._removeUnusedFeaturedFilters = function(widgets, currentCollections) {
    var collectionsToRemove, id, ids, j, len, ref;
    collectionsToRemove = [];
    ids = _.pluck(widgets, 'id');
    ref = Object.keys(this.featuredViews);
    for (j = 0, len = ref.length; j < len; j++) {
      id = ref[j];
      if (indexOf.call(ids, id) >= 0) {
        continue;
      }
      collectionsToRemove.push(this.featuredViews[id].collection.id);
      this._removeUnusedId(id);
    }
    return _.reject(currentCollections, function(collection) {
      var ref1;
      return ref1 = collection.id, indexOf.call(collectionsToRemove, ref1) >= 0;
    });
  };

  RefinementUI.prototype._addNewFeaturedFilters = function(widgets, newCollections) {
    var collection, j, len, refinement, view;
    for (j = 0, len = widgets.length; j < len; j++) {
      refinement = widgets[j];
      if (!(isFeaturedRefinement(refinement) && !this.featuredViews[refinement.id])) {
        continue;
      }
      this.$featuredContainer.append(templates.featured_widget.render({
        id: refinement.id,
        title: refinement.title,
        dataBhw: refinement.dataBhw
      }));
      collection = this._createRefinementCollection(refinement);
      this.refinementCollections[refinement.id] = collection;
      view = this._createFeaturedView(refinement, collection, this.$featuredContainer);
      this.featuredViews[refinement.id] = view;
      newCollections.push(collection);
      view.render();
    }
    return newCollections;
  };

  return RefinementUI;

})();

getCollectionForRefinement = function(refinement) {
  var refinementData, refinementOptions;
  if (refinement.rangeFilters) {
    refinementOptions = rangeRefinementCollectionOptions.toHash(refinement);
    return new Ranges(refinement.refinementData, refinementOptions);
  } else if (refinement.ratingFilters) {
    refinementOptions = ratingRefinementCollectionOptions.toHash(refinement);
    return new Ratings(refinement.refinementData, refinementOptions);
  } else if (refinement.dateTimeFilters) {
    refinementData = getRefinementData(refinement);
    refinementOptions = datetimeCollectionOptions.toHash(refinement);
    return new DatetimeCollection(refinementData, refinementOptions);
  } else {
    refinementData = getRefinementData(refinement);
    refinementOptions = refinementCollectionOptions.toHash(refinement);
    return new Refinements(refinementData, refinementOptions);
  }
};

getRefinementData = function(refinement) {
  var ref;
  return (ref = refinement.expandedRefinementData) != null ? ref : refinement.refinementData;
};

getView = function(refinement) {
  if (refinement.badgeFilters) {
    return BadgeFilters;
  }
  if (refinement.isQueryFilter) {
    return BreadcrumbQuery;
  }
  if (refinement.dateTimeFilters) {
    return DateTimeFilters;
  }
  if (refinement.flatRefinementLinks) {
    return LinksList;
  }
  if (refinement.rangeFilters) {
    return RangeFilters;
  }
  if (refinement.ratingFilters) {
    return RatingFilters;
  }
  if (refinement.resetFilters) {
    return ResetFilters;
  }
  if (refinement.sort) {
    return Sort;
  }
  return ParentNestedLinks;
};

getFeaturedView = function(refinement) {
  if (refinement.dateTimeFilters) {
    return FeaturedDateTimeFilters;
  }
  if (refinement.sort) {
    return FeaturedSort;
  }
  return FeaturedSelectionFilters;
};

isFeaturedRefinement = function(refinement) {
  var ref;
  return ref = refinement.id, indexOf.call(FEATURED_REFINEMENTS, ref) >= 0;
};

renderResetAll = function(container, featuredContainer, refinements) {
  var el, resetAll;
  el = container.find('#reset-all-container');
  resetAll = new ResetAll({
    refinements: refinements,
    el: el
  });
  return resetAll.render();
};

renderBreadcrumb = function(container, refinementCollections) {
  var el;
  el = container.find('#grui-breadcrumb-container');
  return new BreadcrumbsView({
    refinementCollections: refinementCollections,
    el: el
  }).render();
};

module.exports = window.RefinementUI = RefinementUI;

},{"../templates":116,"./collections/datetimes":70,"./collections/ranges":71,"./collections/ratings":72,"./collections/refinements":73,"./models/range":79,"./models/refinement":81,"./presenters/datetime_collection_options":82,"./presenters/range_refinement_collection_options":83,"./presenters/rating_refinement_collection_options":84,"./presenters/refinement_collection_options":85,"./views/badge_filters":87,"./views/breadcrumb_query":89,"./views/breadcrumbs":91,"./views/datetime_filters":94,"./views/featured/datetime_filters":96,"./views/featured/selection_filters":97,"./views/featured/sort":98,"./views/links_list":99,"./views/parent_nested_links":103,"./views/range_filters":105,"./views/rating_filters":107,"./views/reset_all":108,"./views/reset_filters":109,"./views/sort":111}],69:[function(require,module,exports){
var BreadcrumbModel, BreadcrumbsCollection,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

BreadcrumbModel = require('../models/breadcrumb');

module.exports = BreadcrumbsCollection = (function(superClass) {
  extend(BreadcrumbsCollection, superClass);

  function BreadcrumbsCollection() {
    return BreadcrumbsCollection.__super__.constructor.apply(this, arguments);
  }

  BreadcrumbsCollection.prototype.model = BreadcrumbModel;

  BreadcrumbsCollection.prototype.setNewRefinementCollections = function(refinementCollections, idsToRemove) {
    this._removeListeners(this.refinementCollections);
    this.refinementCollections = refinementCollections;
    this._applyListeners(refinementCollections);
    this._initSelectedValues(refinementCollections);
    return this._removeUnusedPills(idsToRemove);
  };

  BreadcrumbsCollection.prototype._initSelectedValues = function(refinementCollections) {
    var collection, key, results;
    results = [];
    for (key in refinementCollections) {
      collection = refinementCollections[key];
      if (this._supportsBreadcrumb(collection)) {
        results.push(this._updateSelections({
          id: collection.id,
          selectedValues: collection.getSelectedValues()
        }));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  BreadcrumbsCollection.prototype._parseSelectedValues = function(selectedValues, id) {
    return _.map(selectedValues, function(arg) {
      var friendlyNameHtml, friendlyNameShort, name, refinementId;
      name = arg.name, refinementId = arg.refinementId, friendlyNameHtml = arg.friendlyNameHtml, friendlyNameShort = arg.friendlyNameShort;
      return {
        name: name,
        refinementId: refinementId,
        friendlyNameHtml: friendlyNameHtml,
        friendlyNameShort: friendlyNameShort,
        selected: true,
        collectionId: id,
        id: id + "-" + refinementId
      };
    });
  };

  BreadcrumbsCollection.prototype._updateSelections = function(selectedModels) {
    var currentSelectedIds, id, newSelectedIds, newSelectedValues, selectedValues;
    selectedValues = selectedModels.selectedValues, id = selectedModels.id;
    newSelectedValues = this._parseSelectedValues(selectedValues, id);
    currentSelectedIds = _.pluck(this.where({
      collectionId: id
    }), 'id');
    newSelectedIds = _.pluck(newSelectedValues, 'id');
    if (currentSelectedIds.length) {
      this.remove(_.difference(currentSelectedIds, newSelectedIds));
    }
    return this.add(newSelectedValues);
  };

  BreadcrumbsCollection.prototype._applyListeners = function(refinementCollections) {
    var collection, key;
    for (key in refinementCollections) {
      collection = refinementCollections[key];
      if (this._supportsBreadcrumb(collection)) {
        this.listenTo(collection, 'selectedModels:updated', this._updateSelections);
      }
    }
    return this.on('change:selected', this._removeModel);
  };

  BreadcrumbsCollection.prototype._removeListeners = function(refinementCollections) {
    var collection, key;
    for (key in refinementCollections) {
      collection = refinementCollections[key];
      if (this._supportsBreadcrumb(collection)) {
        this.stopListening(collection, 'selectedModels:updated');
      }
    }
    return this.off('change:selected', this._removeModel);
  };

  BreadcrumbsCollection.prototype._removeModel = function(model, value, options) {
    var ref, ref1, ref2;
    if (!value) {
      this.remove(model);
      return (ref = this.refinementCollections) != null ? (ref1 = ref[model.get('collectionId')]) != null ? (ref2 = ref1.get(model.get('name'))) != null ? ref2.deselect() : void 0 : void 0 : void 0;
    }
  };

  BreadcrumbsCollection.prototype._removeUnusedPills = function(idsToRemove) {
    var i, id, len, pillsToRemove, ref, results;
    if (!(idsToRemove != null ? idsToRemove.length : void 0)) {
      return;
    }
    results = [];
    for (i = 0, len = idsToRemove.length; i < len; i++) {
      id = idsToRemove[i];
      if ((ref = (pillsToRemove = this.where({
        collectionId: id
      }))) != null ? ref.length : void 0) {
        results.push(this.remove(pillsToRemove));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  BreadcrumbsCollection.prototype._supportsBreadcrumb = function(collection) {
    var ref;
    return (collection != null) && (collection.multiselect || ((ref = collection.id) === 'rating' || ref === 'badge'));
  };

  return BreadcrumbsCollection;

})(Backbone.Collection);

},{"../models/breadcrumb":78}],70:[function(require,module,exports){
(function (global){
var DEFAULT_SELECTIONS, DateTimeHelper, Datetimes, Refinements, _,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Refinements = require('./refinements');

DateTimeHelper = require('../helpers/datetime_helper');

_ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

DEFAULT_SELECTIONS = ["anytime", "anyday"];

module.exports = Datetimes = (function(superClass) {
  extend(Datetimes, superClass);

  function Datetimes() {
    return Datetimes.__super__.constructor.apply(this, arguments);
  }

  Datetimes.prototype.initialize = function(models, options) {
    if (options == null) {
      options = {};
    }
    Datetimes.__super__.initialize.apply(this, arguments);
    this.explanation = options.explanation;
    this.options = options;
    ({
      days: [],
      shortMonths: [],
      times: {}
    });
    return this.createArrays();
  };

  Datetimes.prototype.anySelected = function() {
    var selectedValues;
    selectedValues = _.reject(this.getSelectedValues(), function(value) {
      var ref, ref1;
      return ref = (ref1 = value.selectedValues[0]) != null ? ref1.name : void 0, indexOf.call(DEFAULT_SELECTIONS, ref) >= 0;
    });
    return selectedValues.length > 0;
  };

  Datetimes.prototype.deselectAll = function(options) {
    if (options == null) {
      options = {};
    }
    this.get('date').nestedRefinements.get('anyday').select(options);
    return this.get('time').nestedRefinements.get('anytime').select(options);
  };

  Datetimes.prototype.createArrays = function() {
    this.days = DateTimeHelper.getDayArray();
    this.shortMonths = DateTimeHelper.createMonthArray();
    return this.times = DateTimeHelper.createTimeHash();
  };

  Datetimes.prototype.toHash = function() {
    var baseHash, collectionHash, populatedDates, populatedTimes, rawDates, rawTimes, ref;
    baseHash = {
      id: this.id,
      collection_id: this.id,
      selectedClass: this.id + "-selected"
    };
    collectionHash = this.toJSON();
    rawDates = _.findWhere(collectionHash, {
      "id": "date"
    });
    rawTimes = _.findWhere(collectionHash, {
      "id": "time"
    });
    populatedDates = rawDates ? this._populateDateData(rawDates) : [];
    populatedTimes = rawTimes ? this._populateTimeData(rawTimes) : [];
    return _.extend(baseHash, {
      dateTimeFilter: true,
      explanation: (ref = this.explanation) != null ? ref : '',
      dates: populatedDates,
      times: populatedTimes,
      refinementData: collectionHash,
      showRefinementBox: true,
      title: DateTimeHelper.getTitle(),
      dataBhw: this.dataBhw
    });
  };

  Datetimes.prototype._populateDateData = function(rawDates) {
    var displayName, i, len, name, rawDate, ref, ref1, shortDateString;
    if (!rawDates) {
      return;
    }
    ref = rawDates.children;
    for (i = 0, len = ref.length; i < len; i++) {
      rawDate = ref[i];
      rawDate.selected = rawDate.selected || false;
      if (rawDate.displayName) {
        continue;
      }
      name = rawDate.id;
      if (indexOf.call(this.days, name) >= 0) {
        displayName = (ref1 = rawDate.friendlyNameShort) != null ? ref1 : rawDate.friendlyName;
        shortDateString = this._getShortDateString(name);
        if (shortDateString) {
          displayName += ", " + shortDateString;
        }
        rawDate.displayName = displayName;
      } else {
        rawDate.displayName = rawDate.friendlyName;
      }
    }
    return rawDates;
  };

  Datetimes.prototype._populateTimeData = function(rawTimes) {
    var i, len, rawTime, ref;
    if (!rawTimes) {
      return;
    }
    ref = rawTimes.children;
    for (i = 0, len = ref.length; i < len; i++) {
      rawTime = ref[i];
      rawTime.selected = rawTime.selected || false;
      if (!rawTime.displayName) {
        rawTime.displayName = rawTime.friendlyName;
      }
    }
    return rawTimes;
  };

  Datetimes.prototype._getShortDateString = function(day) {
    var currentDay, date, delta, searchDay;
    date = new Date();
    currentDay = date.getDay();
    searchDay = this.days.indexOf(day);
    if (!(searchDay <= 6)) {
      return;
    }
    if (currentDay >= searchDay) {
      delta = 7 - currentDay + searchDay;
    } else {
      delta = searchDay - currentDay;
    }
    date.setDate(date.getDate() + delta);
    return this.shortMonths[date.getMonth()] + " " + date.getDate();
  };

  return Datetimes;

})(Refinements);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../helpers/datetime_helper":75,"./refinements":73}],71:[function(require,module,exports){
var Ranges, Refinements,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Refinements = require('./refinements');

module.exports = Ranges = (function(superClass) {
  extend(Ranges, superClass);

  function Ranges() {
    this._updateModel = bind(this._updateModel, this);
    return Ranges.__super__.constructor.apply(this, arguments);
  }

  Ranges.prototype.initialize = function(models, options) {
    if (options == null) {
      options = {};
    }
    this.id = options.id, this.multiselect = options.multiselect;
    return this.on('change:updated', this._updateModel);
  };

  Ranges.prototype.anySelected = function() {
    return !!this.filter(function(model) {
      return model.isNotDefault();
    }).length;
  };

  Ranges.prototype.getSelectedValues = function() {
    return this.reduce(((function(_this) {
      return function(memo, refinement) {
        if (!refinement.isNotDefault()) {
          return memo;
        }
        memo.push(_this._selectedHash(refinement));
        return memo;
      };
    })(this)), []);
  };

  Ranges.prototype.setOrdered = function() {
    Refinements.prototype.setOrdered.apply(this, arguments);
    return this.triggerModelsUpdated({
      queue: true
    });
  };

  Ranges.prototype._selectedHash = function(refinement) {
    var friendlyNameShort, id, name, ref, refinementId, selectedMax, selectedMin, showPriceRangeButton, unit;
    selectedMin = refinement.get('selectedMin');
    selectedMax = refinement.get('selectedMax');
    showPriceRangeButton = refinement.get('showPriceRangeButton');
    id = name = refinement.get('id');
    unit = (ref = refinement.get('unit')) != null ? ref : '';
    refinementId = id + ":" + selectedMin + "-" + selectedMax;
    friendlyNameShort = "" + unit + selectedMin + " - " + unit + selectedMax;
    return {
      id: id,
      name: name,
      refinementId: refinementId,
      friendlyNameShort: friendlyNameShort,
      selectedMin: selectedMin,
      selectedMax: selectedMax,
      showPriceRangeButton: showPriceRangeButton
    };
  };

  Ranges.prototype._updateModel = function(model, value, options) {
    if (value) {
      if (!options.preventTrigger) {
        this.triggerModelsUpdated(options);
      }
      return model.set('updated', false, {
        silent: true
      });
    }
  };

  return Ranges;

})(Refinements);

},{"./refinements":73}],72:[function(require,module,exports){
var Ratings, Refinements,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Refinements = require('./refinements');

module.exports = Ratings = (function(superClass) {
  extend(Ratings, superClass);

  function Ratings() {
    return Ratings.__super__.constructor.apply(this, arguments);
  }

  Ratings.prototype.initialize = function(models, options) {
    if (options == null) {
      options = {};
    }
    this.id = options.id, this.multiselect = options.multiselect, this.title = options.title, this.showCollapseControl = options.showCollapseControl, this.collapseFilter = options.collapseFilter;
    return this.on('change:selected', this._handleSelect);
  };

  Ratings.prototype.getSelectedValues = function() {
    return this.reduce(((function(_this) {
      return function(memo, refinement) {
        if (refinement.get('selected')) {
          memo.push(_this._selectedHash(refinement));
        }
        return memo;
      };
    })(this)), []);
  };

  Ratings.prototype._selectedHash = function(refinement) {
    var friendlyNameHtml, friendlyNameShort, name, refinementId;
    refinementId = name = refinement.get('id');
    friendlyNameShort = refinement.get('friendlyName');
    friendlyNameHtml = refinement.getFriendlyNameHtml();
    return {
      friendlyNameShort: friendlyNameShort,
      friendlyNameHtml: friendlyNameHtml,
      id: this.id,
      name: name,
      refinementId: refinementId
    };
  };

  Ratings.prototype._handleSelect = function(model, value, options) {
    if (model.get('selected')) {
      _.each(this.without(model), function(refinement) {
        return refinement.deselect({
          preventTrigger: true
        });
      });
    }
    if (!options.preventTrigger) {
      return this.triggerModelsUpdated();
    }
  };

  return Ratings;

})(Refinements);

},{"./refinements":73}],73:[function(require,module,exports){
var Refinements,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

module.exports = Refinements = (function(superClass) {
  extend(Refinements, superClass);

  function Refinements() {
    this._updateSelectedModels = bind(this._updateSelectedModels, this);
    this.triggerModelsUpdated = bind(this.triggerModelsUpdated, this);
    return Refinements.__super__.constructor.apply(this, arguments);
  }

  Refinements.prototype.initialize = function(models, options) {
    if (options == null) {
      options = {};
    }
    this.dataBhw = options.dataBhw, this.flatRefinements = options.flatRefinements, this.hasCheckbox = options.hasCheckbox, this.id = options.id, this.level = options.level, this.max = options.max, this.multiselect = options.multiselect, this.prefix = options.prefix, this.refinementData = options.refinementData, this.title = options.title, this.useSimplifiedCategory = options.useSimplifiedCategory, this.l1Category = options.l1Category, this.useExpandedRefinementData = options.useExpandedRefinementData, this.updateSelectedOnReset = options.updateSelectedOnReset, this.isQueryFilter = options.isQueryFilter, this.showCollapseControl = options.showCollapseControl, this.collapseFilter = options.collapseFilter, this.showMoreSearch = options.showMoreSearch, this.showMoreSearchMax = options.showMoreSearchMax, this.showMoreSearchPlaceholder = options.showMoreSearchPlaceholder;
    return this.on('change:selected', this._updateSelectedModels);
  };

  Refinements.prototype.deselectAll = function(options) {
    if (options == null) {
      options = {};
    }
    this.invoke('deselect', {
      preventTrigger: true
    });
    return this.triggerModelsUpdated(options);
  };

  Refinements.prototype.setOrdered = function(arg, updateOptions) {
    var expandedRefinementData, refinementData;
    refinementData = arg.refinementData, expandedRefinementData = arg.expandedRefinementData;
    if (expandedRefinementData != null) {
      this.refinementData = refinementData;
      return this._resetRefinementData(expandedRefinementData, updateOptions);
    } else if (this._orderMatches(refinementData)) {
      return this.set(refinementData, updateOptions);
    } else {
      return this._resetRefinementData(refinementData, updateOptions);
    }
  };

  Refinements.prototype.anySelected = function() {
    return !!this.where({
      selected: true
    }).length;
  };

  Refinements.prototype.getSelectedValues = function() {
    var selectedIDs;
    selectedIDs = [];
    this.each((function(_this) {
      return function(refinement) {
        if (refinement.get('selected')) {
          return selectedIDs.push(_this._selectedHash(refinement));
        }
      };
    })(this));
    return selectedIDs;
  };

  Refinements.prototype.triggerModelsUpdated = function(options) {
    if (options == null) {
      options = {};
    }
    return this.trigger('selectedModels:updated', {
      id: this.id,
      selectedValues: this.getSelectedValues(),
      queue: !!options.queue
    });
  };

  Refinements.prototype._resetRefinementData = function(refinementData, updateOptions) {
    this.reset(refinementData, updateOptions);
    if (this.updateSelectedOnReset) {
      return this.triggerModelsUpdated({
        queue: true
      });
    }
  };

  Refinements.prototype._updateSelectedModels = function(model, value, options) {
    if (!this.multiselect && model.get('selected')) {
      _.each(this.without(model), function(refinement) {
        return refinement.deselect({
          preventTrigger: true
        });
      });
    }
    if (!options.preventTrigger) {
      return this.triggerModelsUpdated(options);
    }
  };

  Refinements.prototype._selectedHash = function(refinement) {
    var name;
    name = refinement.get('id');
    return {
      id: this.id,
      name: name,
      refinementId: name,
      friendlyNameShort: refinement.get('friendlyNameShort'),
      selectedValues: refinement.nestedRefinements.getSelectedValues()
    };
  };

  Refinements.prototype._orderMatches = function(newModels) {
    var mismatch;
    if (newModels.length !== this.models.length) {
      return false;
    }
    mismatch = _.find(newModels, (function(_this) {
      return function(newModel, index) {
        return _this.get(newModel.id) && _this.models[index].id !== newModel.id;
      };
    })(this));
    return !mismatch;
  };

  return Refinements;

})(Backbone.Collection);

},{}],74:[function(require,module,exports){
var AgeHelper, i18n;

i18n = require('../i18n')();

module.exports = AgeHelper = {
  getAgeTitle: function() {
    return i18n.translate('refinements.ages.title');
  },
  getAgeHash: function() {
    var ageHash, i, invertedAgeHash, key, len, ref;
    ageHash = {};
    invertedAgeHash = {
      "infants": "e8674e25-c666-42c7-ba0b-3876daf67925",
      "toddlers": "4a8b54a3-464d-44b0-acf0-23d587a76b01",
      "grade": "a1e47973-f106-4933-b7dc-b9084a2f4f97",
      "tweens": "80a3a62f-96c3-4719-a830-438e9a20c37c",
      "teens": "719f0fc4-d37a-41f2-9c62-9ac24a8c9c3e"
    };
    ref = Object.keys(invertedAgeHash);
    for (i = 0, len = ref.length; i < len; i++) {
      key = ref[i];
      ageHash[invertedAgeHash[key]] = i18n.translate("refinements.ages." + key);
    }
    return ageHash;
  }
};

},{"../i18n":76}],75:[function(require,module,exports){
(function (global){
var DateTimeHelper, _, i18n;

i18n = require('../i18n')();

_ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

module.exports = DateTimeHelper = {
  getTitle: function() {
    return i18n.translate('refinements.datetime.title');
  },
  getDayArray: function() {
    return ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  },
  createMonthArray: function() {
    var months;
    months = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "december"];
    return _.map(months, function(month) {
      return i18n.translate("refinements.datetime.short_months." + month);
    });
  },
  createTimeHash: function() {
    var times;
    times = ["now", "morning", "afternoon", "evening", "anytime"];
    return _.map(times, function(time) {
      return i18n.translate("refinements.datetime.times." + time);
    });
  }
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../i18n":76}],76:[function(require,module,exports){
var allTranslations, myI18n;

allTranslations = require('../../translations.json');

myI18n = void 0;

module.exports = function() {
  if (myI18n) {
    return myI18n;
  }
  myI18n = I18n.scoped();
  myI18n.translations = {
    refinements: allTranslations[I18n.locale].modules.refinements,
    number: I18n.translations.number
  };
  return myI18n;
};

},{"../../translations.json":117}],77:[function(require,module,exports){
module.exports = _.mixin({
  preventDefaultAndDefer: function(eventName) {
    return function(e) {
      e.preventDefault();
      return _.defer((function(_this) {
        return function() {
          return typeof _this[eventName] === "function" ? _this[eventName](e) : void 0;
        };
      })(this));
    };
  }
});

},{}],78:[function(require,module,exports){
var Breadcrumb,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Breadcrumb = (function(superClass) {
  extend(Breadcrumb, superClass);

  function Breadcrumb() {
    return Breadcrumb.__super__.constructor.apply(this, arguments);
  }

  Breadcrumb.prototype.deselect = function() {
    return this.set('selected', false);
  };

  return Breadcrumb;

})(Backbone.Model);

module.exports = Breadcrumb;

},{}],79:[function(require,module,exports){
var Range, i18n,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

i18n = require('../i18n')();

module.exports = Range = (function(superClass) {
  extend(Range, superClass);

  function Range() {
    return Range.__super__.constructor.apply(this, arguments);
  }

  Range.prototype.deselect = function(options) {
    var displayedMax, displayedMin, selectedMax, selectedMin;
    displayedMin = selectedMin = this.get('rangeMin');
    displayedMax = selectedMax = this.get('rangeMax');
    return this.set({
      displayedMin: displayedMin,
      displayedMax: displayedMax,
      selectedMin: selectedMin,
      selectedMax: selectedMax,
      updated: true
    }, options);
  };

  Range.prototype.isNotDefault = function() {
    return (this.get('selectedMin') !== this.get('rangeMin')) || (this.get('selectedMax') !== this.get('rangeMax'));
  };

  Range.prototype.validateMin = function(newMin) {
    var err, rangeMin;
    if (isNaN(newMin)) {
      err = i18n.translate('refinements.error_nan_input', {
        input: this.get('unitName')
      });
    } else if (newMin < (rangeMin = this.get('rangeMin'))) {
      err = i18n.translate('refinements.error_oob_input', {
        bound: 'Min',
        unit: this.get('unit'),
        value: rangeMin
      });
    } else if (newMin > this.get('displayedMax')) {
      err = i18n.translate('refinements.error_invalid_input', {
        selectedBound: 'Min',
        comparison: 'less',
        otherBound: 'max'
      });
    }
    return err;
  };

  Range.prototype.validateMax = function(newMax) {
    var err, rangeMax;
    if (isNaN(newMax)) {
      err = i18n.translate('refinements.error_nan_input', {
        input: this.get('unitName')
      });
    } else if (newMax > (rangeMax = this.get('rangeMax'))) {
      err = i18n.translate('refinements.error_oob_input', {
        bound: 'Max',
        unit: this.get('unit'),
        value: rangeMax
      });
    } else if (newMax < this.get('displayedMin')) {
      err = i18n.translate('refinements.error_invalid_input', {
        selectedBound: 'Max',
        comparison: 'greater',
        otherBound: 'min'
      });
    }
    return err;
  };

  return Range;

})(Backbone.Model);

},{"../i18n":76}],80:[function(require,module,exports){
var Rating, ratingNameTemplate, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

templates = require('../../templates');

ratingNameTemplate = templates['rating_name'];

module.exports = Rating = (function(superClass) {
  extend(Rating, superClass);

  function Rating() {
    return Rating.__super__.constructor.apply(this, arguments);
  }

  Rating.prototype.select = function(options) {
    if (options == null) {
      options = {};
    }
    return this.set('selected', true, options);
  };

  Rating.prototype.deselect = function(options) {
    if (options == null) {
      options = {};
    }
    return this.set('selected', false, options);
  };

  Rating.prototype.toggleSelected = function(options) {
    if (options == null) {
      options = {};
    }
    if (!this.get('selected')) {
      return this.select(options);
    }
  };

  Rating.prototype._getFriendlyNameHtmlHash = function() {
    var iconData, val;
    iconData = (function() {
      var i, ref, results;
      results = [];
      for (val = i = 0, ref = this.get('iconValue'); 0 <= ref ? i < ref : i > ref; val = 0 <= ref ? ++i : --i) {
        results.push({});
      }
      return results;
    }).call(this);
    return {
      iconData: iconData,
      friendlyName: this.get('friendlyName'),
      suffix: this.get('suffix')
    };
  };

  Rating.prototype.getFriendlyNameHtml = function() {
    return ratingNameTemplate.render(this._getFriendlyNameHtmlHash());
  };

  return Rating;

})(Backbone.Model);

},{"../../templates":116}],81:[function(require,module,exports){
(function (global){
var Refinement, find,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

find = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null).find;

Refinement = (function(superClass) {
  extend(Refinement, superClass);

  function Refinement() {
    this._updateNestedRefinements = bind(this._updateNestedRefinements, this);
    return Refinement.__super__.constructor.apply(this, arguments);
  }

  Refinement.prototype.defaults = function() {
    var ref;
    return {
      children: [],
      hasCheckbox: (ref = this.collection) != null ? ref.hasCheckbox : void 0
    };
  };

  Refinement.prototype.initialize = function() {
    this.refinementCollectionOptions = require('../presenters/refinement_collection_options');
    this.Refinements = require('../collections/refinements');
    this.nestedRefinements = this._createNestedCollections();
    this.set('lowestSelected', this._isLowestSelected());
    this.set('isLastLevel', this._isLastLevel());
    this.set('isLastButOneLevel', this._isLastButOneLevel());
    this.set('showCollapseControl', this.collection.showCollapseControl);
    this._setCategoryVisibility();
    this._listenToChildren();
    this.on('change:selected', (function(_this) {
      return function() {
        _this.set('lowestSelected', _this._isLowestSelected());
        return _this._setCategoryVisibility();
      };
    })(this));
    return this.on('change:children', this._updateNestedRefinements);
  };

  Refinement.prototype.select = function(options) {
    var ref;
    if (options == null) {
      options = {};
    }
    if (!this.get('selected')) {
      this.set('selected', true, options);
    }
    return (ref = this.nestedRefinements) != null ? ref.invoke('deselect') : void 0;
  };

  Refinement.prototype.deselect = function(options) {
    var ref;
    if (options == null) {
      options = {};
    }
    this.set('selected', false, options);
    return (ref = this.nestedRefinements) != null ? ref.invoke('deselect', {
      preventTrigger: true
    }) : void 0;
  };

  Refinement.prototype.toggleSelected = function(options) {
    var ref;
    if (options == null) {
      options = {};
    }
    if ((ref = this.collection) != null ? ref.multiselect : void 0) {
      if (this.get('selected')) {
        return this.deselect(options);
      } else {
        return this.select(options);
      }
    } else {
      return this.select(options);
    }
  };

  Refinement.prototype.toJSON = function() {
    var superMethod;
    superMethod = Backbone.Model.prototype.toJSON.apply(this, arguments);
    return _.extend({}, superMethod, {
      children: this.nestedRefinements.toJSON()
    });
  };

  Refinement.prototype._isLowestSelected = function() {
    if (!this.get('selected')) {
      return false;
    }
    return !this.nestedRefinements.anySelected();
  };

  Refinement.prototype._isLastLevel = function() {
    return !this.get('children').length;
  };

  Refinement.prototype._isLastButOneLevel = function() {
    if (!this.get('children').length) {
      return false;
    }
    return find(this.get('children'), function(child) {
      var ref;
      return (child != null ? (ref = child.children) != null ? ref.length : void 0 : void 0) > 0;
    }) == null;
  };

  Refinement.prototype._setCategoryVisibility = function() {
    if (this.collection.useSimplifiedCategory) {
      return this.set({
        simplifiedShow: this.get('selected') || this.nestedRefinements.anySelected(),
        useSimplifiedCategory: true
      });
    }
  };

  Refinement.prototype._createNestedCollections = function() {
    var refinementOptions;
    refinementOptions = this.refinementCollectionOptions.toHash(this.collection);
    return new this.Refinements(this.get('children'), refinementOptions);
  };

  Refinement.prototype._listenToChildren = function() {
    return this.listenTo(this.nestedRefinements, 'selectedModels:updated', (function(_this) {
      return function() {
        var ref;
        _this.set('lowestSelected', _this._isLowestSelected());
        return (ref = _this.collection) != null ? ref.triggerModelsUpdated.apply(ref, arguments) : void 0;
      };
    })(this));
  };

  Refinement.prototype._updateNestedRefinements = function(model, newValue, options) {
    return this.nestedRefinements.set(newValue);
  };

  return Refinement;

})(Backbone.Model);

module.exports = Refinement;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../collections/refinements":73,"../presenters/refinement_collection_options":85}],82:[function(require,module,exports){
var Refinement;

Refinement = require('../models/refinement');

module.exports = {
  toHash: function(refinementCollection) {
    if (!refinementCollection) {
      return {};
    }
    return {
      dataBhw: refinementCollection.dataBhw,
      id: refinementCollection.id,
      model: Refinement,
      multiselect: refinementCollection.multiselect,
      title: refinementCollection.title,
      updateSelectedOnReset: refinementCollection.updateSelectedOnReset,
      explanation: refinementCollection.explanation
    };
  }
};

},{"../models/refinement":81}],83:[function(require,module,exports){
var Range;

Range = require('../models/range');

module.exports = {
  toHash: function(refinementCollection) {
    if (!refinementCollection) {
      return {};
    }
    return _.extend(_.pick(refinementCollection, 'id', 'multiselect'), {
      model: Range
    });
  }
};

},{"../models/range":79}],84:[function(require,module,exports){
var Rating;

Rating = require('../models/rating');

module.exports = {
  toHash: function(refinementCollection) {
    if (!refinementCollection) {
      return {};
    }
    return _.extend(_.pick(refinementCollection, 'id', 'multiselect', 'title', 'showCollapseControl', 'collapseFilter'), {
      model: Rating
    });
  }
};

},{"../models/rating":80}],85:[function(require,module,exports){
var Refinement, findLevel, findRefinementId, findRefinementPrefix;

Refinement = require('../models/refinement');

module.exports = {
  toHash: function(refinementCollection) {
    var level;
    if (!refinementCollection) {
      return {};
    }
    level = findLevel(refinementCollection);
    return {
      dataBhw: refinementCollection.dataBhw,
      flatRefinements: !!refinementCollection.flatRefinementLinks,
      hasCheckbox: refinementCollection.hasCheckbox,
      id: findRefinementId(refinementCollection, level),
      level: level,
      max: refinementCollection.max,
      model: Refinement,
      multiselect: refinementCollection.multiselect,
      prefix: findRefinementPrefix(refinementCollection, level),
      refinementData: refinementCollection.useExpandedRefinementData ? refinementCollection.refinementData : void 0,
      title: refinementCollection.title,
      useExpandedRefinementData: refinementCollection.useExpandedRefinementData,
      updateSelectedOnReset: refinementCollection.updateSelectedOnReset,
      useSimplifiedCategory: refinementCollection.useSimplifiedCategory,
      l1Category: refinementCollection.l1Category,
      isQueryFilter: refinementCollection.isQueryFilter,
      showCollapseControl: refinementCollection.showCollapseControl,
      collapseFilter: refinementCollection.collapseFilter,
      showMoreSearch: refinementCollection.showMoreSearch,
      showMoreSearchMax: refinementCollection.showMoreSearchMax,
      showMoreSearchPlaceholder: refinementCollection.showMoreSearchPlaceholder
    };
  }
};

findRefinementId = function(refinements, level) {
  if (level === 1) {
    return refinements.id;
  }
  return "" + refinements.prefix + level;
};

findLevel = function(refinements) {
  if (refinements.level) {
    return refinements.level + 1;
  } else {
    return 1;
  }
};

findRefinementPrefix = function(refinements, level) {
  if (level === 1) {
    return refinements.id;
  }
  return refinements.prefix;
};

},{"../models/refinement":81}],86:[function(require,module,exports){
var Badge, partials, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

templates = require('../../templates');

partials = {
  radio: templates['radio']
};

module.exports = Badge = (function(superClass) {
  extend(Badge, superClass);

  function Badge() {
    return Badge.__super__.constructor.apply(this, arguments);
  }

  Badge.prototype.template = templates['badge'];

  Badge.prototype.events = {
    'click': _.preventDefaultAndDefer('_handleClick')
  };

  Badge.prototype.initialize = function() {
    this.listenTo(this.model, 'change:selected', this.render);
    return this.listenTo(this.model, 'remove', this.remove);
  };

  Badge.prototype.render = function() {
    this.$el.html(this.template.render(this.model.toJSON(), partials));
    return this;
  };

  Badge.prototype._handleClick = function() {
    return this.model.toggleSelected();
  };

  return Badge;

})(Backbone.View);

},{"../../templates":116,"../mixins/underscore":77}],87:[function(require,module,exports){
var Badge, BadgeFilters, ClearReset, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Badge = require('./badge');

ClearReset = require('./clear_reset');

templates = require('../../templates');

module.exports = BadgeFilters = (function(superClass) {
  extend(BadgeFilters, superClass);

  function BadgeFilters() {
    return BadgeFilters.__super__.constructor.apply(this, arguments);
  }

  BadgeFilters.prototype.template = templates['badges'];

  BadgeFilters.prototype.events = {
    'click .toggle-refinements': '_toggleRefinementRange'
  };

  BadgeFilters.prototype.initialize = function() {
    return this.listenTo(this.collection, 'add remove reset', this.render);
  };

  BadgeFilters.prototype.render = function() {
    this.$el.empty();
    this.$el.html(this.template.render(this._toHash()));
    this.cacheElem();
    this._addAllBadges();
    this._addClearReset();
    return this;
  };

  BadgeFilters.prototype._toHash = function() {
    return {
      id: this.collection.id,
      title: this.collection.title,
      showRefinementBox: this.collection.length,
      showCollapseControl: this.collection.showCollapseControl,
      collapseFilter: this.collection.collapseFilter
    };
  };

  BadgeFilters.prototype.cacheElem = function() {
    this.$badgeContainer = this.$el.find('.refinement-badges-list');
    this.$clearContainer = this.$el.find('.refinement-badges-clear');
    return this.$refinementBadge = this.$el.find('.refinement-badges');
  };

  BadgeFilters.prototype._addBadge = function(model) {
    var badgeView;
    badgeView = new Badge({
      model: model
    });
    return badgeView.render().el;
  };

  BadgeFilters.prototype._addAllBadges = function() {
    return this.$badgeContainer.append(this.collection.map((function(_this) {
      return function(model) {
        return _this._addBadge(model);
      };
    })(this)));
  };

  BadgeFilters.prototype._addClearReset = function() {
    var clearView;
    clearView = new ClearReset({
      collection: this.collection
    });
    return this.$clearContainer.html(clearView.render().el);
  };

  BadgeFilters.prototype._toggleRefinementRange = function(ev) {
    $(ev.currentTarget).toggleClass("icon-arrow-down-large icon-arrow-up-large");
    return this.$refinementBadge.stop().slideToggle();
  };

  return BadgeFilters;

})(Backbone.View);

},{"../../templates":116,"./badge":86,"./clear_reset":93}],88:[function(require,module,exports){
var BreadcrumbView, templates;

templates = require('../../templates');

BreadcrumbView = Backbone.View.extend({
  template: templates['breadcrumb'],
  events: {
    'click': 'deselect'
  },
  className: 'grui-breadcrumb-pill c-bg-prim c-txt-white',
  tagName: 'div',
  initialize: function() {
    return this.listenTo(this.model, 'change:selected remove', this.remove);
  },
  render: function() {
    this.$el.html(this.template.render(this.model.toJSON()));
    return this;
  },
  deselect: function(e) {
    e.preventDefault();
    return this.model.deselect();
  }
});

module.exports = BreadcrumbView;

},{"../../templates":116}],89:[function(require,module,exports){
var BreadcrumbQuery, ResetFilters, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

ResetFilters = require('./reset_filters');

templates = require('../../templates');

module.exports = BreadcrumbQuery = (function(superClass) {
  extend(BreadcrumbQuery, superClass);

  function BreadcrumbQuery() {
    return BreadcrumbQuery.__super__.constructor.apply(this, arguments);
  }

  BreadcrumbQuery.prototype.template = templates['breadcrumb_query'];

  BreadcrumbQuery.prototype.partials = {
    breadcrumb: templates['breadcrumb']
  };

  BreadcrumbQuery.prototype.events = {
    'click .grui-breadcrumb-pill': _.preventDefaultAndDefer('_clearFilter')
  };

  BreadcrumbQuery.prototype._getHtml = function() {
    return this.template.render(this._getViewModel(), this.partials);
  };

  BreadcrumbQuery.prototype._getViewModel = function() {
    var ref, viewModel;
    viewModel = (ref = this.collection.findWhere({
      selected: true
    })) != null ? ref.toJSON() : void 0;
    if (viewModel != null) {
      viewModel.friendlyNameShort = "\"" + viewModel.friendlyName + "\"";
    }
    return {
      query: viewModel
    };
  };

  return BreadcrumbQuery;

})(ResetFilters);

},{"../../templates":116,"../mixins/underscore":77,"./reset_filters":109}],90:[function(require,module,exports){
var BreadcrumbReset, ResetAll, i18n, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

ResetAll = require('./reset_all');

templates = require('../../templates');

i18n = require('../i18n')();

module.exports = BreadcrumbReset = (function(superClass) {
  extend(BreadcrumbReset, superClass);

  function BreadcrumbReset() {
    return BreadcrumbReset.__super__.constructor.apply(this, arguments);
  }

  BreadcrumbReset.prototype.template = templates['breadcrumb'];

  BreadcrumbReset.prototype.className = 'grui-breadcrumb-reset-pill c-bd-grey-md';

  BreadcrumbReset.prototype.tagName = 'div';

  BreadcrumbReset.prototype._toHash = function() {
    return {
      friendlyNameShort: i18n.translate('refinements.reset'),
      id: 'grui-breadcrumb-reset'
    };
  };

  return BreadcrumbReset;

})(ResetAll);

},{"../../templates":116,"../i18n":76,"./reset_all":108}],91:[function(require,module,exports){
var BreadcrumbResetView, BreadcrumbView, BreadcrumbsCollection, BreadcrumbsView, RESET_FILTER_MIN_COUNT, i18n, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

BreadcrumbView = require('./breadcrumb');

BreadcrumbsCollection = require('../collections/breadcrumbs');

BreadcrumbResetView = require('./breadcrumb_reset');

templates = require('../../templates');

i18n = require('../i18n')();

RESET_FILTER_MIN_COUNT = 2;

BreadcrumbsView = (function(superClass) {
  extend(BreadcrumbsView, superClass);

  function BreadcrumbsView() {
    return BreadcrumbsView.__super__.constructor.apply(this, arguments);
  }

  BreadcrumbsView.prototype.template = templates['breadcrumb_filters'];

  BreadcrumbsView.prototype.initialize = function(options) {
    var refinementCollections;
    if (options == null) {
      options = {};
    }
    refinementCollections = options.refinementCollections, this.resetFilterMin = options.resetFilterMin;
    this.breadcrumbViews = {};
    if (this.resetFilterMin == null) {
      this.resetFilterMin = RESET_FILTER_MIN_COUNT;
    }
    this.collection = new BreadcrumbsCollection();
    this.resetAllView = new BreadcrumbResetView({
      refinements: refinementCollections
    });
    this.resetRefinements(refinementCollections);
    return this._applyListeners();
  };

  BreadcrumbsView.prototype.render = function() {
    this.$el.html(this.template.render(this._toHash()));
    this._cacheElem();
    this._toggleVisibility();
    this._addAllBreadcrumbHtml();
    return this;
  };

  BreadcrumbsView.prototype.resetRefinements = function(refinementCollections, idsToRemove) {
    if (refinementCollections == null) {
      refinementCollections = {};
    }
    return this.collection.setNewRefinementCollections(refinementCollections, idsToRemove);
  };

  BreadcrumbsView.prototype._toHash = function() {
    return {
      breadcrumbTitle: i18n.translate('refinements.selected_filters')
    };
  };

  BreadcrumbsView.prototype._applyListeners = function() {
    this.listenTo(this.collection, 'add', this._appendBreadcrumbView);
    this.listenTo(this.collection, 'remove', this._handleRemove);
    return this.listenTo(this.collection, 'add remove reset', this._toggleVisibility);
  };

  BreadcrumbsView.prototype._cacheElem = function() {
    this.$breadcrumbContainer = this.$el.find('.grui-breadcrumb-container');
    return this.$resetAllContainer = this.$el.find('.grui-breadcrumb-reset-container');
  };

  BreadcrumbsView.prototype._shouldShowResetView = function() {
    return this.collection.length > this.resetFilterMin;
  };

  BreadcrumbsView.prototype._toggleResetShow = function() {
    if (this._shouldShowResetView()) {
      return this.$resetAllContainer.show();
    } else {
      return this.$resetAllContainer.hide();
    }
  };

  BreadcrumbsView.prototype._toggleBreadcrumbs = function() {
    if (this.collection.length) {
      return this.$el.show();
    } else {
      return this.$el.hide();
    }
  };

  BreadcrumbsView.prototype._toggleVisibility = function() {
    this._toggleBreadcrumbs();
    return this._toggleResetShow();
  };

  BreadcrumbsView.prototype._removeBreadcrumbView = function(id) {
    var ref;
    if ((ref = this.breadcrumbViews[id]) != null) {
      ref.remove();
    }
    return delete this.breadcrumbViews[id];
  };

  BreadcrumbsView.prototype._removeAllBreadcrumbViews = function() {
    var id;
    for (id in this.breadcrumbViews) {
      this._removeBreadcrumbView(id);
    }
    return this.breadcrumbViews = {};
  };

  BreadcrumbsView.prototype._handleRemove = function(model) {
    return this._removeBreadcrumbView(model.get('id'));
  };

  BreadcrumbsView.prototype._getBreadcrumbView = function(model) {
    return (new BreadcrumbView({
      model: model
    })).render();
  };

  BreadcrumbsView.prototype._addBreadcrumbView = function(model) {
    return this.breadcrumbViews[model.get('id')] = this._getBreadcrumbView(model);
  };

  BreadcrumbsView.prototype._appendBreadcrumbView = function(model) {
    return this.$breadcrumbContainer.append(this._addBreadcrumbView(model).el);
  };

  BreadcrumbsView.prototype._getBreadcrumbHtml = function(model) {
    return this._addBreadcrumbView(model).el;
  };

  BreadcrumbsView.prototype._getAllBreadcrumbHtml = function(collection) {
    if (collection == null) {
      collection = [];
    }
    this._removeAllBreadcrumbViews();
    return collection.map((function(_this) {
      return function(model) {
        return _this._getBreadcrumbHtml(model);
      };
    })(this));
  };

  BreadcrumbsView.prototype._addAllBreadcrumbHtml = function() {
    this.$breadcrumbContainer.html(this._getAllBreadcrumbHtml(this.collection));
    return this.$resetAllContainer.html(this.resetAllView.render().delegateEvents().el);
  };

  return BreadcrumbsView;

})(Backbone.View);

module.exports = BreadcrumbsView;

},{"../../templates":116,"../collections/breadcrumbs":69,"../i18n":76,"./breadcrumb":88,"./breadcrumb_reset":90}],92:[function(require,module,exports){
var CheckboxReset, i18n, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

templates = require('../../templates');

i18n = require('../i18n')();

module.exports = CheckboxReset = (function(superClass) {
  extend(CheckboxReset, superClass);

  function CheckboxReset() {
    this.render = bind(this.render, this);
    return CheckboxReset.__super__.constructor.apply(this, arguments);
  }

  CheckboxReset.prototype.template = templates['checkbox_reset'];

  CheckboxReset.prototype.events = {
    'click': _.preventDefaultAndDefer('_handleReset')
  };

  CheckboxReset.prototype.initialize = function() {
    return this.listenTo(this.collection, 'change', this.render);
  };

  CheckboxReset.prototype.render = function() {
    this.$el.html(this.template.render(this._toHash()));
    return this;
  };

  CheckboxReset.prototype._toHash = function() {
    return {
      anySelected: this.collection.anySelected(),
      id: this.collection.id,
      all: i18n.translate('refinements.all')
    };
  };

  CheckboxReset.prototype._handleReset = function(e) {
    return this.collection.deselectAll();
  };

  return CheckboxReset;

})(Backbone.View);

},{"../../templates":116,"../i18n":76,"../mixins/underscore":77}],93:[function(require,module,exports){
var CheckboxReset, ClearReset, i18n, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

CheckboxReset = require('./checkbox_reset');

templates = require('../../templates');

i18n = require('../i18n')();

module.exports = ClearReset = (function(superClass) {
  extend(ClearReset, superClass);

  function ClearReset() {
    this.render = bind(this.render, this);
    return ClearReset.__super__.constructor.apply(this, arguments);
  }

  ClearReset.prototype.template = templates['radio_reset'];

  ClearReset.prototype.partial = {
    radio: templates['radio']
  };

  ClearReset.prototype.render = function() {
    this.$el.html(this.template.render(this._toHash(), this.partial));
    return this;
  };

  ClearReset.prototype._toHash = function() {
    return {
      all: i18n.translate('refinements.all'),
      id: this.collection.id,
      selected: !this.collection.anySelected()
    };
  };

  return ClearReset;

})(CheckboxReset);

},{"../../templates":116,"../i18n":76,"../mixins/underscore":77,"./checkbox_reset":92}],94:[function(require,module,exports){
var DateTime, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

templates = require('../../templates');

module.exports = DateTime = (function(superClass) {
  extend(DateTime, superClass);

  function DateTime() {
    return DateTime.__super__.constructor.apply(this, arguments);
  }

  DateTime.prototype.template = templates['datetime_filter'];

  DateTime.prototype.className = 'refinement-box';

  DateTime.prototype.events = {
    "click .dates-radio-button": "_handleClick",
    "click .times-radio-button": "_handleClick"
  };

  DateTime.prototype.initialize = function() {
    this.multiselect = true;
    this.listenTo(this.collection.get('date').nestedRefinements, 'selectedModels:updated', this.render);
    this.listenTo(this.collection.get('time').nestedRefinements, 'selectedModels:updated', this.render);
    return DateTime.__super__.initialize.apply(this, arguments);
  };

  DateTime.prototype.render = function() {
    this.$el.html(this.template.render(this.collection.toHash(), templates));
    this._setupListeners();
    return this;
  };

  DateTime.prototype._setupListeners = function() {
    var dateButtons, timeButtons;
    dateButtons = this.$el.find('.dates-radio-button');
    timeButtons = this.$el.find('.times-radio-button');
    dateButtons.on('click', (function(_this) {
      return function(e) {
        return _this._handleClick(e);
      };
    })(this));
    return timeButtons.on('click', (function(_this) {
      return function(e) {
        return _this._handleClick(e);
      };
    })(this));
  };

  DateTime.prototype._handleClick = function(e) {
    var el, id, isDates;
    el = $(e.target);
    id = el.attr('data-id');
    isDates = /dates/.test(el.attr('id'));
    if (isDates) {
      return this.collection.get('date').nestedRefinements.get(id).select();
    } else {
      return this.collection.get('time').nestedRefinements.get(id).select();
    }
  };

  return DateTime;

})(Backbone.View);

},{"../../templates":116}],95:[function(require,module,exports){
var Featurable, SELECTED_CLASSES, UNSELECTED_CLASSES, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

templates = require('../../templates');

SELECTED_CLASSES = 'c-bg-prim c-bdr-prim ch-bdr-prim-dk ch-bg-prim-dk c-txt-white';

UNSELECTED_CLASSES = "c-txt-gray-dk c-bdr-gray-lt ch-bdr-gray-dk";

module.exports = Featurable = (function(superClass) {
  extend(Featurable, superClass);

  function Featurable() {
    return Featurable.__super__.constructor.apply(this, arguments);
  }

  Featurable.prototype.featuredView = null;

  Featurable.prototype.collectionId = null;

  Featurable.prototype.featuredBoxSelector = null;

  Featurable.prototype.featuredTooltipSelector = null;

  Featurable.prototype.selectedClass = null;

  Featurable.prototype.initialize = function(options) {
    this.listenTo(this.collection, 'add change:simplifiedShow reset', this.render);
    this.collectionId = this.collection.id;
    this.selectedClass = this.collectionId + "-selected";
    this.featuredBoxSelector = "#featured-" + this.collectionId + "-box";
    this.featuredTooltipSelector = "#featured-" + this.collectionId + "-tooltip";
    this.collection.on("deselect", (function(_this) {
      return function() {
        return _this.reload();
      };
    })(this));
    $(document).off("click.featurable." + this.collectionId);
    $(document).off("tab:active." + this.collectionId);
    $(document).on("click.featurable." + this.collectionId, (function(_this) {
      return function(e) {
        return _this._handleDocClick(e);
      };
    })(this));
    return $(document).on("tab:active." + this.collectionId, (function(_this) {
      return function() {
        return _this.closeFeaturedTooltip();
      };
    })(this));
  };

  Featurable.prototype.reload = function() {
    this.$el.empty();
    return this.render();
  };

  Featurable.prototype._toHash = function() {
    return {
      id: this.collectionId,
      collection_id: this.collectionId,
      selectedClass: this.selectedClass
    };
  };

  Featurable.prototype._handleDocClick = function(e) {
    if (this._clickContains(e, this.featuredBoxSelector)) {
      if (e.result !== "opened-true") {
        this._toggleFeatured(e);
      }
      return "opened-" + (this._tooltipIsVisible());
    } else if (this._tooltipIsVisible() && !this._clickContains(e, this.featuredTooltipSelector)) {
      return this.closeFeaturedTooltip();
    }
  };

  Featurable.prototype.closeFeaturedTooltip = function() {
    GIG.Tooltip.close($(this.featuredTooltipSelector));
    return this._updateFeaturedTitle();
  };

  Featurable.prototype.setFeaturedTitle = function(title, clearTitle) {
    if (clearTitle == null) {
      clearTitle = true;
    }
    $("[data-tooltip-id='featured-" + this.collectionId + "-tooltip']").text(title);
    if (clearTitle) {
      $("" + this.featuredBoxSelector).addClass(UNSELECTED_CLASSES).removeClass(SELECTED_CLASSES);
      return $("#featured-" + this.collectionId + "-arrow").addClass("c-txt-prim");
    } else {
      $("" + this.featuredBoxSelector).addClass(SELECTED_CLASSES).removeClass(UNSELECTED_CLASSES);
      return $("#featured-" + this.collectionId + "-arrow").removeClass("c-txt-prim");
    }
  };

  Featurable.prototype._toggleFeatured = function(e) {
    if (this._tooltipIsVisible()) {
      return this.closeFeaturedTooltip();
    } else {
      return this._openFeaturedTooltip();
    }
  };

  Featurable.prototype._openFeaturedTooltip = function() {
    var leftOffset;
    leftOffset = $(this.featuredBoxSelector).offset().left;
    GIG.Tooltip.open($(this.featuredTooltipSelector), $(this.featuredBoxSelector + " .featured-title"));
    $(this.featuredTooltipSelector).offset({
      left: leftOffset
    });
    return $("#featured-" + this.collectionId + "-tooltip .indicator").offset({
      left: leftOffset + 26
    });
  };

  Featurable.prototype._tooltipIsVisible = function() {
    return $(this.featuredTooltipSelector).is(":visible");
  };

  Featurable.prototype._clickContains = function(e, selector) {
    var container, hasTarget, isTarget;
    if (!(e.target && selector)) {
      return;
    }
    container = $("" + selector);
    hasTarget = container.has(e.target).length > 0;
    isTarget = container.is(e.target);
    return hasTarget || isTarget;
  };

  return Featurable;

})(Backbone.View);

},{"../../templates":116}],96:[function(require,module,exports){
var DateTime, DateTimeHelper, Featurable, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

templates = require('../../../templates');

DateTimeHelper = require('../../helpers/datetime_helper');

Featurable = require('../featurable');

module.exports = DateTime = (function(superClass) {
  extend(DateTime, superClass);

  function DateTime() {
    return DateTime.__super__.constructor.apply(this, arguments);
  }

  DateTime.prototype.featuredTemplate = templates['featured_datetimes'];

  DateTime.prototype.className = 'refinement-box';

  DateTime.prototype.selectedDateLabel = ".dates-radio-label.datetime-selected";

  DateTime.prototype.selectedTimeLabel = ".times-radio-label.datetime-selected";

  DateTime.prototype.selectedDateButton = ".dates-radio-button:checked";

  DateTime.prototype.selectedTimeButton = ".times-radio-button:checked";

  DateTime.prototype.events = {
    "click .dates-radio-button": "_handleClick",
    "click .times-radio-button": "_handleClick"
  };

  DateTime.prototype.initialize = function() {
    this.multiselect = true;
    this.listenTo(this.collection.get('date').nestedRefinements, 'selectedModels:updated', this.render);
    this.listenTo(this.collection.get('time').nestedRefinements, 'selectedModels:updated', this.render);
    return DateTime.__super__.initialize.apply(this, arguments);
  };

  DateTime.prototype.render = function() {
    var ref;
    if ((ref = this.$el) != null) {
      ref.html(this.featuredTemplate.render(this.collection.toHash(), templates));
    }
    this._setupListeners();
    return this._updateFeaturedTitle();
  };

  DateTime.prototype._setupListeners = function() {
    var dateButtons, timeButtons;
    dateButtons = this.$el.find('.dates-radio-button');
    timeButtons = this.$el.find('.times-radio-button');
    dateButtons.on('click', (function(_this) {
      return function(e) {
        return _this._handleClick(e);
      };
    })(this));
    return timeButtons.on('click', (function(_this) {
      return function(e) {
        return _this._handleClick(e);
      };
    })(this));
  };

  DateTime.prototype._getSelected = function() {
    return this.collection.getSelectedValues().map(function(selected) {
      return selected.selectedValues[0].name;
    });
  };

  DateTime.prototype._handleClick = function(e) {
    var el, id, isDates;
    el = $(e.target);
    id = el.attr('data-id');
    isDates = /dates/.test(el.attr('id'));
    if (isDates) {
      this.collection.get('date').nestedRefinements.get(id).select();
    } else {
      this.collection.get('time').nestedRefinements.get(id).select();
    }
    return this.closeFeaturedTooltip();
  };

  DateTime.prototype._updateFeaturedTitle = function() {
    var date, dateId, ref, selectedDateObj, selectedTimeObj, time, timeId;
    selectedTimeObj = $("#featured-datetime-tooltip " + this.selectedTimeLabel);
    selectedDateObj = $("#featured-datetime-tooltip " + this.selectedDateLabel);
    date = selectedDateObj ? selectedDateObj.text() : '';
    time = selectedTimeObj ? selectedTimeObj.text() : '';
    ref = this._getSelected(), dateId = ref[0], timeId = ref[1];
    if (dateId === "anyday" && timeId === "anytime") {
      return this.setFeaturedTitle(DateTimeHelper.getTitle());
    } else {
      this.collection.modifiedTitle = date + ", " + time;
      return this.setFeaturedTitle(this.collection.modifiedTitle, false);
    }
  };

  return DateTime;

})(Featurable);

},{"../../../templates":116,"../../helpers/datetime_helper":75,"../featurable":95}],97:[function(require,module,exports){
(function (global){
var AgeHelper, Featurable, Selection, _, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

templates = require('../../../templates');

_ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

Featurable = require('../featurable');

AgeHelper = require('../../helpers/age_helper');

module.exports = Selection = (function(superClass) {
  extend(Selection, superClass);

  function Selection() {
    return Selection.__super__.constructor.apply(this, arguments);
  }

  Selection.prototype.featuredTemplate = templates['featured_nested_links'];

  Selection.prototype.className = 'refinement-box';

  Selection.prototype.initialize = function() {
    Selection.__super__.initialize.apply(this, arguments);
    return this.listenTo(this.collection, 'selectedModels:updated', this.render);
  };

  Selection.prototype.reload = function() {
    Selection.__super__.reload.apply(this, arguments);
    return this.render();
  };

  Selection.prototype.render = function() {
    var ref;
    if ((ref = this.$el) != null) {
      ref.html(this.featuredTemplate.render(this._toHash(), templates));
    }
    this._updateFeaturedTitle();
    return this._setupListeners();
  };

  Selection.prototype._setupListeners = function() {
    return $(".age-checkbox-button").on('click', (function(_this) {
      return function(e) {
        return _this._handleClick(e);
      };
    })(this));
  };

  Selection.prototype._handleClick = function(e) {
    var id;
    if (!e) {
      return;
    }
    id = $(e.target).attr('data-id');
    this.collection.get(id).toggleSelected();
    return this.closeFeaturedTooltip();
  };

  Selection.prototype._updateFeaturedTitle = function() {
    var selections;
    selections = this.collection.filter(function(refinement) {
      return refinement.get('selected');
    }).map(function(refinement) {
      return refinement.get('friendlyName');
    });
    if (selections.length === 0) {
      return this.setFeaturedTitle(AgeHelper.getAgeTitle(), true);
    } else if (selections.length < 3) {
      if (selections.length < 3) {
        return this.setFeaturedTitle(selections.join(", "), false);
      }
    } else {
      if (selections.length >= 3) {
        return this.setFeaturedTitle(selections.length + " " + (AgeHelper.getAgeTitle()), false);
      }
    }
  };

  Selection.prototype._toHash = function() {
    var collectionHash;
    collectionHash = this.collection.toJSON();
    return {
      children: collectionHash,
      id: this.collection.id,
      collection_id: this.collection.id
    };
  };

  return Selection;

})(Featurable);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../../templates":116,"../../helpers/age_helper":74,"../featurable":95}],98:[function(require,module,exports){
(function (global){
var Featurable, Sort, _, i18n, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

templates = require('../../../templates');

Featurable = require('../featurable');

_ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

i18n = require('../../i18n')();

module.exports = Sort = (function(superClass) {
  extend(Sort, superClass);

  function Sort() {
    return Sort.__super__.constructor.apply(this, arguments);
  }

  Sort.prototype.featuredTemplate = templates['featured_sort'];

  Sort.prototype.className = 'refinement-box';

  Sort.prototype.initialize = function() {
    this.listenTo(this.collection, 'selectedModels:updated', this.render);
    this.listenTo(this.collection, 'change:implicitlySelected', this.render);
    return Sort.__super__.initialize.apply(this, arguments);
  };

  Sort.prototype.render = function() {
    var ref;
    if ((ref = this.$el) != null) {
      ref.html(this.featuredTemplate.render(this._toHash(), templates));
    }
    this._updateFeaturedTitle();
    return this._setupListeners();
  };

  Sort.prototype._setupListeners = function() {
    return $(".sort-radio-button").on('click', (function(_this) {
      return function(e) {
        return _this._handleClick(e);
      };
    })(this));
  };

  Sort.prototype._handleClick = function(e) {
    var selectedValue;
    if (!e) {
      return;
    }
    selectedValue = $(e.target).attr('data-id');
    this.collection.get(selectedValue).select();
    return this.closeFeaturedTooltip();
  };

  Sort.prototype._updateFeaturedTitle = function() {
    var ref, ref1, title;
    title = (ref = this.collection.getSelectedValues()) != null ? (ref1 = ref[0]) != null ? ref1.friendlyNameShort : void 0 : void 0;
    if (title) {
      return this.setFeaturedTitle(i18n.translate('refinements.sort.title_prefix', {
        title: title
      }), false);
    } else {
      return this.setFeaturedTitle(i18n.translate('refinements.sort.title'), true);
    }
  };

  Sort.prototype._toHash = function() {
    var collectionHash, i, len, model;
    collectionHash = this.collection.toJSON();
    for (i = 0, len = collectionHash.length; i < len; i++) {
      model = collectionHash[i];
      model.selectedInView = model.selected || model.implicitlySelected;
    }
    return {
      children: collectionHash
    };
  };

  return Sort;

})(Featurable);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../../../templates":116,"../../i18n":76,"../featurable":95}],99:[function(require,module,exports){
var LinksList, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

templates = require('../../templates');

module.exports = LinksList = (function(superClass) {
  extend(LinksList, superClass);

  function LinksList() {
    this.render = bind(this.render, this);
    return LinksList.__super__.constructor.apply(this, arguments);
  }

  LinksList.prototype.template = templates['links_list'];

  LinksList.prototype.partials = {
    link: templates['link']
  };

  LinksList.prototype.events = {
    'click .toggle-refinements': '_toggleRefinementList'
  };

  LinksList.prototype.initialize = function() {
    return this.listenTo(this.collection, 'add change reset', this.render);
  };

  LinksList.prototype.render = function() {
    this.$el.html(this.template.render(this.toHash(), this.partials));
    this.$refinementList = this.$el.find('.refinement-list');
    return this;
  };

  LinksList.prototype.toHash = function() {
    return {
      refinementData: this.collection.toJSON()
    };
  };

  LinksList.prototype._toggleRefinementList = function(ev) {
    var listId;
    $(ev.currentTarget).toggleClass("icon-arrow-down-large icon-arrow-up-large");
    listId = $(ev.currentTarget).data('id');
    return $("#" + listId + ".refinement-list").slideToggle();
  };

  return LinksList;

})(Backbone.View);

},{"../../templates":116}],100:[function(require,module,exports){
var ModalItem, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

templates = require('../../templates');

module.exports = ModalItem = (function(superClass) {
  extend(ModalItem, superClass);

  function ModalItem() {
    return ModalItem.__super__.constructor.apply(this, arguments);
  }

  ModalItem.prototype.template = templates['modal_item'];

  ModalItem.prototype.partials = {
    checkbox: templates['checkbox']
  };

  ModalItem.prototype.events = {
    "click .refinement": "toggleSelected"
  };

  ModalItem.prototype.tagName = "li";

  ModalItem.prototype.initialize = function() {
    this.id = this.model.id;
    return this.selected = this.model.get('selected');
  };

  ModalItem.prototype.attributes = function() {
    return {
      "data-bhc": "brand:" + this.model.id,
      "data-id": this.model.id
    };
  };

  ModalItem.prototype.resetSelectedState = function(refinement) {
    this.selected = refinement.get('selected');
    return this._toggleCheckbox();
  };

  ModalItem.prototype.render = function() {
    this.$el.html(this.template.render(this.model.toJSON(), this.partials));
    return this;
  };

  ModalItem.prototype._toggleCheckbox = function() {
    return this.$el.find('input').prop('checked', this.selected);
  };

  ModalItem.prototype.toggleSelected = function() {
    this.selected = !this.selected;
    return this._toggleCheckbox();
  };

  return ModalItem;

})(Backbone.View);

},{"../../templates":116}],101:[function(require,module,exports){
var NestedLink, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

templates = require('../../templates');

module.exports = NestedLink = (function(superClass) {
  extend(NestedLink, superClass);

  function NestedLink() {
    this._handleClick = bind(this._handleClick, this);
    this.remove = bind(this.remove, this);
    return NestedLink.__super__.constructor.apply(this, arguments);
  }

  NestedLink.prototype.template = templates['nested_link'];

  NestedLink.prototype.partials = {
    checkbox: templates['checkbox']
  };

  NestedLink.prototype.events = {
    'click .dynamic': _.preventDefaultAndDefer('_handleClick')
  };

  NestedLink.prototype.initialize = function() {
    var ref, ref1, ref2;
    this.$childrenEl = (ref = $(this.options.childrenEl)) != null ? ref : $('div');
    this.$childView = (ref1 = this.options.childView) != null ? ref1 : Backbone.View;
    if ((ref2 = this.model.nestedRefinements) != null ? ref2.length : void 0) {
      this.childView = this._createChildView();
    }
    this.listenTo(this.model, 'change', this._renderMain);
    return this.listenTo(this.model, 'remove', this.remove);
  };

  NestedLink.prototype.render = function() {
    this._renderMain();
    this._renderChildren();
    return this;
  };

  NestedLink.prototype.remove = function() {
    var ref;
    if ((ref = this.childView) != null) {
      ref.remove();
    }
    return Backbone.View.prototype.remove.apply(this);
  };

  NestedLink.prototype._renderMain = function(model, options) {
    if (options == null) {
      options = {};
    }
    if (options.preventTrigger) {
      return;
    }
    this.$el.html(this.template.render(this.model.toJSON(), this.partials));
    this.$childrenEl.toggleClass('expanded', this.model.get('selected'));
    return this.$childrenEl.toggleClass('lowest-selected', this.model.get('lowestSelected'));
  };

  NestedLink.prototype._createChildView = function() {
    return new this.$childView({
      collection: this.model.nestedRefinements,
      el: this.$childrenEl
    });
  };

  NestedLink.prototype._renderChildren = function() {
    var ref;
    return (ref = this.childView) != null ? ref.render() : void 0;
  };

  NestedLink.prototype._handleClick = function(e) {
    return this.model.toggleSelected();
  };

  return NestedLink;

})(Backbone.View);

},{"../../templates":116,"../mixins/underscore":77}],102:[function(require,module,exports){
var NestedLink, NestedLinks, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

NestedLink = require('./nested_link');

templates = require('../../templates');

module.exports = NestedLinks = (function(superClass) {
  extend(NestedLinks, superClass);

  function NestedLinks() {
    return NestedLinks.__super__.constructor.apply(this, arguments);
  }

  NestedLinks.prototype.template = templates['child_list'];

  NestedLinks.prototype.partials = {
    nested_item: templates['nested_item']
  };

  NestedLinks.prototype.initialize = function() {
    this.listenTo(this.collection, 'add change:simplifiedShow reset', this.render);
    return this.childViews = [];
  };

  NestedLinks.prototype.render = function() {
    this._removeChildren();
    this.$el.html(this.template.render(this._toHash(), this.partials));
    this._renderChildren();
    return this;
  };

  NestedLinks.prototype.remove = function() {
    this._removeChildren();
    return Backbone.View.prototype.remove.apply(this);
  };

  NestedLinks.prototype._toHash = function() {
    return {
      children: this.collection.toJSON()
    };
  };

  NestedLinks.prototype._renderChildren = function() {
    return this.collection.each((function(_this) {
      return function(refinement) {
        var $childrenEl, $refinementEl, childView;
        $refinementEl = _this.$el.find("[data-id='" + (refinement.get('id')) + "']");
        $childrenEl = $refinementEl.next('.children-list');
        childView = new NestedLink({
          model: refinement,
          el: $refinementEl,
          childrenEl: $childrenEl,
          childView: NestedLinks
        });
        _this.childViews.push(childView);
        return childView.render();
      };
    })(this));
  };

  NestedLinks.prototype._removeChildren = function() {
    _.invoke(this.childViews, 'remove');
    return this.childViews = [];
  };

  return NestedLinks;

})(Backbone.View);

},{"../../templates":116,"./nested_link":101}],103:[function(require,module,exports){
var CheckboxReset, NestedLinks, ParentNestedLinks, ShowMoreModal, TypeaheadSearch, i18n, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

CheckboxReset = require('./checkbox_reset');

NestedLinks = require('./nested_links');

ShowMoreModal = require('./show_more_modal');

TypeaheadSearch = require('./typeahead_search');

templates = require('../../templates');

i18n = require('../i18n')();

module.exports = ParentNestedLinks = (function(superClass) {
  extend(ParentNestedLinks, superClass);

  function ParentNestedLinks() {
    return ParentNestedLinks.__super__.constructor.apply(this, arguments);
  }

  ParentNestedLinks.prototype.template = templates['nested_links'];

  ParentNestedLinks.prototype.partials = {
    child_list: templates['child_list'],
    nested_item: templates['nested_item'],
    see_more: templates['see_more']
  };

  ParentNestedLinks.prototype.events = {
    "click .see-more": "_renderShowMoreModal",
    'click .toggle-refinements': '_toggleRefinementList'
  };

  ParentNestedLinks.prototype.render = function() {
    NestedLinks.prototype.render.apply(this, arguments);
    if (this.collection.multiselect) {
      this._renderReset();
    }
    this._renderShowMoreSearch();
    if (this.showMoreModal) {
      this.showMoreModal.render();
    }
    this._cacheElements();
    return this;
  };

  ParentNestedLinks.prototype.remove = function() {
    var ref, ref1, ref2;
    if ((ref = this.checkboxResetView) != null) {
      ref.remove();
    }
    if ((ref1 = this.showMoreModal) != null) {
      ref1.remove();
    }
    if ((ref2 = this.showMoreSearch) != null) {
      ref2.remove();
    }
    return ParentNestedLinks.__super__.remove.apply(this, arguments);
  };

  ParentNestedLinks.prototype._cacheElements = function() {
    this.$refinementList = this.$el.find('.refinement-list');
    return this.$seeMore = this.$el.find('.see-more');
  };

  ParentNestedLinks.prototype._toHash = function() {
    return {
      id: this.collection.id,
      multiselect: !!this.collection.multiselect,
      refinementData: this._getRefinementData(),
      showRefinementBox: this.collection.length > 0,
      useSimplifiedCategory: this.collection.useSimplifiedCategory,
      l1Category: this.collection.l1Category,
      showSeeMoreLink: this.collection.length > this.collection.max,
      title: this.collection.title,
      seeMore: i18n.translate('refinements.see_more'),
      showCollapseControl: this.collection.showCollapseControl,
      collapseFilter: this._collapseFilter(),
      showMoreSearch: this.collection.showMoreSearch,
      showMoreSearchPlaceholder: this.collection.showMoreSearchPlaceholder
    };
  };

  ParentNestedLinks.prototype._collapseFilter = function() {
    if (this.collection.anySelected()) {
      return false;
    } else {
      return this.collection.collapseFilter;
    }
  };

  ParentNestedLinks.prototype._getRefinementData = function() {
    if (this.collection.useExpandedRefinementData) {
      return this.collection.refinementData;
    }
    return this.collection.toJSON();
  };

  ParentNestedLinks.prototype._renderReset = function() {
    var $containerEl, ref;
    $containerEl = this.$el.find('.reset');
    if ((ref = this.checkboxResetView) != null) {
      ref.remove();
    }
    return this.checkboxResetView = new CheckboxReset({
      el: $containerEl,
      collection: this.collection
    }).render();
  };

  ParentNestedLinks.prototype._renderShowMoreModal = function() {
    if (!this.collection.useExpandedRefinementData) {
      return;
    }
    if (!this.showMoreModal) {
      this.showMoreModal = new ShowMoreModal({
        collection: this.collection
      });
    }
    return this.showMoreModal.show();
  };

  ParentNestedLinks.prototype._toggleRefinementList = function(ev) {
    $(ev.currentTarget).toggleClass("icon-arrow-down-large icon-arrow-up-large");
    this.$refinementList.stop().slideToggle();
    return this.$seeMore.stop().slideToggle();
  };

  ParentNestedLinks.prototype._renderShowMoreSearch = function() {
    var $containerEl, ref;
    if (!this.collection.showMoreSearch) {
      return;
    }
    $containerEl = this.$el.find('.grui-show-more-search');
    if ((ref = this.showMoreSearch) != null) {
      ref.remove();
    }
    return this.showMoreSearch = new TypeaheadSearch({
      collection: this.collection,
      el: $containerEl
    }).render();
  };

  return ParentNestedLinks;

})(NestedLinks);

},{"../../templates":116,"../i18n":76,"./checkbox_reset":92,"./nested_links":102,"./show_more_modal":110,"./typeahead_search":114}],104:[function(require,module,exports){
var ENTER_KEYCODE, RangeFilter, i18n, pick, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

pick = _.pick;

templates = require('../../templates');

i18n = require('../i18n')();

ENTER_KEYCODE = 13;

module.exports = RangeFilter = (function(superClass) {
  extend(RangeFilter, superClass);

  function RangeFilter() {
    return RangeFilter.__super__.constructor.apply(this, arguments);
  }

  RangeFilter.prototype.template = templates['range_filter'];

  RangeFilter.prototype.className = 'refinement-box';

  RangeFilter.prototype.events = {
    'blur .refinement-range-minInput input': '_setMin',
    'blur .refinement-range-maxInput input': '_setMax',
    'keyup .refinement-range-minInput input': '_enterMin',
    'keyup .refinement-range-maxInput input': '_enterMax',
    'click .toggle-refinements': '_toggleRefinementRange',
    'mousedown a.btn-range-submit': '_setRange'
  };

  RangeFilter.prototype.initialize = function() {
    return this.listenTo(this.model, 'remove', this.remove);
  };

  RangeFilter.prototype.render = function() {
    this.$el.html(this.template.render(this._getViewHash()));
    this._cacheElem();
    this._applySlider();
    return this;
  };

  RangeFilter.prototype._getViewHash = function() {
    var viewHash;
    viewHash = this.model.toJSON();
    viewHash.applyText = i18n.translate('refinements.go');
    viewHash.toText = i18n.translate('refinements.to');
    return viewHash;
  };

  RangeFilter.prototype._cacheElem = function() {
    var rangeErrors, rangeInputs;
    this.$rangeInputs = rangeInputs = this.$el.find('.refinement-range-input');
    this.$minRangeInput = rangeInputs.eq(0);
    this.$maxRangeInput = rangeInputs.eq(1);
    this.$rangeErrors = rangeErrors = this.$el.find('.refinement-range-error-message');
    this.$minRangeError = rangeErrors.eq(0);
    this.$maxRangeError = rangeErrors.eq(1);
    this.$minInput = this.$minRangeInput.find('input');
    this.$maxInput = this.$maxRangeInput.find('input');
    return this.$refinementRange = this.$el.find('.refinement-range');
  };

  RangeFilter.prototype._clearError = function() {
    this.$rangeInputs.removeClass('refinement-range-error');
    return this.$rangeErrors.text('').hide();
  };

  RangeFilter.prototype._setError = function(err, inputEl, errorEl) {
    this._clearError();
    errorEl.text(err).show();
    return inputEl.addClass('refinement-range-error');
  };

  RangeFilter.prototype._setMin = function() {
    var newMin;
    newMin = parseInt(this.$minInput.val(), 10);
    if (!this._isValidNewMin(newMin)) {
      return this.$minInput.val(this.model.get('displayedMin'));
    }
    this.$sliderContainer.slider('values', 0, newMin);
    return this._updateState(newMin, this.model.get('displayedMax'), !this.model.get('showPriceRangeButton'));
  };

  RangeFilter.prototype._setMax = function() {
    var newMax;
    newMax = parseInt(this.$maxInput.val(), 10);
    if (!this._isValidNewMax(newMax)) {
      return this.$maxInput.val(this.model.get('displayedMax'));
    }
    this.$sliderContainer.slider('values', 1, newMax);
    return this._updateState(this.model.get('displayedMin'), newMax, !this.model.get('showPriceRangeButton'));
  };

  RangeFilter.prototype._setRange = function() {
    if (!this._isValidNewMin(this.$minInput.val())) {
      return this.$minInput.val(this.model.get('displayedMin'));
    }
    if (!this._isValidNewMax(this.$maxInput.val())) {
      return this.$maxInput.val(this.model.get('displayedMax'));
    }
    return this._updateState(this.$minInput.val(), this.$maxInput.val(), this.model.get('showPriceRangeButton'));
  };

  RangeFilter.prototype._enterMin = function(e) {
    if (e.keyCode === ENTER_KEYCODE) {
      return this._setMin();
    }
  };

  RangeFilter.prototype._enterMax = function(e) {
    if (e.keyCode === ENTER_KEYCODE) {
      return this._setMax();
    }
  };

  RangeFilter.prototype._isValidNewMin = function(newMin) {
    var err;
    err = this.model.validateMin(newMin);
    if (err) {
      this._setError(err, this.$minRangeInput, this.$minRangeError);
      return false;
    } else {
      this._clearError();
      return true;
    }
  };

  RangeFilter.prototype._isValidNewMax = function(newMax) {
    var err;
    err = this.model.validateMax(newMax);
    if (err) {
      this._setError(err, this.$maxRangeInput, this.$maxRangeError);
      return false;
    } else {
      this._clearError();
      return true;
    }
  };

  RangeFilter.prototype._updateState = function(newMin, newMax, experiment) {
    if (this.model.get('selectedMin') !== newMin || this.model.get('selectedMax') !== newMax) {
      return this.model.set({
        displayedMin: newMin,
        displayedMax: newMax,
        selectedMin: newMin,
        selectedMax: newMax,
        updated: experiment
      });
    }
  };

  RangeFilter.prototype._applySlider = function() {
    var displayedMax, displayedMin, rangeMax, rangeMin, ref, sliderContainerElem;
    ref = pick(this.model.toJSON(), 'rangeMin', 'rangeMax', 'displayedMin', 'displayedMax'), rangeMin = ref.rangeMin, rangeMax = ref.rangeMax, displayedMin = ref.displayedMin, displayedMax = ref.displayedMax;
    sliderContainerElem = $(this.$el.find('.refinement-range-slider'));
    this.$sliderContainer = sliderContainerElem.slider({
      range: true,
      min: rangeMin,
      max: rangeMax,
      values: [displayedMin, displayedMax],
      slide: (function(_this) {
        return function(e, ui) {
          _this.$minInput.val(ui.values[0]);
          return _this.$maxInput.val(ui.values[1]);
        };
      })(this),
      stop: (function(_this) {
        return function(e, ui) {
          _this._clearError();
          return _this._updateState(ui.values[0], ui.values[1], !_this.model.get('showPriceRangeButton'));
        };
      })(this)
    });
    this.$sliderContainer.find('.ui-slider-range').addClass('c-bg-prim');
    this.$minInput.val(displayedMin);
    return this.$maxInput.val(displayedMax);
  };

  RangeFilter.prototype._toggleRefinementRange = function(ev) {
    $(ev.currentTarget).toggleClass('icon-arrow-down-large icon-arrow-up-large');
    return this.$refinementRange.stop().slideToggle();
  };

  return RangeFilter;

})(Backbone.View);

},{"../../templates":116,"../i18n":76}],105:[function(require,module,exports){
var RangeFilter, RangeFilters,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

RangeFilter = require('./range_filter');

module.exports = RangeFilters = (function(superClass) {
  extend(RangeFilters, superClass);

  function RangeFilters() {
    return RangeFilters.__super__.constructor.apply(this, arguments);
  }

  RangeFilters.prototype.initialize = function() {
    return this.listenTo(this.collection, 'add change reset', this.render);
  };

  RangeFilters.prototype.render = function() {
    this._resetChildViews(this.collection);
    this.$el.html(this._getAllRangeFiltersHtml(this.childViews));
    return this;
  };

  RangeFilters.prototype._getRangeFilterView = function(model) {
    return (new RangeFilter({
      model: model
    })).render();
  };

  RangeFilters.prototype._getAllRangeFilterViews = function(collection) {
    if (collection == null) {
      collection = [];
    }
    return collection.map(this._getRangeFilterView);
  };

  RangeFilters.prototype._getAllRangeFiltersHtml = function(views) {
    return _.pluck(views, 'el');
  };

  RangeFilters.prototype._resetChildViews = function(collection) {
    _.invoke(this.childViews, 'remove');
    return this.childViews = this._getAllRangeFilterViews(collection);
  };

  return RangeFilters;

})(Backbone.View);

},{"./range_filter":104}],106:[function(require,module,exports){
var Rating, partials, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

templates = require('../../templates');

partials = {
  radio: templates['radio'],
  rating_name: templates['rating_name']
};

module.exports = Rating = (function(superClass) {
  extend(Rating, superClass);

  function Rating() {
    return Rating.__super__.constructor.apply(this, arguments);
  }

  Rating.prototype.template = templates['rating'];

  Rating.prototype.events = {
    'click': _.preventDefaultAndDefer('_handleClick')
  };

  Rating.prototype.initialize = function() {
    this.listenTo(this.model, 'change:selected', this.render);
    return this.listenTo(this.model, 'remove', this.remove);
  };

  Rating.prototype.render = function() {
    this.$el.html(this.template.render(this.model.toJSON(), partials));
    return this;
  };

  Rating.prototype._handleClick = function() {
    return this.model.toggleSelected();
  };

  return Rating;

})(Backbone.View);

},{"../../templates":116,"../mixins/underscore":77}],107:[function(require,module,exports){
var ClearReset, Rating, RatingFilters, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Rating = require('./rating');

ClearReset = require('./clear_reset');

templates = require('../../templates');

module.exports = RatingFilters = (function(superClass) {
  extend(RatingFilters, superClass);

  function RatingFilters() {
    return RatingFilters.__super__.constructor.apply(this, arguments);
  }

  RatingFilters.prototype.template = templates['ratings'];

  RatingFilters.prototype.events = {
    'click .toggle-refinements': '_toggleRefinementRange'
  };

  RatingFilters.prototype.initialize = function() {
    return this.listenTo(this.collection, 'add remove reset', this.render);
  };

  RatingFilters.prototype.render = function() {
    this.$el.empty();
    this.$el.html(this.template.render(this._toHash()));
    this.cacheElem();
    this._addAllRatings();
    this._addClearReset();
    return this;
  };

  RatingFilters.prototype._toHash = function() {
    return {
      id: this.collection.id,
      title: this.collection.title,
      showRefinementBox: this.collection.length,
      showCollapseControl: this.collection.showCollapseControl,
      collapseFilter: this.collection.collapseFilter
    };
  };

  RatingFilters.prototype.cacheElem = function() {
    this.$ratingContainer = this.$el.find('.refinement-ratings-list');
    this.$clearContainer = this.$el.find('.refinement-ratings-clear');
    return this.$refinementRating = this.$el.find('.refinement-ratings');
  };

  RatingFilters.prototype._addRating = function(model) {
    var ratingView;
    ratingView = new Rating({
      model: model
    });
    return ratingView.render().el;
  };

  RatingFilters.prototype._addAllRatings = function() {
    return this.$ratingContainer.append(this.collection.map((function(_this) {
      return function(model) {
        return _this._addRating(model);
      };
    })(this)));
  };

  RatingFilters.prototype._addClearReset = function() {
    var clearView;
    clearView = new ClearReset({
      collection: this.collection
    });
    return this.$clearContainer.html(clearView.render().el);
  };

  RatingFilters.prototype._toggleRefinementRange = function(ev) {
    $(ev.currentTarget).toggleClass("icon-arrow-down-large icon-arrow-up-large");
    return this.$refinementRating.stop().slideToggle();
  };

  return RatingFilters;

})(Backbone.View);

},{"../../templates":116,"./clear_reset":93,"./rating":106}],108:[function(require,module,exports){
var ResetAll, i18n, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

templates = require('../../templates');

i18n = require('../i18n')();

module.exports = ResetAll = (function(superClass) {
  extend(ResetAll, superClass);

  function ResetAll() {
    this.resetAll = bind(this.resetAll, this);
    return ResetAll.__super__.constructor.apply(this, arguments);
  }

  ResetAll.prototype.template = templates['reset_all'];

  ResetAll.prototype.events = {
    'click': _.preventDefaultAndDefer('resetAll')
  };

  ResetAll.prototype.initialize = function() {
    this.featuredReset = $("#featured-reset-box");
    this.featuredReset.on("click", (function(_this) {
      return function() {
        return _this.resetAll();
      };
    })(this));
    return this.resetRefinements(this.options.refinements);
  };

  ResetAll.prototype.render = function() {
    if (this._anyRefinementsSelected()) {
      this.featuredReset.show();
    } else {
      this.featuredReset.hide();
    }
    this.$el.html(this.template.render(this._toHash()));
    return this;
  };

  ResetAll.prototype.resetRefinements = function(refinementCollections) {
    _.each(this.collections, (function(_this) {
      return function(collection) {
        return _this.stopListening(collection, 'selectedModels:updated');
      };
    })(this));
    this.collections = this._getResetableCollections(refinementCollections);
    return this._setupListeners();
  };

  ResetAll.prototype._toHash = function() {
    return {
      resetAllText: i18n.translate('refinements.reset_all'),
      refinementsSelected: this._anyRefinementsSelected()
    };
  };

  ResetAll.prototype.resetAll = function(e) {
    var queue;
    queue = this.collections.length - 1;
    return _.each(this.collections, function(collection) {
      collection.deselectAll({
        queue: !!queue
      });
      return queue--;
    });
  };

  ResetAll.prototype._getResetableCollections = function(refinementCollections) {
    var collection, collections, key, ref;
    collections = [];
    for (key in refinementCollections) {
      collection = refinementCollections[key];
      if (collection.multiselect || ((ref = collection.id) === 'datetime' || ref === 'age' || ref === 'sort' || ref === 'rating' || ref === 'badge')) {
        collections.push(collection);
      }
    }
    return collections;
  };

  ResetAll.prototype._setupListeners = function() {
    return _.each(this.collections, (function(_this) {
      return function(collection) {
        _this.stopListening(collection, 'selectedModels:updated');
        return _this.listenTo(collection, 'selectedModels:updated', _this.render);
      };
    })(this));
  };

  ResetAll.prototype._anyRefinementsSelected = function() {
    return _.any(this.collections, function(collection) {
      return collection.anySelected();
    });
  };

  return ResetAll;

})(Backbone.View);

},{"../../templates":116,"../i18n":76,"../mixins/underscore":77}],109:[function(require,module,exports){
var ResetFilters, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../mixins/underscore');

templates = require('../../templates');

module.exports = ResetFilters = (function(superClass) {
  extend(ResetFilters, superClass);

  function ResetFilters() {
    this._clearFilter = bind(this._clearFilter, this);
    return ResetFilters.__super__.constructor.apply(this, arguments);
  }

  ResetFilters.prototype.template = templates['reset_filters'];

  ResetFilters.prototype.events = {
    'click .dynamic': _.preventDefaultAndDefer('_clearFilter')
  };

  ResetFilters.prototype.initialize = function() {
    return this.listenTo(this.collection, 'change', this.render);
  };

  ResetFilters.prototype.render = function() {
    this.$el.html(this._getHtml());
    return this;
  };

  ResetFilters.prototype._getHtml = function() {
    return this.template.render({
      refinementData: this.collection.toJSON()
    });
  };

  ResetFilters.prototype._clearFilter = function(e) {
    var targetId, targetModel;
    targetId = $(e.currentTarget).data('id');
    targetModel = this.collection.get(targetId);
    if (targetModel != null) {
      return targetModel.deselect();
    }
  };

  return ResetFilters;

})(Backbone.View);

},{"../../templates":116,"../mixins/underscore":77}],110:[function(require,module,exports){
var DEFAULT_ANIMATE_TIME, ModalItem, ShowMoreModal, TypeaheadSearch, i18n, templates,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

ModalItem = require('./modal_item');

TypeaheadSearch = require('./typeahead_search');

templates = require('../../templates');

i18n = require('../i18n')();

DEFAULT_ANIMATE_TIME = 200;

module.exports = ShowMoreModal = (function(superClass) {
  extend(ShowMoreModal, superClass);

  function ShowMoreModal() {
    this._renderModalViews = bind(this._renderModalViews, this);
    return ShowMoreModal.__super__.constructor.apply(this, arguments);
  }

  ShowMoreModal.prototype.template = templates['show_more_modal'];

  ShowMoreModal.prototype.partials = {
    checkbox: templates['checkbox'],
    modal_item: templates['modal_item']
  };

  ShowMoreModal.prototype.events = {
    "click .apply": "_applyRefinements"
  };

  ShowMoreModal.prototype.initialize = function() {
    _.bindAll(this, '_handleShowMoreSearchSelection');
    return this._createModal();
  };

  ShowMoreModal.prototype.render = function() {
    this._startPageScroll();
    this.$el.replaceWith(this.template.render(this._toHash(), this.partials));
    this._setElement();
    this._cacheElem();
    this._renderModalItems();
    this._renderShowMoreSearch();
    return this;
  };

  ShowMoreModal.prototype.show = function() {
    this._resetModalItems();
    GIG.Modal.open({
      el: this.el
    });
    return this._stopPageScroll();
  };

  ShowMoreModal.prototype._cacheElem = function() {
    this.$modalItemsContainer = this.$el.find('.checkbox-holder');
    return this.$viewsContainer = this.$el.find('.checkbox-container');
  };

  ShowMoreModal.prototype._applyRefinements = function() {
    this._updateCollection();
    return GIG.Modal.close();
  };

  ShowMoreModal.prototype._createModal = function() {
    this.modalId = GIG.Modal.create(this.template.render(this._toHash(), this.partials), {
      destroyOnClose: false
    });
    this._setElement();
    this._cacheElem();
    this._renderModalItems();
    this._renderShowMoreSearch();
    return GIG.Modal.onClose(this._startPageScroll);
  };

  ShowMoreModal.prototype._removeModalViews = function() {
    return _.invoke(this.modalItems, 'remove');
  };

  ShowMoreModal.prototype._createModalViews = function() {
    this._removeModalViews();
    return this.modalItems = this.collection.map(function(refinement) {
      return new ModalItem({
        model: refinement
      });
    });
  };

  ShowMoreModal.prototype._renderModalItems = function() {
    this._createModalViews();
    return _.defer(this._renderModalViews);
  };

  ShowMoreModal.prototype._renderModalViews = function() {
    var modalItemElems;
    modalItemElems = this.modalItems.map(function(modalItem) {
      return modalItem.render().$el;
    });
    this.$viewsContainer.html(modalItemElems);
    return this.$el.find('.spinner-overlay').hide();
  };

  ShowMoreModal.prototype._resetModalItems = function() {
    var i, len, modalItem, ref, refinement, results;
    ref = this.modalItems;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      modalItem = ref[i];
      if (refinement = this.collection.get(modalItem.id)) {
        results.push(modalItem.resetSelectedState(refinement));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  ShowMoreModal.prototype._setElement = function() {
    this.el = $("#" + this.modalId);
    return this.setElement(this.el);
  };

  ShowMoreModal.prototype._startPageScroll = function() {
    return $('body').css('overflow', 'auto');
  };

  ShowMoreModal.prototype._stopPageScroll = function() {
    return $('body').css('overflow', 'hidden');
  };

  ShowMoreModal.prototype._toHash = function() {
    return {
      dataBhw: this.collection.dataBhw,
      id: this.collection.id,
      modalId: this.modalId,
      title: this.collection.title,
      apply: i18n.translate('refinements.apply'),
      showMoreSearch: this.collection.showMoreSearch,
      showMoreSearchPlaceholder: this.collection.showMoreSearchPlaceholder
    };
  };

  ShowMoreModal.prototype._updateCollection = function() {
    var i, id, len, modalItem, model, ref, selected;
    ref = this.modalItems;
    for (i = 0, len = ref.length; i < len; i++) {
      modalItem = ref[i];
      id = modalItem.id, selected = modalItem.selected;
      if ((model = this.collection.get(id)) && model.get('selected') !== selected) {
        model.toggleSelected({
          preventTrigger: true
        });
      }
    }
    return this.collection.triggerModelsUpdated();
  };

  ShowMoreModal.prototype._handleShowMoreSearchSelection = function(model) {
    var id, modalItemView;
    id = model.get('id');
    modalItemView = _.find(this.modalItems, function(view) {
      return (view != null ? view.id : void 0) === id;
    });
    if (!(modalItemView != null ? modalItemView.selected : void 0)) {
      if (modalItemView != null) {
        modalItemView.toggleSelected();
      }
    }
    return this._scrollToSelected(modalItemView);
  };

  ShowMoreModal.prototype._scrollToSelected = function(modalItemView) {
    var $modalItem, scrollTop;
    if (!modalItemView) {
      return;
    }
    $modalItem = modalItemView.$el;
    scrollTop = this.$modalItemsContainer.scrollTop() + $modalItem.offset().top - this.$modalItemsContainer.offset().top;
    if (!isNaN(scrollTop)) {
      return this.$modalItemsContainer.animate({
        scrollTop: scrollTop
      }, DEFAULT_ANIMATE_TIME);
    }
  };

  ShowMoreModal.prototype._renderShowMoreSearch = function() {
    var $containerEl, ref;
    if (!this.collection.showMoreSearch) {
      return;
    }
    $containerEl = this.$el.find('.grui-show-more-search');
    if ((ref = this.showMoreSearch) != null) {
      ref.remove();
    }
    return this.showMoreSearch = new TypeaheadSearch({
      collection: this.collection,
      el: $containerEl,
      onSelection: this._handleShowMoreSearchSelection
    }).render();
  };

  return ShowMoreModal;

})(Backbone.View);

},{"../../templates":116,"../i18n":76,"./modal_item":100,"./typeahead_search":114}],111:[function(require,module,exports){
var Sort, templates,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

templates = require('../../templates');

module.exports = Sort = (function(superClass) {
  extend(Sort, superClass);

  function Sort() {
    return Sort.__super__.constructor.apply(this, arguments);
  }

  return Sort;

})(Backbone.View);

},{"../../templates":116}],112:[function(require,module,exports){
var TypeaheadInput;

TypeaheadInput = Backbone.View.extend({
  events: {
    'blur .grui-show-more-search-input': '_handleBlur',
    'focus .grui-show-more-search-input': '_handleFocus',
    'input .grui-show-more-search-input': '_handleType'
  },
  render: function() {
    this._cacheElem();
    return this;
  },
  blur: function() {
    return this.$input.blur();
  },
  focus: function() {
    return this.$input.focus();
  },
  setValue: function(value) {
    this.$input.val(value);
    return this.trigger('typeEvent', value);
  },
  getValue: function() {
    return this.$input.val();
  },
  clearValue: function() {
    return this.setValue('');
  },
  _cacheElem: function() {
    return this.$input = this.$el.find('.grui-show-more-search-input');
  },
  _handleBlur: function() {
    return this.trigger('blurEvent');
  },
  _handleFocus: function() {
    return this.trigger('focusEvent');
  },
  _handleType: _.debounce((function() {
    return this.trigger('typeEvent', this.getValue());
  }), 100)
});

module.exports = TypeaheadInput;

},{}],113:[function(require,module,exports){
var DEFAULT_MAX_RESULTS, DEFAULT_SORT_COMPARATOR, TypeaheadResultsList, templates;

templates = require('../../templates');

DEFAULT_SORT_COMPARATOR = function(a, b) {
  return b.get('count') - a.get('count');
};

DEFAULT_MAX_RESULTS = 5;

TypeaheadResultsList = Backbone.View.extend({
  _currentQuery: '',
  _currentResultModels: [],
  template: templates['typeahead_search_results_item'],
  events: {
    'click .grui-show-more-search-result-item': '_handleClickSelection'
  },
  initialize: function() {
    return this.sortedCollection = this.collection.slice(0).sort(DEFAULT_SORT_COMPARATOR);
  },
  hideAllResults: function() {
    return this.$el.hide();
  },
  showAllResults: function() {
    var ref;
    if (!((ref = this._currentResultModels) != null ? ref.length : void 0)) {
      return this.hideAllResults();
    }
    return this.$el.show();
  },
  resetState: function() {
    this.hideAllResults();
    this._resetResultsState();
    return this._currentQuery = '';
  },
  filterResults: function(query) {
    var maxResultsCount, queryToMatch, ref, resultElems, resultModels;
    if (!((query = query.trim()) && this._currentQuery !== query)) {
      if (!query.length) {
        this.resetState();
      }
      return;
    }
    maxResultsCount = (ref = this.sortedCollection.showMoreSearchMax) != null ? ref : DEFAULT_MAX_RESULTS;
    queryToMatch = new RegExp("(" + query + ")", 'i');
    resultModels = [];
    resultElems = [];
    _.find(this.sortedCollection, (function(_this) {
      return function(model) {
        var html, name;
        name = model.get('friendlyNameShort');
        if (name != null ? name.match(queryToMatch) : void 0) {
          html = _this.template.render({
            count: model.get('count'),
            displayText: name.replace(queryToMatch, '<b>$1</b>'),
            id: model.get('id')
          });
          resultModels.push(model);
          resultElems.push(html);
        }
        return resultElems.length >= maxResultsCount;
      };
    })(this));
    this._currentQuery = query;
    this._currentResultModels = resultModels;
    this.$el.html(resultElems);
    return this.showAllResults();
  },
  _triggerSelectionMade: function(highlightedModel) {
    if (!highlightedModel) {
      return;
    }
    return this.trigger('selectionMade', highlightedModel);
  },
  _handleClickSelection: function(e) {
    var id;
    id = $(e.target).data('id');
    return this._triggerSelectionMade(this.collection.get(id));
  },
  _resetResultsState: function() {
    this._currentResultModels = [];
    return this.$el.html('');
  }
});

module.exports = TypeaheadResultsList;

},{"../../templates":116}],114:[function(require,module,exports){
var KEYCODE_TAB, TypeaheadInput, TypeaheadResultsList, TypeaheadSearch, templates;

TypeaheadInput = require('./typeahead_input');

TypeaheadResultsList = require('./typeahead_results_list');

templates = require('../../templates');

KEYCODE_TAB = 9;

TypeaheadSearch = Backbone.View.extend({
  template: templates['typeahead_search'],
  partials: {
    typeahead_search_input: templates['typeahead_search_input']
  },
  initialize: function(options) {
    var onSelection;
    _.bindAll(this, '_handleBlur', '_handleFocus', '_handleKeypress');
    if ((onSelection = options != null ? options.onSelection : void 0) != null) {
      this.onSelection = onSelection;
    }
    return this._applyInitializeListeners();
  },
  render: function() {
    this.$el.html(this.template.render(this._toHash(), this.partials));
    this._cacheElem();
    this._initInput();
    this._initResults();
    this._applyListeners();
    return this;
  },
  remove: function() {
    var ref, ref1;
    this.closeSearch();
    if ((ref = this.inputView) != null) {
      ref.remove();
    }
    if ((ref1 = this.resultsView) != null) {
      ref1.remove();
    }
    return Backbone.View.prototype.remove.call(this);
  },
  closeSearch: function() {
    this.$el.removeClass('grui-show-more-search-focused');
    $(document).off('click', this._handleBlur);
    $(document).off('keydown', this._handleKeypress);
    this.resultsView.hideAllResults();
    return this.inputView.blur();
  },
  resetSearch: function() {
    this.closeSearch();
    this.inputView.clearValue();
    return this.resultsView.resetState();
  },
  onSelection: function(model) {
    return model.select();
  },
  _toHash: function() {
    return {
      showMoreSearchPlaceholder: this.collection.showMoreSearchPlaceholder
    };
  },
  _cacheElem: function() {
    this.$input = this.$el.find('.grui-show-more-search-input-container');
    return this.$results = this.$el.find('.grui-show-more-search-results');
  },
  _initInput: function() {
    var ref;
    if ((ref = this.inputView) != null) {
      ref.remove();
    }
    return this.inputView = (new TypeaheadInput({
      el: this.$input
    })).render();
  },
  _initResults: function() {
    var ref;
    this.stopListening(this.resultsView);
    if ((ref = this.resultsView) != null) {
      ref.remove();
    }
    return this.resultsView = (new TypeaheadResultsList({
      collection: this.collection,
      el: this.$results
    })).render();
  },
  _handleBlur: function(arg) {
    var ref, ref1, target;
    target = arg.target;
    if (this.$input.is(target) || this.$results.is(target) || ((ref = this.$input.has(target)) != null ? ref.length : void 0) || ((ref1 = this.$results.has(target)) != null ? ref1.length : void 0)) {
      return;
    }
    return this.closeSearch();
  },
  _handleFocus: function() {
    this.$el.addClass('grui-show-more-search-focused');
    this.resultsView.showAllResults();
    $(document).off('click', this._handleBlur).on('click', this._handleBlur);
    return $(document).off('keydown', this._handleKeypress).on('keydown', this._handleKeypress);
  },
  _handleKeypress: function(e) {
    var altKey, ctrlKey, keyCode, keyValue, which;
    altKey = e.altKey, ctrlKey = e.ctrlKey, keyCode = e.keyCode, which = e.which;
    if (altKey || ctrlKey) {
      return;
    }
    keyValue = keyCode != null ? keyCode : which;
    if (keyValue === KEYCODE_TAB) {
      return this.closeSearch();
    }
  },
  _handleReset: function(model, value, options) {
    if (!(options != null ? options.preventTrigger : void 0)) {
      return this.resetSearch();
    }
  },
  _handleSelection: function(model) {
    this.resetSearch();
    return this.onSelection(model);
  },
  _applyInitializeListeners: function() {
    return this.listenTo(this.collection, 'reset', this._handleReset);
  },
  _applyListeners: function() {
    var inputView, ref, resultsView;
    ref = this, inputView = ref.inputView, resultsView = ref.resultsView;
    this.listenTo(this.resultsView, 'selectionMade', this._handleSelection);
    resultsView.listenTo(inputView, 'typeEvent', resultsView.filterResults);
    resultsView.listenTo(inputView, 'keypressEvent', this._handleKeypress);
    return resultsView.listenTo(inputView, 'focusEvent', this._handleFocus);
  }
});

module.exports = TypeaheadSearch;

},{"../../templates":116,"./typeahead_input":112,"./typeahead_results_list":113}],115:[function(require,module,exports){
module.exports = (function() {
    var Hogan = require('hogan.js');
    var templates = {};
    templates['badge'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<a href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <div data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("\" class=\"refinement-badge");if(t.s(t.f("selected",c,p,1),c,p,0,91,117,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" refinement-badge-selected");});c.pop();}t.b("\">");t.b("\n" + i);t.b(t.rp("<radio0",c,p,"    "));t.b("    <label for=\"ref-ui-radio-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("      <span class=\"c-txt-black ");if(t.s(t.f("selected",c,p,1),c,p,0,236,248,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("ch-txt-black");});c.pop();}if(!t.s(t.f("selected",c,p,1),c,p,1,0,0,"")){t.b("ch-txt-ntc");};t.b(" refinement-badge-name\">");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      <span class=\"c-txt-gray-dk refinement-badge-count\">(");t.b(t.v(t.f("count",c,p,0)));t.b(")</span>");t.b("\n" + i);t.b("    </label>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</a>");t.b("\n");return t.fl(); },partials: {"<radio0":{name:"radio", partials: {}, subs: {  }}}, subs: {  }});
    templates['badges'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("showRefinementBox",c,p,1),c,p,0,24,596,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <h4>");t.b(t.v(t.f("title",c,p,0)));if(t.s(t.f("showCollapseControl",c,p,1),c,p,0,68,268,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" <span data-bhw=\"collapse_filter_");t.b(t.v(t.f("id",c,p,0)));t.b("\" class=\"toggle-refinements ");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,156,177,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("icon-arrow-down-large");});c.pop();}if(!t.s(t.f("collapseFilter",c,p,1),c,p,1,0,0,"")){t.b("icon-arrow-up-large");};t.b("\"></span>");});c.pop();}t.b("</h4>");t.b("\n" + i);t.b("  <div class=\"refinement-badges");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,352,362,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" collapsed");});c.pop();}t.b("\">");t.b("\n" + i);t.b("    <div data-bhc=\"");t.b(t.v(t.f("id",c,p,0)));t.b(":all\" class=\"refinement-badges-clear\"></div>");t.b("\n" + i);t.b("    <div class=\"refinement-badges-list\">");t.b("\n" + i);if(t.s(t.f("refinementData",c,p,1),c,p,0,526,554,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<badge0",c,p,"        "));});c.pop();}t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<badge0":{name:"badge", partials: {}, subs: {  }}}, subs: {  }});
    templates['breadcrumb'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<a class=\"grui-breadcrumb-friendly-name\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhc=\"breadcrumbPill:");t.b(t.v(t.f("id",c,p,0)));t.b("\" href=\"");if(t.s(t.f("url",c,p,1),c,p,0,107,114,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.v(t.f("url",c,p,0)));});c.pop();}if(!t.s(t.f("url",c,p,1),c,p,1,0,0,"")){t.b("#");};t.b("\">");t.b("\n" + i);if(!t.s(t.f("friendlyNameHtml",c,p,1),c,p,1,0,0,"")){t.b("    ");t.b(t.v(t.f("friendlyNameShort",c,p,0)));t.b("\n" + i);};if(t.s(t.f("friendlyNameHtml",c,p,1),c,p,0,253,285,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    ");t.b(t.t(t.f("friendlyNameHtml",c,p,0)));t.b("\n" + i);});c.pop();}t.b("</a>");t.b("\n" + i);t.b("<span class=\"grui-breadcrumb-close-btn icon-x\"></span>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['breadcrumb_filters'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"refinement-box\" data-bhw=\"refinementBreadcrumbFilters\">");t.b("\n" + i);t.b("  <h4>");t.b(t.v(t.f("breadcrumbTitle",c,p,0)));t.b("</h4>");t.b("\n" + i);t.b("  <div class=\"grui-breadcrumb-pills-container\">");t.b("\n" + i);t.b("    <span class=\"grui-breadcrumb-container\"></span><span class=\"grui-breadcrumb-reset-container\"></span>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['breadcrumb_query'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("query",c,p,1),c,p,0,12,196,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"grui-breadcrumb-pill c-bg-prim c-txt-white\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("    <span class=\"grui-breadcrumb-search-icon icon-magnifying-glass\"></span>");t.b("\n" + i);t.b(t.rp("<breadcrumb0",c,p,"    "));t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<breadcrumb0":{name:"breadcrumb", partials: {}, subs: {  }}}, subs: {  }});
    templates['checkbox'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<input type=\"checkbox\" ");if(t.s(t.f("selected",c,p,1),c,p,0,36,43,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("checked");});c.pop();}t.b(" id=\"ref-ui-checkbox-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['checkbox_reset'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<input type=\"checkbox\" ");if(!t.s(t.f("anySelected",c,p,1),c,p,1,0,0,"")){t.b("checked");};t.b(" id=\"ref-ui-checkbox-reset-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("<label for=\"ref-ui-checkbox-reset-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <a href=\"\">");t.b(t.v(t.f("all",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("</label>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['child_list'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("children",c,p,1),c,p,0,13,310,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <li class=\"refinement");if(t.s(t.f("isLastLevel",c,p,1),c,p,0,53,64,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" last-level");});c.pop();}if(t.s(t.f("simplifiedShow",c,p,1),c,p,0,99,115,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" simplified-show");});c.pop();}t.b("\" data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("\">");t.b("\n" + i);t.b(t.rp("<nested_item0",c,p,"    "));t.b("    <ul class=\"children-list");if(t.s(t.f("lowestSelected",c,p,1),c,p,0,230,246,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" lowest-selected");});c.pop();}t.b("\">");t.b("\n" + i);t.b(t.rp("<child_list1",c,p,"      "));t.b("    </ul>");t.b("\n" + i);t.b("  </li>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<nested_item0":{name:"nested_item", partials: {}, subs: {  }},"<child_list1":{name:"child_list", partials: {}, subs: {  }}}, subs: {  }});
    templates['clear_reset'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("anySelected",c,p,1),c,p,0,16,61,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <a class=\"refinement-clear\">");t.b(t.v(t.f("clear",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }});
    templates['datetime_filter'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("showRefinementBox",c,p,1),c,p,0,24,1431,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<div id=\"datetime-filter\" class=\"refinement-box");if(t.s(t.f("useSimplifiedCategory",c,p,1),c,p,0,98,118,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" simplified-category");});c.pop();}t.b("\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <h4>");t.b(t.v(t.f("title",c,p,0)));if(t.s(t.f("showCollapseControl",c,p,1),c,p,0,228,439,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" <span data-bhw=\"collapse_filter_");t.b(t.v(t.f("id",c,p,0)));t.b("\" class=\"toggle-refinements c-txt-prim ");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,327,348,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("icon-arrow-down-large");});c.pop();}if(!t.s(t.f("collapseFilter",c,p,1),c,p,1,0,0,"")){t.b("icon-arrow-up-large");};t.b("\"></span>");});c.pop();}t.b("</h4>");t.b("\n" + i);t.b("  <p id=\"datetime-explanation\">");t.b(t.t(t.f("explanation",c,p,0)));t.b("</p>");t.b("\n" + i);if(t.s(t.f("dates",c,p,1),c,p,0,538,957,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <ul class=\"dates-list\">");t.b("\n" + i);if(t.s(t.f("children",c,p,1),c,p,0,584,932,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li data-bhc=\"datetime-lhn:");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("        <input class=\"dates-radio-button\" ");if(t.s(t.f("selected",c,p,1),c,p,0,682,689,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("checked");});c.pop();}t.b(" type=\"radio\" id=\"dates-");t.b(t.v(t.f("id",c,p,0)));t.b("-button\" data-id=");t.b(t.v(t.f("id",c,p,0)));t.b(">");t.b("\n" + i);t.b("        <label class=\"dates-radio-label ");if(t.s(t.f("selected",c,p,1),c,p,0,810,827,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.v(t.f("selectedClass",c,p,0)));});c.pop();}t.b("\" id=\"dates-");t.b(t.v(t.f("id",c,p,0)));t.b("-label\" for=\"dates-");t.b(t.v(t.f("id",c,p,0)));t.b("-button\">");t.b(t.v(t.f("displayName",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("  </ul>");t.b("\n" + i);});c.pop();}t.b("  <hr>");t.b("\n" + i);if(t.s(t.f("times",c,p,1),c,p,0,991,1411,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <ul class=\"times-list\">");t.b("\n" + i);if(t.s(t.f("children",c,p,1),c,p,0,1037,1386,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li data-bhc=\"datetime-lhn:");t.b(t.v(t.f("id",c,p,0)));t.b("\" >");t.b("\n" + i);t.b("        <input class=\"times-radio-button\" ");if(t.s(t.f("selected",c,p,1),c,p,0,1136,1143,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("checked");});c.pop();}t.b(" type=\"radio\" id=\"times-");t.b(t.v(t.f("id",c,p,0)));t.b("-button\" data-id=");t.b(t.v(t.f("id",c,p,0)));t.b(">");t.b("\n" + i);t.b("        <label class=\"times-radio-label ");if(t.s(t.f("selected",c,p,1),c,p,0,1264,1281,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.v(t.f("selectedClass",c,p,0)));});c.pop();}t.b("\" id=\"times-");t.b(t.v(t.f("id",c,p,0)));t.b("-label\" for=\"times-");t.b(t.v(t.f("id",c,p,0)));t.b("-button\">");t.b(t.v(t.f("displayName",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("  </ul>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }});
    templates['link'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("friendlyName",c,p,1),c,p,0,18,336,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<li data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" class=\"sub-category-links child-refinement");if(t.s(t.f("selected",c,p,1),c,p,0,95,104,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" selected");});c.pop();}t.b("\" data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <a href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\">");t.b("\n" + i);t.b("    ");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("\n" + i);t.b("    ");if(t.s(t.f("count",c,p,1),c,p,0,199,243,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"deal-counts\">(");t.b(t.v(t.f("count",c,p,0)));t.b(")</span>");});c.pop();}t.b("\n" + i);t.b("    ");if(t.s(t.f("badges",c,p,1),c,p,0,269,311,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"badge-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</span>");});c.pop();}t.b("\n" + i);t.b("  </a>");t.b("\n" + i);t.b("</li>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }});
    templates['links_list'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"refinement-links\">");t.b("\n" + i);if(t.s(t.f("refinementData",c,p,1),c,p,0,54,588,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"refinement-box\">");t.b("\n" + i);t.b("    <h4>");t.b(t.v(t.f("friendlyName",c,p,0)));if(t.s(t.f("showCollapseControl",c,p,1),c,p,0,138,371,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" <span data-bhw=\"collapse_filter_");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("-list\" class=\"toggle-refinements c-txt-prim ");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,259,280,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("icon-arrow-down-large");});c.pop();}if(!t.s(t.f("collapseFilter",c,p,1),c,p,1,0,0,"")){t.b("icon-arrow-up-large");};t.b("\"></span>");});c.pop();}t.b("</h4>");t.b("\n" + i);t.b("    <ul id='");t.b(t.v(t.f("id",c,p,0)));t.b("-list' class=\"refinement-list");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,471,481,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" collapsed");});c.pop();}t.b("\">");t.b("\n" + i);if(t.s(t.f("children",c,p,1),c,p,0,524,551,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<link0",c,p,"        "));});c.pop();}t.b("    </ul>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n");return t.fl(); },partials: {"<link0":{name:"link", partials: {}, subs: {  }}}, subs: {  }});
    templates['main'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("queryFilterId",c,p,1),c,p,0,20,99,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div data-id=\"");t.b(t.v(t.f("queryFilterId",c,p,0)));t.b("\" data-bhw=\"queryFilterRefinement\">");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}if(t.s(t.f("showBreadcrumbFilter",c,p,1),c,p,0,147,193,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div id=\"grui-breadcrumb-container\"></div>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("showBreadcrumbFilter",c,p,1),c,p,1,0,0,"")){if(!t.s(t.f("hideReset",c,p,1),c,p,1,0,0,"")){t.b("    <div id='reset-all-container'>");t.b("\n" + i);t.b(t.rp("<reset_all0",c,p,"      "));t.b("    </div>");t.b("\n" + i);};};t.b("\n" + i);if(t.s(t.f("widgets",c,p,1),c,p,0,397,414,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<widget1",c,p,"  "));});c.pop();}return t.fl(); },partials: {"<reset_all0":{name:"reset_all", partials: {}, subs: {  }},"<widget1":{name:"widget", partials: {}, subs: {  }}}, subs: {  }});
    templates['modal_item'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<span class=\"refinement\">");t.b("\n" + i);if(t.s(t.f("hasCheckbox",c,p,1),c,p,0,46,69,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<checkbox0",c,p,"    "));});c.pop();}t.b("  <label title=\"");t.b(t.v(t.f("friendlyNameShort",c,p,0)));t.b("\">");t.b(t.v(t.f("friendlyNameShort",c,p,0)));t.b("\n" + i);t.b("    ");if(!t.s(t.f("hideCounts",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("count",c,p,1),c,p,0,178,222,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"deal-counts\">(");t.b(t.v(t.f("count",c,p,0)));t.b(")</span>");});c.pop();}};t.b("\n" + i);t.b("    ");if(t.s(t.f("badges",c,p,1),c,p,0,263,305,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"badge-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</span>");});c.pop();}t.b("\n" + i);t.b("  </label>");t.b("\n" + i);t.b("</span>");t.b("\n");return t.fl(); },partials: {"<checkbox0":{name:"checkbox", partials: {}, subs: {  }}}, subs: {  }});
    templates['nested_item'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<span data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b(t.rp("<nested_link0",c,p,"  "));t.b("</span>");t.b("\n");return t.fl(); },partials: {"<nested_link0":{name:"nested_link", partials: {}, subs: {  }}}, subs: {  }});
    templates['nested_link'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("friendlyNameShort",c,p,1),c,p,0,22,829,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"refinement-name");if(t.s(t.f("lowestSelected",c,p,1),c,p,0,70,79,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" selected");});c.pop();}if(!t.s(t.f("static",c,p,1),c,p,1,0,0,"")){t.b(" dynamic");};t.b("\">");t.b("\n" + i);if(t.s(t.f("hasCheckbox",c,p,1),c,p,0,151,174,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<checkbox0",c,p,"    "));});c.pop();}t.b("  <label class=\"name truncated");if(!t.s(t.f("lowestSelected",c,p,1),c,p,1,0,0,"")){if(!t.s(t.f("isLastButOneLevel",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("simplifiedShow",c,p,1),c,p,0,283,294,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" show-arrow");});c.pop();}};};t.b("\" for=\"ref-ui-checkbox-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);if(t.s(t.f("useSimplifiedCategory",c,p,1),c,p,0,418,520,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      ");if(!t.s(t.f("hasCheckbox",c,p,1),c,p,1,0,0,"")){t.b("<span class=\"icon-arrow-left-large c-txt-prim\"></span>");};t.b("\n" + i);});c.pop();}t.b("    <a href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\" ");if(t.s(t.f("noFollow",c,p,1),c,p,0,586,600,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("rel=\"nofollow\"");});c.pop();}t.b(">");t.b(t.v(t.f("friendlyNameShort",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("    ");if(!t.s(t.f("hideCounts",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("count",c,p,1),c,p,0,671,715,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"deal-counts\">(");t.b(t.v(t.f("count",c,p,0)));t.b(")</span>");});c.pop();}};t.b("\n" + i);t.b("    ");if(t.s(t.f("badges",c,p,1),c,p,0,756,798,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"badge-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</span>");});c.pop();}t.b("\n" + i);t.b("  </label>");t.b("\n" + i);t.b("</span>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<checkbox0":{name:"checkbox", partials: {}, subs: {  }}}, subs: {  }});
    templates['nested_links'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("showRefinementBox",c,p,1),c,p,0,24,1488,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<div class=\"refinement-box");if(t.s(t.f("useSimplifiedCategory",c,p,1),c,p,0,77,97,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" simplified-category");});c.pop();}t.b("\">");t.b("\n" + i);t.b("  <h4>");t.b(t.v(t.f("title",c,p,0)));if(t.s(t.f("showCollapseControl",c,p,1),c,p,0,167,378,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" <span data-bhw=\"collapse_filter_");t.b(t.v(t.f("id",c,p,0)));t.b("\" class=\"toggle-refinements c-txt-prim ");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,266,287,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("icon-arrow-down-large");});c.pop();}if(!t.s(t.f("collapseFilter",c,p,1),c,p,1,0,0,"")){t.b("icon-arrow-up-large");};t.b("\"></span>");});c.pop();}t.b("</h4>");t.b("\n");t.b("\n" + i);t.b("  <ul class=\"refinement-list");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,460,470,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" collapsed");});c.pop();}t.b("\">");t.b("\n" + i);if(t.s(t.f("showMoreSearch",c,p,1),c,p,0,519,601,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div data-bhw=\"lhnShowMoreSearch\" class=\"grui-show-more-search\"></div>");t.b("\n" + i);});c.pop();}if(t.s(t.f("multiselect",c,p,1),c,p,0,645,744,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <li class='refinement reset' data-bhc=\"");t.b(t.v(t.f("id",c,p,0)));t.b(":all\">");t.b("\n" + i);t.b(t.rp("<checkbox_reset0",c,p,"      "));t.b("    </li>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("refinementData",c,p,1),c,p,0,789,1433,"{{ }}")){t.rs(c,p,function(c,p,t){if(!t.s(t.f("multiselect",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("useSimplifiedCategory",c,p,1),c,p,0,849,1047,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <li class=\"refinement show-arrow\">");t.b("\n" + i);t.b("            <a href=\"");t.b(t.v(t.d("l1Category.url",c,p,0)));t.b("\"><span class=\"icon-arrow-left-large c-txt-prim\"></span> ");t.b(t.v(t.d("l1Category.friendlyName",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("          </li>");t.b("\n" + i);});c.pop();}};t.b("\n" + i);t.b("      <li class=\"refinement");if(t.s(t.f("useSimplifiedCategory",c,p,1),c,p,0,1153,1207,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("lowestSelected",c,p,1),c,p,0,1172,1188,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" has-l1-category");});c.pop();}});c.pop();}t.b("\" data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("\">");t.b("\n" + i);t.b(t.rp("<nested_item1",c,p,"        "));t.b("        <ul class=\"children-list");if(t.s(t.f("lowestSelected",c,p,1),c,p,0,1337,1353,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" lowest-selected");});c.pop();}t.b("\">");t.b("\n" + i);t.b(t.rp("<child_list2",c,p,"          "));t.b("        </ul>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("  </ul>");t.b("\n" + i);t.b(t.rp("<see_more3",c,p,"  "));t.b("</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<checkbox_reset0":{name:"checkbox_reset", partials: {}, subs: {  }},"<nested_item1":{name:"nested_item", partials: {}, subs: {  }},"<child_list2":{name:"child_list", partials: {}, subs: {  }},"<see_more3":{name:"see_more", partials: {}, subs: {  }}}, subs: {  }});
    templates['radio'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<input type=\"radio\" ");if(t.s(t.f("selected",c,p,1),c,p,0,33,40,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("checked");});c.pop();}t.b(" id=\"ref-ui-radio-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['radio_reset'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b(t.rp("<radio0",c,p,""));t.b("<label for=\"ref-ui-checkbox-reset-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <a class=\"c-txt-black ch-txt-ntc\" href=\"\">");t.b(t.v(t.f("all",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("</label>");t.b("\n");return t.fl(); },partials: {"<radio0":{name:"radio", partials: {}, subs: {  }}}, subs: {  }});
    templates['range_filter'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<h4 data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("_title\">");t.b(t.v(t.f("friendlyNameShort",c,p,0)));if(t.s(t.f("showCollapseControl",c,p,1),c,p,0,80,291,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" <span data-bhw=\"collapse_filter_");t.b(t.v(t.f("id",c,p,0)));t.b("\" class=\"toggle-refinements c-txt-prim ");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,179,200,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("icon-arrow-down-large");});c.pop();}if(!t.s(t.f("collapseFilter",c,p,1),c,p,1,0,0,"")){t.b("icon-arrow-up-large");};t.b("\"></span>");});c.pop();}t.b("</h4>");t.b("\n" + i);t.b("<div class=\"refinement-range");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,372,382,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" collapsed");});c.pop();}t.b("\">");t.b("\n" + i);t.b("  <div data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("_slider\" class=\"refinement-range-slider\"></div>");t.b("\n");t.b("\n" + i);t.b("  <div class=\"refinement-range-input-container\">");t.b("\n" + i);t.b("    <span class=\"refinement-range-input-unit\">");t.b(t.v(t.f("unit",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("    <div class=\"refinement-range-input refinement-range-minInput\">");t.b("\n" + i);t.b("      <input title=\"");t.b(t.v(t.f("friendlyNameShort",c,p,0)));t.b(" min\" data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("_minInput\" type=\"text\" value=\"");t.b(t.v(t.f("displayedMin",c,p,0)));t.b("\" aria-label=\"");t.b(t.v(t.f("priceSliderMinInput",c,p,0)));t.b("\" />");t.b("\n" + i);t.b("    </div>");t.b("\n");t.b("\n" + i);t.b("    <span class=\"refinement-range-input-range-text\">");t.b(t.v(t.f("toText",c,p,0)));t.b("</span>");t.b("\n");t.b("\n" + i);t.b("    <div class=\"refinement-range-input refinement-range-maxInput\">");t.b("\n" + i);t.b("      <input title=\"");t.b(t.v(t.f("friendlyNameShort",c,p,0)));t.b(" max\" data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("_maxInput\" type=\"text\" value=\"");t.b(t.v(t.f("displayedMax",c,p,0)));t.b("\" aria-label=\"");t.b(t.v(t.f("priceSliderMaxInput",c,p,0)));t.b("\" />");t.b("\n" + i);t.b("    </div>");t.b("\n");t.b("\n" + i);if(t.s(t.f("showPriceRangeButton",c,p,1),c,p,0,1168,1320,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"refinement-range-submit\">");t.b("\n" + i);t.b("        <a class=\"btn btn-small btn-range-submit\">");t.b("\n" + i);t.b("          ");t.b(t.v(t.f("applyText",c,p,0)));t.b("\n" + i);t.b("        </a>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);});c.pop();}t.b("  </div>");t.b("\n");t.b("\n" + i);t.b("  <div data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("_minError\" class=\"refinement-range-error-message\"></div>");t.b("\n" + i);t.b("  <div data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("_maxError\" class=\"refinement-range-error-message\"></div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['rating'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<a href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <div data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("\" class=\"refinement-rating");if(t.s(t.f("selected",c,p,1),c,p,0,92,119,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" refinement-rating-selected");});c.pop();}t.b("\">");t.b("\n" + i);t.b(t.rp("<radio0",c,p,"    "));t.b("    <label for=\"ref-ui-radio-");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b(t.rp("<rating_name1",c,p,"      "));t.b("      <span class=\"refinement-rating-count\">(");t.b(t.v(t.f("count",c,p,0)));t.b(")</span>");t.b("\n" + i);t.b("    </label>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</a>");t.b("\n");return t.fl(); },partials: {"<radio0":{name:"radio", partials: {}, subs: {  }},"<rating_name1":{name:"rating_name", partials: {}, subs: {  }}}, subs: {  }});
    templates['rating_name'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("iconData",c,p,1),c,p,0,15,119,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <span class=\"refinement-rating-icon");if(t.s(t.f("active",c,p,1),c,p,0,66,96,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" refinement-rating-icon-active");});c.pop();}t.b("\"></span>");t.b("\n" + i);});c.pop();}t.b("<span title=\"");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("\" class=\"refinement-rating-suffix\">");t.b(t.v(t.f("suffix",c,p,0)));t.b("</span>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['ratings'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("showRefinementBox",c,p,1),c,p,0,24,611,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <h4>");t.b(t.v(t.f("title",c,p,0)));if(t.s(t.f("showCollapseControl",c,p,1),c,p,0,68,279,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" <span data-bhw=\"collapse_filter_");t.b(t.v(t.f("id",c,p,0)));t.b("\" class=\"toggle-refinements c-txt-prim ");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,167,188,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("icon-arrow-down-large");});c.pop();}if(!t.s(t.f("collapseFilter",c,p,1),c,p,1,0,0,"")){t.b("icon-arrow-up-large");};t.b("\"></span>");});c.pop();}t.b("</h4>");t.b("\n" + i);t.b("  <div class=\"refinement-ratings");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,364,374,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" collapsed");});c.pop();}t.b("\">");t.b("\n" + i);t.b("    <div data-bhc=\"");t.b(t.v(t.f("id",c,p,0)));t.b(":all\" class=\"refinement-ratings-clear\"></div>");t.b("\n" + i);t.b("    <div class=\"refinement-ratings-list\">");t.b("\n" + i);if(t.s(t.f("refinementData",c,p,1),c,p,0,540,569,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<rating0",c,p,"        "));});c.pop();}t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<rating0":{name:"rating", partials: {}, subs: {  }}}, subs: {  }});
    templates['reset_all'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"clear-module\" data-bhw=\"refinementResetButton\" ");if(t.s(t.f("refinementsSelected",c,p,1),c,p,0,80,92,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("class=\"show\"");});c.pop();}t.b(">");t.b("\n" + i);t.b("  <div class=\"pill-reset\">");t.b("\n" + i);t.b("    <a href=\"#\">");t.b(t.v(t.f("resetAllText",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("    <span class=\"icon-x\"></span>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }});
    templates['reset_filters'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<ul class=\"pills\">");t.b("\n" + i);if(t.s(t.f("refinementData",c,p,1),c,p,0,40,264,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("selected",c,p,1),c,p,0,58,248,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li class=\"dismiss\">");t.b("\n" + i);t.b("        <a href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\" class=\"bubble-filter-term");if(!t.s(t.f("static",c,p,1),c,p,1,0,0,"")){t.b(" dynamic");};t.b("\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhc=\"");t.b(t.v(t.f("dataBhc",c,p,0)));t.b("\">\"");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("\"</a>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("</ul>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['see_more'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("showSeeMoreLink",c,p,1),c,p,0,22,141,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <a class=\"see-more ");if(t.s(t.f("collapseFilter",c,p,1),c,p,0,65,75,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" collapsed");});c.pop();}t.b("\" data-bhc=\"");t.b(t.v(t.f("id",c,p,0)));t.b(":showMore\">");t.b(t.v(t.f("seeMore",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }});
    templates['show_more_modal'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"modal refinement-modal");if(t.s(t.f("showMoreSearch",c,p,1),c,p,0,55,85,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" grui-show-more-search-visible");});c.pop();}t.b("\" ");if(t.s(t.f("modalId",c,p,1),c,p,0,122,138,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("id=\"");t.b(t.v(t.f("modalId",c,p,0)));t.b("\"");});c.pop();}t.b(">");t.b("\n" + i);t.b("  <div class=\"modal-body\">");t.b("\n" + i);t.b("    <div class=\"close-modal icon-x\"></div>");t.b("\n");t.b("\n" + i);t.b("    <div class=\"tabs-container\">");t.b("\n" + i);t.b("      <ul class=\"tabs\">");t.b("\n" + i);t.b("        <li class=\"");t.b(t.v(t.f("id",c,p,0)));t.b("-tab active\"><a>");t.b(t.v(t.f("title",c,p,0)));t.b("</a></li>");t.b("\n" + i);t.b("      </ul>");t.b("\n" + i);t.b("    </div>");t.b("\n");t.b("\n" + i);if(t.s(t.f("showMoreSearch",c,p,1),c,p,0,391,475,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div data-bhw=\"modalShowMoreSearch\" class=\"grui-show-more-search\"></div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);t.b("    <div class=\"checkbox-holder\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("Modal\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b("      <div class=\"spinner-overlay\">");t.b("\n" + i);t.b("        <div class=\"icon-g-loader\"></div>");t.b("\n" + i);t.b("      </div>");t.b("\n");t.b("\n" + i);t.b("      <ul class=\"checkbox-container\">");t.b("\n" + i);t.b("      </ul>");t.b("\n" + i);t.b("    </div>");t.b("\n");t.b("\n" + i);t.b("    <div class=\"modal-footer\">");t.b("\n" + i);t.b("      <button class=\"apply btn-small btn-cta\" data-bhc=\"show-more-modal:apply\">");t.b(t.v(t.f("apply",c,p,0)));t.b("</button>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['typeahead_search'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b(t.rp("<typeahead_search_input0",c,p,""));t.b("<div class=\"grui-show-more-search-results-container\">");t.b("\n" + i);t.b("  <div class=\"grui-show-more-search-results\" data-bhw=\"showMoreSearchResults\"></div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {"<typeahead_search_input0":{name:"typeahead_search_input", partials: {}, subs: {  }}}, subs: {  }});
    templates['typeahead_search_input'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"gig-field grui-show-more-search-input-container\">");t.b("\n" + i);t.b("  <input data-bhw=\"showMoreSearchInput\" class=\"grui-show-more-search-input\" type=\"text\" placeholder=\"");t.b(t.v(t.f("showMoreSearchPlaceholder",c,p,0)));t.b("\" aria-label=\"");t.b(t.v(t.f("showMoreSearchPlaceholder",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <span class=\"icon icon-magnifying-glass\">");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['typeahead_search_results_item'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div data-id='");t.b(t.v(t.f("id",c,p,0)));t.b("' data-bhc=\"resultItem:");t.b(t.v(t.f("id",c,p,0)));t.b("\" class='grui-show-more-search-result-item");if(t.s(t.f("isActive",c,p,1),c,p,0,106,113,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" active");});c.pop();}t.b("'>");t.b("\n" + i);t.b("  ");t.b(t.t(t.f("displayText",c,p,0)));if(t.s(t.f("count",c,p,1),c,p,0,162,174,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" (");t.b(t.v(t.f("count",c,p,0)));t.b(")");});c.pop();}t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['widget'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("resetFilters",c,p,1),c,p,0,19,173,"{{ }}")){t.rs(c,p,function(c,p,t){if(!t.s(t.f("isQueryFilter",c,p,1),c,p,1,0,0,"")){t.b("    <div id=\"reset-filters\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\">");t.b("\n" + i);t.b(t.rp("<reset_filters0",c,p,"      "));t.b("    </div>");t.b("\n" + i);};});c.pop();}t.b("\n" + i);if(t.s(t.f("rangeFilters",c,p,1),c,p,0,213,422,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);if(t.s(t.f("refinementData",c,p,1),c,p,0,312,393,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"refinement-box\">");t.b("\n" + i);t.b(t.rp("<range_filter1",c,p,"        "));t.b("      </div>");t.b("\n" + i);});c.pop();}t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("flatRefinementLinks",c,p,1),c,p,0,469,576,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b(t.rp("<links_list2",c,p,"    "));t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("nestedRefinementLinks",c,p,1),c,p,0,632,764,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"refinement-box\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b(t.rp("<nested_links3",c,p,"    "));t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("ratingFilters",c,p,1),c,p,0,814,941,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"refinement-box\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b(t.rp("<ratings4",c,p,"    "));t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("badgeFilters",c,p,1),c,p,0,982,1108,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"refinement-box\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b(t.rp("<badges5",c,p,"    "));t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("dateTimeFilters",c,p,1),c,p,0,1151,1286,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"refinement-box\" data-id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\" data-bh-viewport=\"respect\">");t.b("\n" + i);t.b(t.rp("<datetime_filter6",c,p,"    "));t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<reset_filters0":{name:"reset_filters", partials: {}, subs: {  }},"<range_filter1":{name:"range_filter", partials: {}, subs: {  }},"<links_list2":{name:"links_list", partials: {}, subs: {  }},"<nested_links3":{name:"nested_links", partials: {}, subs: {  }},"<ratings4":{name:"ratings", partials: {}, subs: {  }},"<badges5":{name:"badges", partials: {}, subs: {  }},"<datetime_filter6":{name:"datetime_filter", partials: {}, subs: {  }}}, subs: {  }});
    templates['featured_datetimes'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<p id=\"featured-datetime-explanation\" class=\"c-txt-gray-dk\">");t.b(t.t(t.f("explanation",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("<span class=\"featured-datetime-dates c-bdr-gray-lt\">");t.b("\n" + i);if(t.s(t.f("dates",c,p,1),c,p,0,149,598,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <ul>");t.b("\n" + i);if(t.s(t.f("children",c,p,1),c,p,0,180,571,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li data-bhc=\"featured-datetime:");t.b(t.v(t.f("id",c,p,0)));t.b("\" >");t.b("\n" + i);t.b("          <input class=\"dates-radio-button\" ");if(t.s(t.f("selected",c,p,1),c,p,0,288,295,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("checked");});c.pop();}t.b(" type=\"radio\" id=\"featured-dates-");t.b(t.v(t.f("id",c,p,0)));t.b("-button\" data-id=");t.b(t.v(t.f("id",c,p,0)));t.b(">");t.b("\n" + i);t.b("          <label class=\"dates-radio-label ");if(t.s(t.f("selected",c,p,1),c,p,0,427,444,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.v(t.f("selectedClass",c,p,0)));});c.pop();}t.b("\" id=\"featured-dates-");t.b(t.v(t.f("id",c,p,0)));t.b("-label\" for=\"featured-dates-");t.b(t.v(t.f("id",c,p,0)));t.b("-button\">");t.b(t.v(t.f("displayName",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("        </li>");t.b("\n" + i);});c.pop();}t.b("    </ul>");t.b("\n" + i);});c.pop();}t.b("</span>");t.b("\n");t.b("\n" + i);t.b("<span class=\"featured-datetime-times\">");t.b("\n" + i);if(t.s(t.f("times",c,p,1),c,p,0,673,1115,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <ul>");t.b("\n" + i);if(t.s(t.f("children",c,p,1),c,p,0,704,1087,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li data-bhc=\"featured-datetime:");t.b(t.v(t.f("id",c,p,0)));t.b("\" >");t.b("\n" + i);t.b("        <input class=\"times-radio-button\" ");if(t.s(t.f("selected",c,p,1),c,p,0,808,815,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("checked");});c.pop();}t.b(" type=\"radio\" id=\"featured-times-");t.b(t.v(t.f("id",c,p,0)));t.b("-button\" data-id=");t.b(t.v(t.f("id",c,p,0)));t.b(">");t.b("\n" + i);t.b("        <label class=\"times-radio-label ");if(t.s(t.f("selected",c,p,1),c,p,0,945,962,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.v(t.f("selectedClass",c,p,0)));});c.pop();}t.b("\" id=\"featured-times-");t.b(t.v(t.f("id",c,p,0)));t.b("-label\" for=\"featured-times-");t.b(t.v(t.f("id",c,p,0)));t.b("-button\">");t.b(t.v(t.f("displayName",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("    </ul>");t.b("\n" + i);});c.pop();}t.b("</span>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['featured_main'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("widgets",c,p,1),c,p,0,12,38,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.rp("<featured_widget0",c,p,"  "));});c.pop();}t.b(t.rp("<featured_reset_all1",c,p,""));return t.fl(); },partials: {"<featured_widget0":{name:"featured_widget", partials: {}, subs: {  }},"<featured_reset_all1":{name:"featured_reset_all", partials: {}, subs: {  }}}, subs: {  }});
    templates['featured_nested_links'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<ul class=\"featured-tooltip-ul\">");t.b("\n" + i);if(t.s(t.f("children",c,p,1),c,p,0,50,497,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <li data-bhc=\"featured-");t.b(t.v(t.f("collection_id",c,p,0)));t.b(":");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("      <input class=\"");t.b(t.v(t.f("collection_id",c,p,0)));t.b("-checkbox-button\" ");if(t.s(t.f("selected",c,p,1),c,p,0,173,180,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("checked");});c.pop();}t.b("\n" + i);t.b("              type=\"checkbox\" id=\"featured-");t.b(t.v(t.f("collection_id",c,p,0)));t.b("-");t.b(t.v(t.f("id",c,p,0)));t.b("-button\" data-id=");t.b(t.v(t.f("id",c,p,0)));t.b(">");t.b("\n" + i);t.b("      <label class=\"");t.b(t.v(t.f("collection_id",c,p,0)));t.b("-checkbox-label");t.b("\n" + i);t.b("      ");if(t.s(t.f("selected",c,p,1),c,p,0,358,384,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.v(t.f("collection_id",c,p,0)));t.b("-selected");});c.pop();}t.b("\"");t.b("\n" + i);t.b("              for=\"featured-");t.b(t.v(t.f("collection_id",c,p,0)));t.b("-");t.b(t.v(t.f("id",c,p,0)));t.b("-button\">");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("    </li>");t.b("\n" + i);});c.pop();}t.b("</ul>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['featured_reset_all'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"featured-reset-box\">");t.b("\n" + i);t.b("  <a id=\"featured-reset-button\" href=\"#\" rel=\"nofollow\">");t.b(t.v(t.f("resetAllText",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['featured_sort'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<ul class=\"featured-tooltip-ul\">");t.b("\n" + i);if(t.s(t.f("children",c,p,1),c,p,0,50,437,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <li data-bhc=\"featured-sort:");t.b(t.v(t.f("id",c,p,0)));t.b("\" >");t.b("\n" + i);t.b("      <input class=\"sort-radio-button\" ");if(t.s(t.f("selectedInView",c,p,1),c,p,0,151,158,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("checked");});c.pop();}t.b(" type=\"radio\" id=\"featured-sort-");t.b(t.v(t.f("id",c,p,0)));t.b("-button\" data-id=");t.b(t.v(t.f("id",c,p,0)));t.b(">");t.b("\n" + i);t.b("      <label class=\"sort-radio-label ");if(t.s(t.f("selectedInView",c,p,1),c,p,0,296,313,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.v(t.f("selectedClass",c,p,0)));});c.pop();}t.b("\" id=\"featured-sort-");t.b(t.v(t.f("id",c,p,0)));t.b("-label\" for=\"featured-sort-");t.b(t.v(t.f("id",c,p,0)));t.b("-button\">");t.b(t.v(t.f("friendlyName",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("    </li>");t.b("\n" + i);});c.pop();}t.b("</ul>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    templates['featured_widget'] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id = \"featured-");t.b(t.v(t.f("id",c,p,0)));t.b("-box\" class=\"featured-filter-box c-txt-gray-dk c-bdr-gray-lt ch-bdr-gray-dk\"");t.b("\n" + i);t.b("  data-id=\"featured-");t.b(t.v(t.f("id",c,p,0)));t.b("\" data-bhw=\"featured-");t.b(t.v(t.f("dataBhw",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <span data-trigger-event=\"open-featured-");t.b(t.v(t.f("id",c,p,0)));t.b("\"");t.b("\n" + i);t.b("    data-tooltip-id=\"featured-");t.b(t.v(t.f("id",c,p,0)));t.b("-tooltip\" data-position=\"bottom\" class=\"featured-title c-txt-gray\">");t.b(t.v(t.f("title",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("  <span id = \"featured-");t.b(t.v(t.f("id",c,p,0)));t.b("-arrow\" class=\"icon-arrow-down-large c-txt-prim\"></span>");t.b("\n" + i);t.b("  <div id=\"featured-");t.b(t.v(t.f("id",c,p,0)));t.b("-tooltip\" class=\"featured-filter-tooltip tooltip\" data-bhw=\"");t.b(t.v(t.f("id",c,p,0)));t.b("-tooltip\">");t.b("\n" + i);t.b("    <div class=\"indicator\"></div>");t.b("\n" + i);t.b("    <div class=\"tooltip-content\" id=\"featured-");t.b(t.v(t.f("id",c,p,0)));t.b("-tooltip-content\"></div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
    return templates;
})();
},{"hogan.js":119}],116:[function(require,module,exports){
var localTemplates;

localTemplates = require('../lib/localTemplates');

module.exports = localTemplates;

},{"../lib/localTemplates":115}],117:[function(require,module,exports){
module.exports={"en":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"Go","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"}}},"de_DE":{"modules":{"refinements":{"afternoon_evening":"Nachmittag und Abend","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Alle","all_dates":"Alle Termine","all_party_sizes":"Alle Gruppengrößen","all_times":"Alle Zeiten","apply":"Anwenden","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} muss {{comparison}} sein als {{otherBound}}","error_nan_input":"Bitte gültige/-s/-n {{input}} eingeben","error_oob_input":"{{bound}} ist {{unit}}{{value}}","go":"Anwenden","morning":"Morgen","party_size_count":{"one":"{{count}} Person","other":"{{count}} Personen"},"party_size_prompt":"Wie viele Personen?","price_slider":{"max_input":"Preisspanne Maximum Eingabe","min_input":"Preisspanne Minimum Eingabe"},"reset":"Reset","reset_all":"Alle zurücksetzen","see_more":"Weitere anzeigen","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"bis"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"·","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"EUR"}},"es_ES":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","go":"Ir","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","price_slider":{"max_input":"Añade rango de precio máximo","min_input":"Añade rango de precio mínimo"},"reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"a"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"EUR"}},"fr_FR":{"modules":{"refinements":{"afternoon_evening":"Après-midi & Soirée","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Tout","all_dates":"Toutes les dates","all_party_sizes":"Tout sélectionner","all_times":"Toutes les heures","apply":"Appliquer","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} doit être {{comparison}} au {{otherBound}}","error_nan_input":"Merci de renseigner un {{input}} valide","error_oob_input":"{{bound}} est de {{unit}}{{value}}","go":"Go","morning":"Matin","party_size_count":{"one":"{{count}} Personne","other":"{{count}} Personnes"},"party_size_prompt":"Combien de personne(s) ?","price_slider":{"max_input":"Prix maximum","min_input":"Prix minimum"},"reset":"Reset","reset_all":"Supprimer les filtres","see_more":"Afficher plus","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"à"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"EUR"}},"it_IT":{"modules":{"refinements":{"afternoon_evening":"Pomeriggio e sera","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Tutti","all_dates":"Tutte le date","all_party_sizes":"Tutti i gruppi","all_times":"Qualsiasi orario","apply":"Applica","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} deve essere {{comparison}} di {{otherBound}}","error_nan_input":"Per favore inserisci un {{input}} valido","error_oob_input":"{{bound}} è {{unit}}{{value}}","go":"Vai","morning":"Mattino","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"Quante persone?","price_slider":{"max_input":"Prezzo massimo","min_input":"Prezzo minimo"},"reset":"Reset","reset_all":"Cancella tutti","see_more":"Vedi più","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"a"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00","percent":"#,##0%"},"defaultCurrency":"EUR"}},"iw_IL":{"modules":{"refinements":{"afternoon_evening":"אחה\"צ & ערב","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"הכל ","all_dates":"All Dates","all_party_sizes":"כל המידות","all_times":"All Times","apply":"הרשם","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}}  חייב להיות בין {{comparison}} ל  {{otherBound}}","error_nan_input":"אנא הזן  {{input}} תקין","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"המשך","morning":"בוקר","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"כמה אנשים?","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"התחל ","see_more":"ראה עוד ","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"‎+","minusSign":"‎-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"ILS"}},"nl_NL":{"modules":{"refinements":{"afternoon_evening":"Middag & avond","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Alle","all_dates":"Alle data","all_party_sizes":"Alle groepsgroottes ","all_times":"Alle tijden","apply":"Toepassen","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} moet {{comparison}} zijn dan {{otherBound}}","error_nan_input":"Voer een geldige {{input}} in","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"Go","morning":"Ochtend","party_size_count":{"one":"{{count}} persoon","other":"{{count}} personen"},"party_size_prompt":"Hoeveel mensen?","price_slider":{"max_input":"Prijsbereik - max.","min_input":"Prijsbereik - min."},"reset":"Reset","reset_all":"Herstel","see_more":"Meer zien","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"tot"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.00;¤ #,##0.00-","percent":"#,##0%"},"defaultCurrency":"EUR"}},"pl_PL":{"modules":{"refinements":{"afternoon_evening":"Popołudnie i wieczór","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Wszystko","all_dates":"Wszystkie daty","all_party_sizes":"Wszystkie rodzaje","all_times":"Cały czas","apply":"Zgłoś się","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} musi być {{comparison}} niż {{otherBound}}","error_nan_input":"Wprowadź prawidłowy {{input}}","error_oob_input":"{{bound}} jest {{unit}}{{value}}","go":"Użyj","morning":"Rano","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"Ile osób?","price_slider":{"max_input":"Maks. cena","min_input":"Min. cena"},"reset":"Reset","reset_all":"Resetuj wszystko","see_more":"Zobacz więcej","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"do"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.## ¤;(#,##0.## ¤)","percent":"#,##0%"},"defaultCurrency":"PLN"}},"ar_AE":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"Go","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"‎+","minusSign":"‎-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.##;¤ #,##0.##-","percent":"#,##0%"},"defaultCurrency":"AED"}},"en_HK":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"Go","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"HKD"}},"en_US":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"},"title":"When"},"error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"Go","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"USD"}},"ja_JP":{"modules":{"refinements":{"afternoon_evening":"午後および夕方","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"すべて","all_dates":"全期日","all_party_sizes":"全パーティー規模","all_times":"常時","apply":"適用する","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"（選択バウンド）は、（他のバウンド）よりも（比較内容）でなければならない。","error_nan_input":"有効な（インプット）を入力して下さい。","error_oob_input":"（バウンド）は（数値）（まで）","go":"Go","morning":"午前","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"人数は？","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"すべてをリセット","see_more":"4日前githubをインポート","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"円","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.##¤","percent":"#,##0%"},"defaultCurrency":"JPY"}},"zh_HK":{"modules":{"refinements":{"afternoon_evening":"下午及晚上","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"全部","all_dates":"所有日子","all_party_sizes":"所有派對人數","all_times":"所有時間","apply":"應用","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} 須 {{comparison}} 過 {{otherBound}}","error_nan_input":"請輸入有效 {{input}}","error_oob_input":"{{bound}} 是 {{unit}}{{value}}","go":"Go","morning":"早上","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"多少人？","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"全部重置","see_more":"查看更多","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"HKD"}},"en_GB":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"},"title":"When"},"error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"Go","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"GBP"}},"es_MX":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","go":"Ir","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","price_slider":{"max_input":"Añade rango de precio máximo","min_input":"Añade rango de precio mínimo"},"reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"a"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"MXN"}},"pt_BR":{"modules":{"refinements":{"afternoon_evening":"Tarde e noite","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Tudo","all_dates":"Todas as datas","all_party_sizes":"Grupos de todos os tamanhos","all_times":"Todos os momentos","apply":"Aplicar","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} deve ser {{comparison}} que {{otherBound}}","error_nan_input":"Por favor insira um {{input}} válido","error_oob_input":"{{bound}} é {{unit}}{{value}}","go":"Go","morning":"Manhã","party_size_count":{"one":"{{count}} pessoa","other":"{{count}} pessoas"},"party_size_prompt":"Quantas pessoas?","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"Redefinir tudo","see_more":"Ver mais","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"a"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"BRL"}},"en_CA":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"},"title":"When"},"error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"Go","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"CAD"}},"fr_BE":{"modules":{"refinements":{"afternoon_evening":"Après-midi & Soirée","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Tout","all_dates":"Toutes les dates","all_party_sizes":"Tout sélectionner","all_times":"Toutes les heures","apply":"Appliquer","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} doit être {{comparison}} au {{otherBound}}","error_nan_input":"Merci de renseigner un {{input}} valide","error_oob_input":"{{bound}} est de {{unit}}{{value}}","go":"Go","morning":"Matin","party_size_count":{"one":"{{count}} Personne","other":"{{count}} Personnes"},"party_size_prompt":"Combien de personne(s) ?","price_slider":{"max_input":"Prix maximum","min_input":"Prix minimum"},"reset":"Reset","reset_all":"Supprimer les filtres","see_more":"Afficher plus","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"à"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"EUR"}},"fr_CA":{"modules":{"refinements":{"afternoon_evening":"Après-midi & Soirée","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Tout","all_dates":"Toutes les dates","all_party_sizes":"Tout sélectionner","all_times":"Toutes les heures","apply":"Appliquer","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} doit être {{comparison}} au {{otherBound}}","error_nan_input":"Merci de renseigner un {{input}} valide","error_oob_input":"{{bound}} est de {{unit}}{{value}}","go":"Go","morning":"Matin","party_size_count":{"one":"{{count}} Personne","other":"{{count}} Personnes"},"party_size_prompt":"Combien de personne(s) ?","price_slider":{"max_input":"Prix maximum","min_input":"Prix minimum"},"reset":"Reset","reset_all":"Supprimer les filtres","see_more":"Afficher plus","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"à"}},"number":{"symbols":{"decimal":",","group":" ","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0 %"},"defaultCurrency":"CAD"}},"nl_BE":{"modules":{"refinements":{"afternoon_evening":"Middag & avond","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Alle","all_dates":"Alle data","all_party_sizes":"Alle groepsgroottes ","all_times":"Alle tijden","apply":"Toepassen","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} moet {{comparison}} zijn dan {{otherBound}}","error_nan_input":"Voer een geldige {{input}} in","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"Go","morning":"Ochtend","party_size_count":{"one":"{{count}} persoon","other":"{{count}} personen"},"party_size_prompt":"Hoeveel mensen?","price_slider":{"max_input":"Prijsbereik - max.","min_input":"Prijsbereik - min."},"reset":"Reset","reset_all":"Herstel","see_more":"Meer zien","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"tot"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"EUR"}},"en_AE":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"},"title":"When"},"error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"Go","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"‎+","minusSign":"‎-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤ #,##0.##;¤ #,##0.##-","percent":"#,##0%"},"defaultCurrency":"AED"}},"en_AU":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"},"title":"When"},"error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"Go","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"AUD"}},"en_IE":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"},"title":"When"},"error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"Go","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"EUR"}},"en_NZ":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"},"title":"When"},"error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"Go","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"NZD"}},"en_SG":{"modules":{"refinements":{"afternoon_evening":"Afternoon & Evening","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"All","all_dates":"All Dates","all_party_sizes":"All Party Sizes","all_times":"All Times","apply":"Apply","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"},"title":"When"},"error_invalid_input":"{{selectedBound}} must be {{comparison}} than {{otherBound}}","error_nan_input":"Please enter a valid {{input}}","error_oob_input":"{{bound}} is {{unit}}{{value}}","go":"Go","morning":"Morning","party_size_count":{"one":"{{count}} Person","other":"{{count}} People"},"party_size_prompt":"How Many People?","price_slider":{"max_input":"Price Range Max Input","min_input":"Price Range Min Input"},"reset":"Reset","reset_all":"Reset All","see_more":"See More","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"to"}},"number":{"symbols":{"decimal":".","group":",","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"S$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"SGD"}},"es_AR":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","go":"Ir","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","price_slider":{"max_input":"Añade rango de precio máximo","min_input":"Añade rango de precio mínimo"},"reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"a"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"ARS"}},"es_CO":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","go":"Ir","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","price_slider":{"max_input":"Añade rango de precio máximo","min_input":"Añade rango de precio mínimo"},"reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"a"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.##","percent":"#,##0%"},"defaultCurrency":"COP"}},"es_PE":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","go":"Ir","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","price_slider":{"max_input":"Añade rango de precio máximo","min_input":"Añade rango de precio mínimo"},"reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"a"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫","PEN":"S/."}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.00","percent":"#,##0%"},"defaultCurrency":"PEN"}},"es_CL":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","go":"Ir","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","price_slider":{"max_input":"Añade rango de precio máximo","min_input":"Añade rango de precio mínimo"},"reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"a"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"¤#,##0.##;¤-#,##0.##","percent":"#,##0%"},"defaultCurrency":"CLP"}},"es_US":{"modules":{"refinements":{"afternoon_evening":"Mediodía y Tarde","ages":{"grade":"Grade Schoolers (5-7)","infants":"Infants (0-1)","teens":"Teens (12-18)","title":"Ages","toddlers":"Toddlers (2-4)","tweens":"Tweens (8-11)"},"all":"Todo","all_dates":"Todas las fechas","all_party_sizes":"Todos los tamaños de fiesta","all_times":"Todos los tiempos","apply":"Solicitar","clear":"Clear","datetime":{"short_days":{"anyday":"anyday","friday":"fri","monday":"mon","saturday":"sat","sunday":"sun","thursday":"thur","today":"today","tomorrow":"tomorrow","tuesday":"tue","wednesday":"wed"},"short_months":{"april":"Apr","august":"Aug","december":"Dec","february":"Feb","january":"Jan","july":"Jul","june":"Jun","march":"Mar","may":"May","november":"Nov","october":"Oct","september":"Sep"},"times":{"afternoon":"afternoon","anytime":"anytime","evening":"evening","morning":"morning","now":"now"}},"error_invalid_input":"{{selectedBound}} debe ser {{comparison}} que {{otherBoun}}","error_nan_input":"Por favor, introduce un {input}} valor","error_oob_input":"{{bound}} es {{unit}}{{value}}","go":"Ir","morning":"Mañana","party_size_count":{"one":"{{count}} Persona","other":"{{count}} Personas"},"party_size_prompt":"¿Cuántas personas?","price_slider":{"max_input":"Añade rango de precio máximo","min_input":"Añade rango de precio mínimo"},"reset":"Reset","reset_all":"Reiniciar","see_more":"Ver más","selected_filters":"Selected Filters","sort":{"title":"Sort By","title_prefix":"Sort-{{title}}"},"to":"a"}},"number":{"symbols":{"decimal":",","group":".","list":";","percentSign":"%","plusSign":"+","minusSign":"-","exponential":"E","superscriptingExponent":"×","perMille":"‰","infinity":"∞","nan":"NaN","currency":{"EUR":"€","XCD":"EC$","ARS":"$","USD":"$","AUD":"A$","BBD":"$","BDT":"৳","XOF":"CFA","BMD":"$","BND":"$","BRL":"R$","BSD":"$","BYR":"р.","BZD":"$","CAD":"C$","XAF":"FCFA","NZD":"NZ$","CLP":"$","CNY":"CN¥","COP":"$","CRC":"₡","CUP":"$","DOP":"$","FJD":"$","GBP":"£","GHS":"₵","GIP":"£","GYD":"$","HKD":"HK$","ILS":"₪","INR":"₹","JMD":"$","JPY":"¥","KHR":"៛","KRW":"₩","KYD":"$","KZT":"₸","LAK":"₭","LRD":"$","MNT":"₮","MXN":"MX$","NAD":"$","XPF":"CFPF","NGN":"₦","PHP":"₱","PLN":"zł","PYG":"₲","SBD":"$","SGD":"$","SRD":"$","SSP":"£","THB":"฿","TRY":"₺","TTD":"$","TWD":"NT$","UAH":"₴","UYU":"$","VND":"₫"}},"formats":{"scientific":"#E0","decimal":"#,##0.###","currency":"#,##0.00 ¤","percent":"#,##0%"},"defaultCurrency":"USD"}}}
},{}],118:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],119:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = require('./compiler');
Hogan.Template = require('./template').Template;
Hogan.template = Hogan.Template;
module.exports = Hogan;

},{"./compiler":118,"./template":120}],120:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],121:[function(require,module,exports){
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

},{}],122:[function(require,module,exports){
module.exports = require('./lib');

},{"./lib":123}],123:[function(require,module,exports){
// Load modules

var Stringify = require('./stringify');
var Parse = require('./parse');


// Declare internals

var internals = {};


module.exports = {
    stringify: Stringify,
    parse: Parse
};

},{"./parse":124,"./stringify":125}],124:[function(require,module,exports){
// Load modules

var Utils = require('./utils');


// Declare internals

var internals = {
    depth: 5,
    arrayLimit: 20,
    parametersLimit: 1000
};


internals.parseValues = function (str) {

    var obj = {};
    var parts = str.split('&').slice(0, internals.parametersLimit);

    for (var i = 0, il = parts.length; i < il; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        if (pos === -1) {
            obj[Utils.decode(part)] = '';
        }
        else {
            var key = Utils.decode(part.slice(0, pos));
            var val = Utils.decode(part.slice(pos + 1));

            if (!obj[key]) {
                obj[key] = val;
            }
            else {
                obj[key] = [].concat(obj[key]).concat(val);
            }
        }
    }

    return obj;
};


internals.parseObject = function (chain, val) {

    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj = {};
    if (root === '[]') {
        obj = [];
        obj = obj.concat(internals.parseObject(chain, val));
    }
    else {
        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
        var index = parseInt(cleanRoot, 10);
        if (!isNaN(index) &&
            root !== cleanRoot &&
            index <= internals.arrayLimit) {

            obj = [];
            obj[index] = internals.parseObject(chain, val);
        }
        else {
            obj[cleanRoot] = internals.parseObject(chain, val);
        }
    }

    return obj;
};


internals.parseKeys = function (key, val, depth) {

    if (!key) {
        return;
    }

    depth = typeof depth === 'undefined' ? internals.depth : depth;

    // The regex chunks

    var parent = /^([^\[\]]*)/;
    var child = /(\[[^\[\]]*\])/g;

    // Get the parent

    var segment = parent.exec(key);

    // Don't allow them to overwrite object prototype properties

    if (Object.prototype.hasOwnProperty(segment[1])) {
        return;
    }

    // Stash the parent if it exists

    var keys = [];
    if (segment[1]) {
        keys.push(segment[1]);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < depth) {

        ++i;
        if (!Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
            keys.push(segment[1]);
        }
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return internals.parseObject(keys, val);
};


module.exports = function (str, depth) {

    if (str === '' ||
        str === null ||
        typeof str === 'undefined') {

        return {};
    }

    var tempObj = typeof str === 'string' ? internals.parseValues(str) : Utils.clone(str);
    var obj = {};

    // Iterate over the keys and setup the new object

    for (var key in tempObj) {
        if (tempObj.hasOwnProperty(key)) {
            var newObj = internals.parseKeys(key, tempObj[key], depth);
            obj = Utils.merge(obj, newObj);
        }
    }

    return Utils.compact(obj);
};



},{"./utils":126}],125:[function(require,module,exports){
(function (Buffer){
// Load modules


// Declare internals

var internals = {};


internals.stringify = function (obj, prefix) {

    if (Buffer.isBuffer(obj)) {
        obj = obj.toString();
    }
    else if (obj instanceof Date) {
        obj = obj.toISOString();
    }
    else if (obj === null) {
        obj = '';
    }

    if (typeof obj === 'string' ||
        typeof obj === 'number' ||
        typeof obj === 'boolean') {

        return [encodeURIComponent(prefix) + '=' + encodeURIComponent(obj)];
    }

    var values = [];

    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']'));
        }
    }

    return values;
};


module.exports = function (obj) {

    var keys = [];

    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys = keys.concat(internals.stringify(obj[key], key));
        }
    }

    return keys.join('&');
};

}).call(this,{"isBuffer":require("../../is-buffer/index.js")})

},{"../../is-buffer/index.js":121}],126:[function(require,module,exports){
(function (Buffer){
// Load modules


// Declare internals

var internals = {};


exports.arrayToObject = function (source) {

    var obj = {};
    for (var i = 0, il = source.length; i < il; ++i) {
        if (source[i] !== undefined &&
            source[i] !== null) {

            obj[i] = source[i];
        }
    }

    return obj;
};


exports.clone = function (source) {

    if (typeof source !== 'object' ||
        source === null) {

        return source;
    }

    if (Buffer.isBuffer(source)) {
        return source.toString();
    }

    var obj = Array.isArray(source) ? [] : {};
    for (var i in source) {
        if (source.hasOwnProperty(i)) {
            obj[i] = exports.clone(source[i]);
        }
    }

    return obj;
};


exports.merge = function (target, source) {

    if (!source) {
        return target;
    }

    var obj = exports.clone(target);

    if (Array.isArray(source)) {
        for (var i = 0, il = source.length; i < il; ++i) {
            if (source[i] !== undefined) {
                obj[i] = source[i];
            }
        }

        return obj;
    }

    if (Array.isArray(obj)) {
        obj = exports.arrayToObject(obj);
    }

    var keys = Object.keys(source);
    for (var k = 0, kl = keys.length; k < kl; ++k) {
        var key = keys[k];
        var value = source[key];

        if (value &&
            typeof value === 'object') {

            if (!obj[key]) {
                obj[key] = exports.clone(value);
            }
            else {
                obj[key] = exports.merge(obj[key], value);
            }
        }
        else {
            obj[key] = value;
        }
    }

    return obj;
};


exports.decode = function (str) {

    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};


exports.compact = function (obj) {

    if (typeof obj !== 'object') {
        return obj;
    }

    var compacted = {};

    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (Array.isArray(obj[key])) {
                compacted[key] = [];

                for (var i = 0, l = obj[key].length; i < l; i++) {
                    if (obj[key].hasOwnProperty(i) &&
                        obj[key][i] !== null) {

                        compacted[key].push(obj[key][i]);
                    }
                }
            }
            else {
                compacted[key] = exports.compact(obj[key]);
            }
        }
    }

    return compacted;
};

}).call(this,{"isBuffer":require("../../is-buffer/index.js")})

},{"../../is-buffer/index.js":121}]},{},[4])

